/* tslint:disable */
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { Observable, Subject } from "rxjs/Rx";
import { Http } from "@angular/http";
import { Headers, RequestOptions } from "@angular/http";
import { DatePipe, registerLocaleData } from '@angular/common';
import { GenProvider } from "../gen/gen";
import { ISubscription, Subscription } from "rxjs/Subscription";
import { ValidaCampoProvider } from "providers/valida-campo/valida-campo";
import { CamelcasePipe } from "pipes/camelcase/camelcase";
import * as moment from 'moment'
import { take, takeUntil } from "rxjs/operators";
import {
  AngularFireUploadTask,
  AngularFireStorage
} from 'angularfire2/storage';
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

declare var google;
//declare var gapi: any;
@Injectable()
export class ServiceProvider {
  unSub$ = new Subject();
  vcardData: string = "";
  task: AngularFireUploadTask;
  downloadURL: any;
  public time: any;
  public time_resposta: number = 3; // minutos
  public url: any;
  public contatos = [];
  key: number = 0;
  intervalo: any;
  pergunta: any;
  bem_vindo = "";
  mensagem = "";
  pergunta_nome: any;
  isLog: boolean = false;
  lastNuber: any;
  isonLine: boolean = false;
  isPergunta: boolean = false;
  subscription: ISubscription;
  msgSubscription: ISubscription;
  url_pergunta_item: any;
  url_pergunta: any = 0;
  key_pergunta: any = 0;
  nivel = 0;
  key_child: any = 0;
  key_master: any = 0;
  uid: any = 0;
  msg_navegacao: any;
  menus: any;
  item: {};
  ctrl = "\n";
  escolha_opcao: any;
  enqueteOpcao: any;
  menuEnqueteOpcao: any;
  //  ctrl = ''+String.fromCharCode(92, 110) +''
  // rodape: string ="Para alterar seu nome digite: **perfil*. "+this.ctrl+"digite: **sair* para não receber mais nossas mensagens";
  rodape: string =
    "👤 Para alterar seus dados de perfil digite: **perfil*. " + this.ctrl;
  parametros: any;
  ischatBot: any = false;
  saudacao: string;
  myTimer: any;
  continua: boolean;
  atendimento: any;
  classificado: any;
  anunciar: any;
  classificados: any;
  publicidade: any;
  publicidade_rodape: {};
  publicidade_tipo: any;
  localizacao: any;
  data_nascimento: any;
  cancelar_denuncia: any;
  enquete: any;
  menu_enquete: any[];
  menuEnquete: any;
  imagemAnuncio: any;
  midiaMensagem: any;
  type_midia: any;
  galeria: any[];
  cancelar = this.ctrl + "Para cancelar, é só digitar *sair*";
  enqueteEncerrada: any;
  menu_enquete_encerrada: any[];
  postSubscription: any;
  isAcesso: number;
  pergunta_nome_midia: any;
  opcao_invalida_midia: any;
  bem_vindo_midia: any;
  isMonitora: any;
  autoPhone: any;
  menu_texto: any;
  menu_texto_ativo: any;
  mensagem_full: any;
  chatbot: any;
  atendimento_final: any;
  noticia: any[];
  bloqueado: any;
  cancela_mensagem: any;
  msg_denuncia: any;
  msg_mensagem: any;
  msg_recebida: any;
  primeiro_acesso_saudacao: any;
  natureza: any;
  msg_padrao_denuncia: any;
  invalida01_padrao_denuncia: any;
  invalida02_padrao_denuncia: any;
  invalida03_padrao_denuncia: any;
  msg_denuncia_acompanhar: any;
  sendSubscription: any;
  msg_sugestao: any;
  qtdOnline: number;
  informaProtocolo: boolean = false;
  denuncia: any[];
  denuncia_body: any[];
  mensagens: any[];
  mensagens_body: any[];
  ouvidoria: any[];
  ouvidoria_body: any[];
  chatLive: any[];
  chat_body: any[];
  mensagemCount: any;
  statusBot: boolean = false;
  isGravarPergunta: boolean = false;
  unSubstatus: any;
  subAbrir: any;
  getchatUpdate: any;
  chatUpdate: any;
  msg_midia: any;
  tokenFace: any;
  userIdFace: any;
  finaliza_atendimento: any;
  acaobot: any;
  texto_acao: any;
  opcao_acao: any;
  type_bem_vindo_midia: any;
  ponto: any[]
  chat_fila: any;
  unSubchat_fila: ISubscription;
  unSubPonto: ISubscription;
  dicas: any;
  intervalo_msg_recebida: any;
  primeiro_atendimento: any;
  opcao_autobot: any;
  opcao_enquete: any;
  enquete_final: any;
  texto_finaliza_enquete: any;
  filaAgente: any;
  finaliza_chatbot: any;
  time_inatividade: any;
  msgPendente: any;
  unSubPendente: any;
  chat: any[];
  puc: any;
  mostra_numero_menu: any;
  key_puc: any;
  nome_puc: any;
  postSubChatBot: any;
  msgMenu: string;
  unSub: Subscription[] = [];
  // user: gapi.auth2.GoogleUser;
  messages: any = [];
  listEmail: any = [];
  timeMail: any;
  options: any;
  titulo: any;
  rg: any;
  imageSrc: any;
  imageurl: SafeUrl | undefined;
  temp: any = [];
  usuarios: any = [];
  lotacao: any = [];
  itemCatalogo: any = [];
  pessoa: any = [];
  catalogo: any = [];
  subItem: any = [];
  menu_principal_lista: any;
  tipo: any;
  template: any = [];
  constructor(
    private domSanitizer: DomSanitizer,
    public http: Http,
    private genProvider: GenProvider,
    public validaCampoProvider: ValidaCampoProvider,
    public storage: AngularFireStorage,
  ) {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded  ;charset=iso-8859-1"
    });
    this.options = new RequestOptions({ headers: headers, method: "post" });
    this.ponto = [];
  }
  onDestroy() {
    this.isAcesso = 0;
    this.contatos = [];
    this.isPergunta = false;
    console.log("chatBot OffLine!! ", this.contatos);
    this.unSub.forEach(s => {
      s.unsubscribe();
    });
    clearInterval(this.timeMail);
    this.unSub$.next();
    this.unSub$.complete();
  }
  /*
  onTimeEmail() {
    console.log("AutoMail ativo")
    console.log(this.parametros.intervalo_email)
    //  let n = Math.floor(Math.random() * ((1000 * 60) * this.parametros.intervalo_email))
    this.timeMail = setInterval(() => {
      this.onLoadEmail();
    }, (this.parametros.intervalo_email * 1000));
  }
  */
  onStart(value) {
    if (value) {
      this.onParametro();
      setTimeout(() => {
        if (!this.isPergunta) {
          alert("Aguarde um momento, tentando carregar dados...");
        } else {
          this.isonLine = !this.isonLine;
          this.isAcesso = 0;
          this.onConfig();
          this.onFinalizaUsuario();
          setTimeout(() => {
            this.onLine();
            this.onGetLogin();
          }, 5000);
        }
      }, 3000);
    } else {
      this.onDestroy()
    }
  }
  onCreateAtendimento(data) {
    console.log(data)
    let filtro = [
      "Novo",
      "Em Atendimento",
      "Pendente"
    ]
    this.genProvider.onGetFilterOrderAll('dados/' + this.parametros.path + '/chat', "time", "key_solicitante", data.email, "==", "status", filtro, "in", 1000, 'desc').pipe(take(1)).subscribe(res => {
      let lista = JSON.parse(JSON.stringify(res));
      if (lista.length == 0) {
        this.genProvider.onIncrementKeyDateTime().then((keyValue: any) => {
          var dtInicio = new DatePipe("pt-BR").transform(data.time, "dd/MM/yyyy - HH:mm:ss"); //"20/06/2017 16:40:00";
          var dtAtual = new DatePipe("pt-BR").transform(Date.now(), "dd/MM/yyyy - HH:mm:ss"); //"20/06/2017 11:20:00";
          var ms = moment(dtAtual, "DD/MM/YYYY HH:mm:ss").diff(moment(dtInicio, "DD/MM/YYYY HH:mm:ss"));
          var d = moment.duration(ms);
          var tempo = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");
          let dados_ticket = {
            status_ticket: "Novo",
            image: "assets/icon/email.png",
            menu: "Solicitação de atendimento",
            protocolo: keyValue,
            compartilhado: false,
            copia_usuario: false,
            distribuicao: false,
            encaminhado: false,
            encerrado: false,
            status: "Novo",
            data_hora: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            ),
            key_puc: this.parametros.key_puc,
            nome_usuario: this.parametros.nome,
            //  key_usuario: this.parametros.key_usuario,
            key_solicitante: data.email,
            nome_solicitante: data.from,
            key_catalogo: '',
            nome_catalogo: '',
            key_subcatalogo: '',
            nome_subcatalogo: '',
            key_lotacao: '',
            nome_lotacao: '',
            canal: 'email',
            origem: 'email',
            conteudo: '',
            time: Date.now(),
            data_criacao: Date.now(),
            enviar_resposta_solicitante: true,
            id_canal: data.email,
            key_responsavel: null,
            nome_responsavel: null,
            observacao_interna: "",
            qtd_interacao: "",
            resposta: "",
            telefone: '0000000000000',
            type: 'chat',
            tipo_ticket: "Externo",
            titulo_ticket: data.subject,
            prioridade: 'Nenhuma',
            tramitacao: '0',
            novo: '1',
            value: data.snippet
          };
          this.genProvider.onSaveIncrementZeroDate("dados/" + this.parametros.path + "/ticket", dados_ticket, "ticket", 6).then(t => {
            let dados_body = {
              protocolo: keyValue,
              telefone: '0000000000000',
              key_usuario: this.parametros.key_usuario,
              nome_usuario: this.parametros.nome,
              key_lotacao: this.parametros.key_lotacao,
              nome_lotacao: this.parametros.nome_lotacao,
              status_ticket: '1',
              id_canal: data.email,
              type: 'chat',
              value: data.snippet,
              time: Date.now(),
              data_criacao: Date.now(),
              data_hora: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              )

            };
            // this.genProvider.onSaveObjeto('dados', this.parametros.path + '/ticket/' + t, 'ticket_body', dados_body);
            let atendimento = {
              status: "Novo",
              tipo: '',
              protocolo: keyValue + '-' + new DatePipe("pt-BR").transform(Date.now(), "mmss"),
              ticket: t,
              key_puc: this.parametros.key_puc,
              key_lotacao: this.parametros.key_lotacao,
              key_usuario: '000000',
              key_solicitante: data.email,
              nome_solicitante: data.from,
              canal: 'email',
              origem: 'email',
              id_canal: data.email,
              telefone: '0000000000000',
              data_criacao: Date.now(),
              time: Date.now(),
              tempo: tempo,
              menu: 'Solicitação por e-mail'
            };
            let dados_chat = {
              ticket: t,
              ...dados_ticket
            }
            this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/chat", dados_chat.protocolo, dados_chat).then(res => {
              let dados_body = {
                protocolo: keyValue,
                key_usuario: this.parametros.key_usuario,
                nome_usuario: this.parametros.nome,
                key_lotacao: this.parametros.key_lotacao,
                nome_lotacao: this.parametros.nome_lotacao,
                status_ticket: '1',
                telefone: '0000000000000',
                id_canal: data.email,
                type: 'chat',
                value: data.snippet,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto('dados', this.parametros.path + '/chat/' + keyValue, 'chat_body', dados_body);
              let email = {
                from: this.parametros.conta_email,
                to: data.email,
                subject: 'Resgistro de atendimento',
                text: this.parametros.email_resposta
              }
              this.onSendEmail(email);
              // this.onTrashEmail(data.id);
            })
            this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/atendimento", atendimento.protocolo, atendimento);

          })

        })
      } else {
        let dados = {
          key: lista[0].protocolo,
          status: 'Nova Mensagem'
        }
        this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chat', dados);
        let dados_chat = {
          protocolo: lista[0].protocolo,
          key_usuario: this.parametros.key_usuario,
          nome_usuario: this.parametros.nome,
          key_lotacao: this.parametros.key_lotacao,
          nome_lotacao: this.parametros.nome_lotacao,
          status_ticket: '1',
          telefone: '0000000000000',
          id_canal: data.email,
          type: 'chat',
          value: data.snippet,
          time: Date.now(),
          data_criacao: Date.now(),
          data_hora: new DatePipe("pt-BR").transform(
            Date.now(),
            "d, MMMM yyyy - HH:mm"
          )
        };
        this.genProvider.onSaveObjeto('dados', this.parametros.path + '/chat/' + lista[0].protocolo, 'chat_body', dados_chat);
        this.genProvider.onGetfilter('dados/' + this.parametros.path + '/ticket', "protocolo", lista[0].protocolo).pipe(take(1)).subscribe(res => {
          let lista2 = JSON.parse(JSON.stringify(res));
          console.log(lista2)
          let dados_ticket = {
            protocolo: lista2[0].protocolo,
            telefone: '0000000000000',
            id_canal: data.email,
            type: 'chat',
            value: data.snippet,
            time: Date.now(),
            data_criacao: Date.now(),
            data_hora: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            )
          };
          // this.genProvider.onSaveObjeto('dados', this.parametros.path + '/ticket/' + lista2[0].key, 'ticket_body', dados_ticket);
        })
        //   this.onTrashEmail(data.id);
      }
    });
  }
  //load de tabelas
  onLoadPuc() {
    this.unSub.push(this.genProvider
      .onGetFilterOrder("dados/" + this.parametros.path + "/puc", "descricao", "status", "Ativo")
      .subscribe(
        data => {
          let puc = JSON.parse(JSON.stringify(data));
          let i = 1;
          this.puc = puc.map(res => {
            res.numero = i
            i++
            return res;
          });
        },
        err => console.log(err)
      ));
  }
  onLoadRG() {
    this.unSub.push(this.genProvider
      .onGetAll("dados/" + this.parametros.path + "/rg", "nome")
      .subscribe(
        data => {
          let rg = JSON.parse(JSON.stringify(data));
          this.rg = rg.map(res => {
            res.nome = res.nome.toLowerCase();
            res.rg = res.rg.replace('-', '');
            return res;
          });
        },
        err => console.log(err)
      ));
  }
  onLoadEnquete() {
    this.unSub.push(this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/enquete",
        "key_enquete",
        "status",
        "ativo"
      )
      .subscribe(
        data => {
          this.enquete = JSON.parse(JSON.stringify(data));
          this.onLoadEnqueteOpcao();
        },
        err => console.log(err)
      ));
    this.unSub.push(this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/enquete",
        "key_enquete",
        "status",
        "encerrada"
      )
      .subscribe(
        data => {
          this.enqueteEncerrada = JSON.parse(JSON.stringify(data));
        },
        err => console.log(err)
      ));
  }
  onLoadEnqueteOpcao() {
    this.unSub.push(this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/enquete_item",
        "numero",
        "status",
        "ativo"
      )
      .subscribe(
        data => {
          this.enqueteOpcao = JSON.parse(JSON.stringify(data));
        },
        err => console.log(err)
      ));
  }
  onParametro() {
    this.parametros = this.genProvider.parametros;
    this.url_pergunta_item = "dados/" + this.parametros.path + "/item";
    this.url_pergunta = "dados/" + this.parametros.path + "/pergunta";
    this.url = this.parametros.servidor;
    this.time_resposta = this.genProvider.parametros.request;
    this.time_inatividade = this.genProvider.parametros.menu_automatico_tempo;
    this.tokenFace = this.parametros.tokenFace;
    this.userIdFace = this.parametros.userIdFace;
    this.intervalo_msg_recebida = this.parametros.intervalo_msg_recebida;
    this.filaAgente = this.parametros.filaAgente;
    this.key_puc = this.parametros.key_puc;
    this.mostra_numero_menu = this.parametros.mostra_numero_menu;
    this.msgMenu = "# - ◀Voltar uma opção" + this.ctrl + "0 - 📄Voltar ao menu principal" + this.ctrl + "Sair - 🤝Finalizar atendimento"
    this.onLoadMenu();
  }
  onLoadMenu() {
    // carrega opcoes de atendimento do bot
    this.unSub.push(this.genProvider
      .onGetfilter(this.url_pergunta, "status", "ativo")
      .subscribe(
        data => {
          let res = JSON.parse(JSON.stringify(data));
          if (res.length > 0) {
            this.onLoadItem(res[0].key);
            this.titulo = res[0].titulo
            this.pergunta = res[0];
            this.rodape = this.pergunta.rodape || "";
            this.key_pergunta = res[0].key;
            this.msg_denuncia_acompanhar = res[0].msg_denuncia_acompanhar;
            this.informaProtocolo = res[0].protocolo;
            this.invalida01_padrao_denuncia = res[0].invalida01_padrao_denuncia;
            this.invalida02_padrao_denuncia = res[0].invalida02_padrao_denuncia;
            this.invalida03_padrao_denuncia = res[0].invalida03_padrao_denuncia;
            this.finaliza_atendimento = res[0].finaliza_atendimento,
              this.finaliza_chatbot = res[0].finaliza_chatbot,
              this.acaobot = res[0].acaobot,
              this.texto_acao = res[0].texto_acao,
              this.opcao_acao = res[0].opcao_acao
            this.msg_padrao_denuncia = res[0].msg_padrao_denuncia;
            this.msg_recebida = res[0].msg_recebida;
            this.msg_mensagem = res[0].msg_mensagem;
            this.msg_denuncia = res[0].msg_denuncia;
            this.msg_sugestao = res[0].msg_sugestao;
            this.msg_midia = res[0].msg_midia;
            this.menu_texto = res[0].menu_texto;
            this.menu_texto_ativo = res[0].menu_texto_ativo;
            this.msg_navegacao = res[0].msg_navegacao;
            this.mensagem = res[0].mensagem;
            this.localizacao = res[0].localizacao;
            this.data_nascimento = res[0].data_nascimento;
            this.anunciar = res[0].anunciar;
            this.atendimento = res[0].atendimento;
            this.escolha_opcao = res[0].escolha_opcao;
            this.atendimento_final = res[0].atendimento_final;
            this.cancelar_denuncia =
              "Para cancelar a denúncia, digite e envie apenas o número *_0_*";
            this.bem_vindo = this.pergunta.bem_vindo.replace(
              "{{1}}",
              this.parametros.razao
            );
            this.pergunta_nome = this.pergunta.pergunta_nome.replace(
              "{{1}}",
              this.parametros.razao
            );
            this.pergunta_nome_midia = res[0].pergunta_nome_midia;
            this.primeiro_acesso_saudacao = res[0].primeiro_acesso_saudacao;
            this.opcao_invalida_midia = res[0].opcao_invalida_midia;
            this.cancela_mensagem = res[0].cancela_mensagem;
            this.bem_vindo_midia = res[0].bem_vindo_midia;
            this.type_bem_vindo_midia = res[0].type_bem_vindo_midia;
            this.primeiro_atendimento = res[0].primeiro_atendimento;
            this.opcao_autobot = res[0].opcao_autobot;
            this.enquete_final = res[0].enquete_final;
            this.opcao_enquete = res[0].opcao_enquete;
            this.texto_finaliza_enquete = res[0].texto_finaliza_enquete;
            this.menu_principal_lista = res[0].menu_principal_lista
            this.isPergunta = true;
          } else {
            this.isPergunta = false;
          }
        },
        err => console.log(err)
      ));

    this.unSub.push(this.genProvider.onGetfilter('dados/' + this.parametros.path + '/template', 'status', 'ativo').subscribe(res => {
      let data = JSON.parse(JSON.stringify(res));
      if (data.length > 0) {
        data.forEach(e => {
          let sub = this.genProvider.onGetAll('dados/' + this.parametros.path + '/template/' + e.key + '/template_body', 'numero').subscribe(tmp => {
            sub.unsubscribe();
            e.array = tmp
            this.template.push(e)
          })
        });
      }
    }));

  }
  onLoadChatbot() {
    this.unSub.push(this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/chatbot", "pergunta", "status", "ativo")
      .subscribe(
        data => {
          this.chatbot = JSON.parse(JSON.stringify(data));
        },
        err => console.log(err)
      ));
  }
  onLoadNatureza() {
    this.unSub.push(this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/natureza",
        "pergunta",
        "status",
        "ativo"
      )
      .subscribe(
        data => {
          this.natureza = JSON.parse(JSON.stringify(data));
        },
        err => console.log(err)
      ));
  }
  onLoadItem(key) {
    this.unSub.push(this.genProvider
      .onGetFilterOrder('dados/' + this.parametros.path + '/item', 'numero', 'key_pergunta', key)
      .subscribe(data => {
        this.nivel = 0;
        let temp = JSON.parse(JSON.stringify(data))
        this.menus = temp.filter(obj => {
          return obj.status == "ativo"
        });
        if (this.menus === 0) {
          return this.menus;
        } else {
          this.menus = this.menus.map((res) => {
            res.menu = res.nivel.toString() + res.key_master.toString() + res.key_child.toString();
            res.opcao = res.numero.toString() + res.key_child.toString();
            return res;
          });
        }
        let item = this.menus
        this.filtroNivel(item, this.nivel, null).then(res => {
          this.item = res
        })
      }));

  }
  onAtualizaUsuario() {
    let unSub = this.genProvider
      .onGetfilter("dados/" + this.parametros.path + "/contato", "online", "on")
      .subscribe(data => {
        this.contatos = JSON.parse(JSON.stringify(data));
        unSub.unsubscribe();
        this.onAtualizaMensagens()
      });
  }
  onAtualizaMensagens() {
    this.denuncia = [];
    this.denuncia_body = [];
    this.mensagens = [];
    this.mensagens_body = [];
    this.ouvidoria = [];
    this.ouvidoria_body = [];
    this.chat = [];
    this.chat_body = [];
    let contatos = this.contatos;
    contatos.forEach(element => {
      if (element.protocolo) {
        let unSubscribe = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/denuncia", "protocolo", element.protocolo).subscribe(data => {
          unSubscribe.unsubscribe();
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            delete dados["key"]
            this.denuncia.push(dados[0]);
          }
        });
        // mensagens
        let unSubscribe2 = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/mensagem", "protocolo", element.protocolo).subscribe(data => {
          unSubscribe2.unsubscribe();
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.mensagens.push(dados[0]);
          }
        });
        // ouvidoria
        let unSubscribe3 = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/ouvidoria", "protocolo", element.protocolo).subscribe(data => {
          unSubscribe3.unsubscribe();
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.ouvidoria.push(dados[0]);
          }
        });
        let unSubscribe4 = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/chat", "protocolo", element.protocolo).subscribe(data => {
          unSubscribe4.unsubscribe();
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            delete dados["key"]
            this.chat.push(dados[0]);
          }
        });

      }
    });
  }
  // fim

  //configuracao do sistema
  onConfig() {
    // configura e carrega todas as tabelas
    this.parametros = this.genProvider.parametros;
    this.onLoadPuc();
    this.onLoadEnquete();
    //  this.onPublicidade();
    this.onLoadChatbot();
    this.onLoadNatureza();
    this.onAtualizaUsuario();
    this.onLoadRG();
    this.genProvider
      .remove("whatsPost", this.parametros.telefone)
      .then(() => { });
    this.genProvider
      .remove("dados/" + this.parametros.path + "/abrirdenuncia", this.parametros.telefone)
      .then(() => { });
    this.genProvider
      .remove("dados/" + this.parametros.path + "/srvComando", this.parametros.telefone)
      .then(() => { });

    let now = new Date();

    if (now.getHours() >= 0 && now.getHours() < 12) {
      this.saudacao = "Bom dia";
    } else if (now.getHours() >= 12 && now.getHours() < 18) {
      this.saudacao = "Boa tarde";
    } else {
      this.saudacao = "Boa noite";
    }
  }
  onStartLog() {
    return new Promise(resolve => {
      this.isLog = !this.isLog;
      resolve(this.isLog);
    });
  }
  // fim

  //fila de espera
  onchat_fila() {
    this.unSub.push(this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/chat_fila", "time", "status", "Novo").subscribe(data => {
      this.chat_fila = JSON.parse(JSON.stringify(data));
      if ((this.chat_fila.length > 0) && (this.ponto.length > 0)) {
        this.onMontaFila()
      }
    }));
  }
  onMontaFila() {
    let c = 0;
    this.chat_fila.forEach(e => {
      if ((this.ponto.length > 0) && (this.filaAgente)) {
        let key = this.ponto[0].key
        let key_usuario = this.ponto[0].key_usuario;
        let nome_usuario = this.ponto[0].nome;

        const index = this.ponto.indexOf(this.ponto[0]);
        this.ponto.splice(index, 1);
        let dados = {
          key: key,
          data_hora: new DatePipe('pt-BR').transform(
            Date.now(),
            'd, MMMM yyyy - HH:mm:ss'
          ),
          protocolo: e.protocolo,
          atendimento_status: "Espera",
          canal: e.origem,
          atendimento_espera: Date.now()
        }
        this.genProvider.onSaveObjeto('dados', this.parametros.path, 'ponto', dados).then(s => {
          let dados_chat = {
            key: e.key,
            key_usuario: key_usuario,
            nome_usuario: nome_usuario,
            status: 'Espera',
            tempo_envio: Date.now(),
            data_envio: new DatePipe('pt-BR').transform(
              Date.now(),
              'd, MMMM yyyy - HH:mm'
            )
          }
          this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chat_fila', dados_chat)
          let formulario = {
            origem: e.origem,
            contato: e.id_canal,
            mensagem: "Você é o próximo a ser atendido, aguarde um momento."
            //   mensagem: "Voce será atendido por *"+this.ponto[0].nome +"*, aguarde um momento."
          };
          if (e.notifica_usuario) {
            this.enviarMsg(formulario);
          }
        })

      } else {
        c++
        if (this.dicas.length > 0) {
          let d = Math.floor(Math.random() * this.dicas.length);
          let msg_posicao = "Aguarde um momento, você ocupa a posição *" + c + "* da fila."
          let formulario = {
            origem: e.origem,
            contato: e.id_canal,
            mensagem: this.dicas[d].descricao + this.ctrl + this.ctrl + msg_posicao
          };
          if (e.notifica_usuario) {
            this.enviarMsg(formulario);
          }
        } else {
          let msg_posicao = "Aguarde um momento, você ocupa a posição *" + c + "* da fila."
          let formulario = {
            origem: e.origem,
            contato: e.id_canal,
            mensagem: msg_posicao
          };
          if (e.notifica_usuario) {
            this.enviarMsg(formulario);
          }
        }
      }
    });
    // this.onLoadPonto();
  }
  onLoadPonto() {
    this.unSub.push(this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/ponto", "atendimento_time", "atendimento_status", "Livre").subscribe(data => {
      this.ponto = JSON.parse(JSON.stringify(data));
      if ((this.ponto.length > 0) && (this.chat_fila.length > 0)) {
        this.onMontaFila();
      }
    }));
  }
  onLoadDicas() {
    this.unSub.push(this.genProvider.onGetAll('dados/' + this.parametros.path + '/dicas', 'descricao').subscribe(
      data => {
        this.dicas = JSON.parse(JSON.stringify(data));
      },
      err => console.log(err)
    ));
  }
  notificarAtendente(mensagem, contato) {
    let chat_fila = {
      status: "Novo",
      data_hora: new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm"
      ),
      origem: contato[0].origem,
      nome: contato[0].nome,
      telefone: contato[0].telefone,
      id_canal: contato[0].id_canal,
      tipo: contato[0].tipo,
      protocolo: contato[0].protocolo,
      menu: contato[0].menu,
      type: mensagem.type,
      time: Date.now(),
      data_criacao: Date.now(),
      hora_notificacao: '',
      tempo_espera: '',
      tempo_atendimento: '',
      tempo_ocioso: '',
      key_usuario: '',
      nome_usuario: '',
      grau_satisfacao: '',
      notifica_usuario: mensagem.notifica_usuario,
      value: mensagem.value || ''
    };
    contato[0].chatLive = true;
    this.atualizaContato(contato[0]);
    this.genProvider.onSaveIncrement("dados/" + this.parametros.path + "/chat_fila", chat_fila, "chat_fila");
  }
  notificarAtendenteAPI(mensagem) {
    let chat_fila = {
      status: "Novo",
      data_hora: new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm"
      ),
      origem: mensagem.origem,
      iddenuncia: mensagem.iddenuncia,
      nome: mensagem.nome,
      telefone: mensagem.telefone,
      id_canal: mensagem.telefone,
      tipo: mensagem.tipo,
      protocolo: mensagem.protocolo,
      menu: mensagem.menu,
      type: "API",
      time: Date.now(),
      data_criacao: Date.now(),
      hora_notificacao: '',
      tempo_espera: '',
      tempo_atendimento: '',
      tempo_ocioso: '',
      key_usuario: '',
      nome_usuario: '',
      grau_satisfacao: '',
      notifica_usuario: mensagem.notifica_usuario,
      value: mensagem.value
    };
    this.genProvider.onSaveIncrement("dados/" + this.parametros.path + "/chat_fila", chat_fila, "chat_fila");
  }
  // fim

  //contato e usuario
  salvarContato(data) {
    this.contatos.push(data);
  }
  excluirContato(contato) {
    let res = this.contatos.filter(obj => {
      return obj.id_canal == contato.id_canal;
    });
    if (res.length > 0) {
      const index = this.contatos.indexOf(res[0]);
      this.contatos.splice(index, 1);
      this.onContatoOff(contato);
    }
  }
  excluirContatoChat(contato) {
    console.log(contato)
    let res = this.contatos.filter(obj => {
      return obj.telefone == contato.telefone;
    });
    if (res.length > 0) {
      const index = this.contatos.indexOf(res[0]);
      this.contatos.splice(index, 1);
      this.onContatoOff(contato);
    }
  }
  onContatoOff(data) {
    let dados = {
      key: data.telefone,
      origem: '',
      id_canal: data.id_canal,
      telefone: data.telefone,
      protocolo: "",
      nome: data.nome || '',
      email: data.email || '',
      data_hora: new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm"
      ),
      nivel: 0,
      invalida: 0,
      acesso: 0,
      status: "Ativo",
      online: "off",
      tipo: "",
      time: Date.now(),
      menu: ''
    };
    this.onSalvarUsuario(dados);
  }
  excluirProtocolo(protocolo) {
    let res = this.contatos.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res.length > 0) {
      const index = this.contatos.indexOf(res[0]);
      this.contatos.splice(index, 1);
    }
  }
  atualizaContato(data) {
    if (data.nivel == 0) {
      delete data["menu"];
    }
    if (data.acesso == -1) {
      data.acesso = 0
      this.contatos.push(data);
      this.onSalvarUsuario(data);
    } else {
      let res = this.contatos.filter(obj => {
        return obj.id_canal == data.id_canal;
      });
      if (res.length > 0) {
        const index = this.contatos.indexOf(res[0]);
        this.contatos.splice(index, 1);
        this.contatos.push(data);
        this.onSalvarUsuario(data);
      } else {
        this.contatos.push(data);
        this.onSalvarUsuario(data);
      }
    }
  }
  onSalvarUsuario(data) {

    //   if (data.length > 0){
    delete data["key"];
    if ((data.menu_lista == undefined) || (!data.menu_lista)) {
      data.menu_lista = false;
    }
    //   delete data["menu_lista"];
    if (!data.id_canal) {
      data.id_canal = data.telefone
    }
    this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/contato", data.id_canal, data)
      .then(t => {
        if (t) {
          //            console.log("Contato atualiado com sucesso")
        } else {
          //          console.log("Contato atualizado")
        }
      })
      .catch(e => {
        console.log(data)
        console.log("erro ao atualizar contato")
      });

    //  }
  }
  pesquisaContato(data) {
    return new Promise(resolve => {
      let res = this.contatos.filter(obj => {
        return obj.telefone == data;
      });
      if (res.length > 0) {
        res[0].origem = data.origem
        res[0].id_canal = data.id_canal
        res[0].type = data.type
        resolve(res);
      } else {
        resolve(res);
      }
    });
  }
  validaContato(data) {
    return new Promise(resolve => {
      let res = this.contatos.filter(obj => {
        return obj.id_canal == data.author;
      });
      if (res.length > 0) {
        res[0].origem = data.origem
        res[0].id_canal = data.id_canal
        res[0].type = data.type
        resolve(res);
      } else {
        if (this.pergunta.primeira_saudacao) {
          let bem_vindo = this.pergunta.primeira_saudacao.replace("{{4}}", this.saudacao);
          let primeira_msg = bem_vindo.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(data.senderName))
          let formulario = {
            origem: data.origem,
            contato: data.id_canal,
            mensagem: primeira_msg
          };
          this.enviarMsg(formulario);
        }
        /*
        setTimeout(() => {
          if (this.pergunta.segunda_saudacao) {
            let formulario = {
              origem: data.origem,
              contato: data.id_canal,
              mensagem: this.pergunta.segunda_saudacao
            };
            this.enviarMsg(formulario);
          }
        }, 500);
*/
        this.genProvider.onIncrementKeyDateTime().then((keyValue: any) => {
          let temp = [];
          if (data.senderName == "") {
            data.senderName = "Nome não informado.";
          }
          let dados = {
            telefone: data.author,
            id_canal: data.author,
            data_hora: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            ),
            nivel: 0,
            //          protocolo: Date.now().toString(),
            protocolo: keyValue,
            key_pergunta: '',
            key_puc: '',
            nome_puc: '',
            invalida: 0,
            acesso: -1,
            status: "Ativo",
            online: "on",
            origem: data.origem,
            nome: data.senderName,
            image: data.image,
            coordenadas: "",
            localizacao: "",
            data_nascimento: "",
            tipo: "",
            time: Date.now(),
            data_criacao: Date.now(),
            bloqueado: false,
            type: data.type
          };
          temp.push(dados)
          resolve(temp)
        });
      }
    });
  }
  excluirContatoOmni(telefone) {
    let res = this.contatos.filter(obj => {
      return obj.telefone == telefone;
    });
    if (res.length > 0) {
      const index = this.contatos.indexOf(res[0]);
      this.contatos.splice(index, 1);
    }
  }
  // fim

  //inicio do atendimento
  private getBase64Image(img: HTMLImageElement) {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  public getBase64ImagePNGFromURL(url: string) {
    return new Promise(resolve => {
      const img = new Image();
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          resolve('data:image/png;base64,' + this.getBase64Image(img));
        };
        img.onerror = (err) => {
          resolve(err);
        };
      } else {
        resolve('data:image/png;base64,' + this.getBase64Image(img));
      }
    });
  }
  uploadFile(data) {
    return new Promise(resolve => {
      const filePath = `/chat/file_${new DatePipe('pt-BR').transform(
        new Date(),
        'yyyy-MM-dd-HH:mm:ss'
      )}.` + data.type;
      data.fullPath = filePath;
      this.task = this.storage.ref(filePath).putString(data.midia, 'data_url');
      let progress = this.task.percentageChanges();
      this.downloadURL = this.task.downloadURL().subscribe(res => {
        resolve(res)
      });
    });
  }

  onLine() {
    console.log("online")
    if (this.isPergunta) {
      console.log(this.parametros.telefone)
      this.genProvider.onGetKey("dados/" + this.parametros.path + "/srvComando", this.parametros.telefone).subscribe(data => {
        let result = JSON.parse(JSON.stringify(data));
        if (result) {
          if (result.comando == "finalizachat") {
            this.onFinalizachat(result)
          } else if (result.comando == "fila") {
            this.onMontaFila();
          } else if (result.comando == "loadPonto") {
            this.onLoadPonto()
          } else if (result.comando == "atualizaContato") {
            this.atualizaContato(result.contato);
          } else if (result.comando == "onAtualizaParametro") {
            this.onParametro();
          } else if (result.comando == "finalizaAtendimento") {
            console.log(result)
            this.excluirContatoChat(result);
          } else if (result.comando == "saveChat") {
            this.onSaveChat(result);
          } else if (result.comando == "sendEmail") {
            let email = {
              contato: result.contato,
              assunto: result.assunto,
              mensagem: result.mensagem
            }
            console.log(email)
            this.onSendEmail(email);
          }
        }
      });
      this.genProvider.removeCollection("wabaMessages/", this.parametros.instancia);
      this.genProvider.removeCollection("wabaStatus/", this.parametros.token_user);
      this.genProvider.removeCollection("chatBotPost/", this.parametros.telefone);
      this.genProvider.removeCollection("email_imap/", this.parametros.telefone);
      // inicio facebook
      if (this.userIdFace) {
        this.unSub.push(this.genProvider.onGetfilter("faceMessager/", "userId", this.userIdFace).subscribe(data => {
          //**   console.log("Receive facebook " + new DatePipe("pt-BR").transform(Date.now(), "mm:ss.SSS"));
          let now = new Date();
          let hora = new Date().getHours();
          if (now.getHours() >= 0 && now.getHours() < 12) {
            this.saudacao = "Bom dia";
          } else if (now.getHours() >= 12 && now.getHours() < 18) {
            this.saudacao = "Boa tarde";
          } else {
            this.saudacao = "Boa noite";
          }
          let res = JSON.parse(JSON.stringify(data));
          if (res.length > 0) {
            let type = "";
            let value = "";
            if (res[0].type == "location") {
              type = "location";
              value = res[0].lat.toString() + ";" + res[0].lng.toString();
            } else if (res[0].type) {
              value = res[0].midia;
              if (res[0].type == "audio") {
                type = "ppt";
              } else {
                type = res[0].type;
              }
            } else {
              value = res[0].message;
              res[0].type = "chat"
            }
            let msg = {
              origem: "messenger",
              id_canal: res[0].userId,
              author: res[0].sender,
              telefone: null,
              type: res[0].type,
              body: value,
              date: res[0].date,
              senderName: "Usuario Messenger",
              //  messageNumber: res[0].sender,
              image: "assets/icon/messenger.png"
            };
            if (this.isAcesso == 0) {
              this.isAcesso = 1;
            } else {
              this.onContato(msg);
            }

          } else {
            this.isAcesso = 1;
          }
        },
          err => {
            console.log("o erro ", err);
          }
        ));

      }
      // fim
      // whatsapp
      setTimeout(() => {
        this.genProvider.onGetKey("wabaMessages", this.parametros.instancia).pipe(takeUntil(this.unSub$)).subscribe((data:any) => {
          if (data.author) {
            let now = new Date();
            let hora = new Date().getHours();
            if (now.getHours() >= 0 && now.getHours() < 12) {
              this.saudacao = "Bom dia";
            } else if (now.getHours() >= 12 && now.getHours() < 18) {
              this.saudacao = "Boa tarde";
            } else {
              this.saudacao = "Boa noite";
            }
            let res = JSON.parse(JSON.stringify(data));
            var tmp = res.author;
            let telefone = tmp.replace(/\D/g, "");
            let type = res.type;
            let midia = "";
            let value = "";

            if (type == 'image' || type == 'video') {
              let type_temp = res.mime_type.split('/');
              this.onDownLoadMidia(res).then((result: any) => {
                let dados = {
                  midia: 'data:' + res.mime_type + ';base64, ' + result,
                  type: type_temp[1]
                }
                this.uploadFile(dados).then((file: any) => {
                  value = file
                  midia = file;
                  let msg = {
                    origem: "whatsapp",
                    id_canal: telefone,
                    author: telefone,
                    type: type_temp[1],
                    body: value,
                    date: Date.now(),
                    senderName: res.senderName,
                    image: "assets/icon/whatsapp.png",
                    data_time: new DatePipe("pt-BR").transform(Date.now(), "hh:mm:ss.SSS"),
                    data_time_waba: new DatePipe("pt-BR").transform(res.time, "hh:mm:ss.SSS")
                  };
                  this.onContato(msg);
                });
              })
            } else if (type == 'voice') {
              let tmp = res.mime_type.split('/');
              let type_temp = tmp[1].split(';');
              this.onDownLoadMidia(res[0]).then((result: any) => {
                let dados = {
                  midia: 'data:' + res.mime_type + ';base64, ' + result,
                  type: type_temp[0]
                }
                this.uploadFile(dados).then((file: any) => {
                  value = file
                  midia = file;
                  let msg = {
                    origem: "whatsapp",
                    id_canal: telefone,
                    author: telefone,
                    type: type_temp[0],
                    body: value,
                    date: Date.now(),
                    senderName: res.senderName,
                    image: "assets/icon/whatsapp.png",
                    data_time: new DatePipe("pt-BR").transform(Date.now(), "hh:mm:ss.SSS"),
                    data_time_waba: new DatePipe("pt-BR").transform(res.time, "hh:mm:ss.SSS")
                  };
                  this.onContato(msg);
                });
              })
            } else if (type == 'audio') {
              let tmp = res.mime_type.split('/');
              let type_temp = tmp[1].split(';');
              this.onDownLoadMidia(res).then((result: any) => {
                let dados = {
                  midia: 'data:' + res.mime_type + ';base64, ' + result,
                  type: type_temp[0]
                }
                this.uploadFile(dados).then((file: any) => {
                  value = file
                  midia = file;
                  let msg = {
                    origem: "whatsapp",
                    id_canal: telefone,
                    author: telefone,
                    type: type_temp[0],
                    body: value,
                    date: Date.now(),
                    senderName: res.senderName,
                    image: "assets/icon/whatsapp.png",
                    data_time: new DatePipe("pt-BR").transform(Date.now(), "hh:mm:ss.SSS"),
                    data_time_waba: new DatePipe("pt-BR").transform(res.time, "hh:mm:ss.SSS")
                  };
                  this.onContato(msg);
                });
              })
            } else if (type == 'document') {
              let type_temp = res.mime_type.split('/');
              this.onDownLoadMidia(res).then((result: any) => {
                let dados = {
                  midia: 'data:' + res.mime_type + ';charset=utf-8;base64, ' + result,
                  type: type_temp[1]
                }
                this.uploadFile(dados).then((file: any) => {
                  value = file
                  midia = file;
                  let msg = {
                    origem: "whatsapp",
                    id_canal: telefone,
                    author: telefone,
                    type: type_temp[1],
                    body: value,
                    date: Date.now(),
                    senderName: res.senderName,
                    image: "assets/icon/whatsapp.png",
                    data_time: new DatePipe("pt-BR").transform(Date.now(), "hh:mm:ss.SSS"),
                    data_time_waba: new DatePipe("pt-BR").transform(res.time, "hh:mm:ss.SSS")
                  };
                  this.onContato(msg);
                });
              })
            } else if (type == 'interactive') {
              midia = null;
              value = res.body;
              let msg = {
                origem: "whatsapp",
                id_canal: telefone,
                author: telefone,
                type: type,
                type_interactive: res.type_interactive,
                body: res.body,
                title: res.title,
                date: Date.now(),
                senderName: res.senderName,
                image: "assets/icon/whatsapp.png",
                data_time: new DatePipe("pt-BR").transform(Date.now(), "hh:mm:ss.SSS"),
                data_time_waba: new DatePipe("pt-BR").transform(res.time, "hh:mm:ss.SSS")
              };
              this.onContato(msg);
            } else {
              {
                midia = null;
                value = res.body;
                let msg = {
                  origem: "whatsapp",
                  id_canal: telefone,
                  author: telefone,
                  type: type,
                  body: res.body,
                  date: Date.now(),
                  senderName: res.senderName,
                  image: "assets/icon/whatsapp.png",
                  data_time: new DatePipe("pt-BR").transform(Date.now(), "hh:mm:ss.SSS"),
                  data_time_waba: new DatePipe("pt-BR").transform(res.time, "hh:mm:ss.SSS")
                };
                console.log(msg)
                this.onContato(msg);
              }
            }
          }

        },
          err => {
            console.log("o erro ", err);
          }
        );
      }, 2000);

      // fim
      // chatbot
      this.unSub.push(this.genProvider.onGetfilter("chatBotPost/", "instanceId", this.parametros.instancia).subscribe(data => {
        //**  console.log("Receive chatbot " + new DatePipe("pt-BR").transform(Date.now(), "mm:ss.SSS"));
        let now = new Date();
        let hora = new Date().getHours();
        if (now.getHours() >= 0 && now.getHours() < 12) {
          this.saudacao = "Bom dia";
        } else if (now.getHours() >= 12 && now.getHours() < 18) {
          this.saudacao = "Boa tarde";
        } else {
          this.saudacao = "Boa noite";
        }
        let res = JSON.parse(JSON.stringify(data));
        if (res.length > 0) {
          let midia = "";
          let value = "";
          let msg = {
            origem: "chatbot",
            id_canal: res[0].id_canal,
            author: res[0].author,
            type: res[0].type,
            body: res[0].body,
            date: res[0].time,
            email: res[0].email,
            senderName: res[0].senderName,
            image: "assets/icon/chatbot.png"
          };
          if (res[0].body.substring(0, 4) == "http") {
            midia = res[0].body;
            value = null;
          } else {
            midia = null;
            value = res[0].body;
          }
          if (this.isAcesso == 0) {
            this.isAcesso = 1;
          } else {
            this.onContato(msg);
          }
        } else {
          this.isAcesso = 1;
        }
      },
        err => {
          console.log("o erro ", err);
        }
      ));
      // fim
      // email
      setTimeout(() => {
        //        this.genProvider.onGetfilter("email_imap", "instanceId", this.parametros.telefone).pipe(takeUntil(this.unSub$)).subscribe(data => {
        this.genProvider.onGetAll("email_imap", "data").pipe(takeUntil(this.unSub$)).pipe(takeUntil(this.unSub$)).subscribe(data => {
          let res = JSON.parse(JSON.stringify(data));
          console.log(res)
          if (res.length > 0) {
            this.genProvider.onIncrementKeyDateTime().then((keyValue: any) => {
              let campo = res[0].fromaddress.split('<');
              let nome = campo[0];
              let email = campo[1].replace('>', '');
              // UTF-8
              let dados = {
                status: "Novo",
                protocolo: keyValue,
                image: "assets/icon/email.png",
                key_puc: this.parametros.key_puc,
                nome_puc: '',
                acesso: "0",
                origem: 'email',
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_registro: Date.now(),
                data_status: Date.now(),
                telefone: "0000000000",
                id_canal: email,
                menu: res[0].assunto,
                time: Date.now(),
                email: email,
                data_criacao: Date.now(),
                notifica_usuario: false,
                novo: '1',
                value: res[0].message,
                bloqueado: false,
                data_nascimento: "",
                nome: nome,
                nome_solicitante: nome,
                tipo: 'chat',
                type: 'chat',
              };
              this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/chat", dados.protocolo, dados);
              let dados_body = {
                protocolo: keyValue,
                //   messageNumber: 1,
                telefone: null,
                type: "chat",
                value: res[0].message,
                time: Date.now(), data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path + '/chat/' + keyValue, "chat_body", dados_body);
              if (res[0].files) {
                if (res[0].files.length > 0) {
                  // esmail com midia
                  res[0].files.forEach(e => {
                    let data = {
                      url: e.fullPath,
                      file: e.name
                    }
                    this.loadMidiaEmail(data).then((result: any) => {
                      let dados = {
                        midia: result.value,
                        type: result.type
                      }
                      this.uploadFile(dados).then((file: any) => {
                        let dados_body = {
                          protocolo: keyValue,
                          //   messageNumber: 1,
                          telefone: null,
                          type: dados.type,
                          value: file,
                          time: Date.now(), data_criacao: Date.now(),
                          data_hora: new DatePipe("pt-BR").transform(
                            Date.now(),
                            "d, MMMM yyyy - HH:mm"
                          )
                        };
                        this.genProvider.onSaveObjeto("dados", this.parametros.path + '/chat/' + keyValue, "chat_body", dados_body);
                      });
                    });
                  });
                }
              }

            });
          }
        },
          err => {
            console.log("o erro ", err);
          }
        );
      }, 2000);
      // fim
      // ticket
      setTimeout(() => {
        this.unSub.push(this.genProvider.onGetfilter("webHookTicket/", "instanceId", this.parametros.telefone).subscribe(data => {
          let res = JSON.parse(JSON.stringify(data));
          console.log(res)
          if (res.length > 0) {
            // dados ticket
            let dados = {
              key: 111111,
              time: Date.now(),
              //    qtd_interacao: parseInt(this.formulario.value.qtd_interacao) + 1,
              status: "Finalizado",
              ultima_interacao: Date.now(),
              fim: Date.now(),
              //  tempo: this.tempoAtendimento,
              integrado: '0',
              key_usuario: this.parametros.key_usuario,
              //  key_lotacao: this.key_lotacao,
            }

            //
            // dados ticket body
            let dados_body = {
              status: 'Enviada',
              key_usuario: this.parametros.key_usuario,
              //  nome_usuario: "Nome do usaurio",
              //  key_lotacao: //this.formulario.value.key_lotacao,
              //  nome_lotacao: //this.formulario.value.nome_lotacao,
              type: 'chat',
              //  ticket: ticket,
              //  value: "Lotação: " + this.formulario.value.nome_lotacao + this.service.ctrl + "Usuario: " + this.nomeUsuario + this.service.ctrl + this.service.ctrl + this.formulario.value.conteudoTexto,
              time: Date.now(),
              data_criacao: Date.now(),
              data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
              tipo: 'publica'
            }

            //
            /*
            {
              "instanceId": "558001231234",
              "token": "bWF0cml4d2hhdHNhcGk6V3lCdzZxLnU5cXtKKHxaNVQqS04=",
              "status":"Finalizado", // "Cancelado" "Devolvido"
              "ticket": "20220727.000001.000161",
              "nome_agente : "Reginaldo Esteves",
              "data_transacao": 1658948998091,
              "texto" : "finalizado com sucesso"

            }

            */

          }
        },
          err => {
            console.log("o erro ", err);
          }
        ));
      }, 2000);
      // fim
    } else {
      console.log(
        "whatsapp OnLine com limitações! Não Existe um Grupo de Pergunta Padrão Ativa !!"
      );
    }
    // WebHook Integração
    this.genProvider.removeCollection("omniAPI/", this.parametros.instancia)
    this.unSub.push(this.genProvider.onGetfilter("omniAPI/", "instanceId", this.parametros.instancia)
      .subscribe(
        data => {
          //**  console.log("Receive API " + new DatePipe("pt-BR").transform(Date.now(), "mm:ss.SSS"));
          let res = JSON.parse(JSON.stringify(data));
          if (res.length > 0) {
            this.genProvider.onIncrementKeyDateTime().then((keyValue: any) => {
              let dados = {
                status: "Novo",
                protocolo: keyValue,
                image: "assets/icon/chatbot.png",
                key_puc: '',
                nome_puc: '',
                acesso: "0",
                origem: res[0].origem,
                iddenuncia: parseInt(res[0].iddenuncia),
                coordenadas: res[0].lat + ";" + res[0].lng,
                lat: res[0].lat,
                lng: res[0].lng,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_registro: res[0].data_registro,
                data_status: res[0].data_status,
                local: res[0].local,
                tipo: res[0].tipo,
                estabelecimento: res[0].estabelecimento,
                logradouro: res[0].logradouro,
                bairro: res[0].bairro,
                cidade: res[0].cidade,
                estado: res[0].estado,
                cep: res[0].cep,
                denuncia: res[0].denuncia,
                nome: res[0].origem,
                telefone: "0000000000",
                id_canal: "0000000000",
                menu: res[0].origem,
                value: res[0].denuncia,
                time: Date.now(),
                data_criacao: Date.now(),
                //   messageNumber: "00000",
                notifica_usuario: false
              };
              this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/chat", dados.protocolo, dados);
              this.notificarAtendenteAPI(dados)
              if (res[0].denuncia) {
                let dados_body = {
                  protocolo: keyValue,
                  //   messageNumber: 1,
                  telefone: null,
                  type: "chat",
                  value: res[0].denuncia,
                  time: Date.now(), data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat_body", dados_body);
              }
              let files = res[0].files
              let c = 1;
              files.forEach(e => {
                c++
                let dados_body = {
                  protocolo: keyValue,
                  //   messageNumber: c,
                  telefone: null,
                  type: e.type,
                  value: e.value,
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(), "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat_body", dados_body);
              });
            });
          }
        }))
  }
  onContato(mensagem) {
    if (mensagem.body) {
      if (mensagem.body.substring(0, 5).toLowerCase() == "*sair" || mensagem.body.substring(0, 4).toLowerCase() == "sair") {
        // se usuario digitou sair finaliza o atendimento
        // pesquisa se contato esta no array de contatos
        this.pesquisaContato(mensagem.author).then(res => {
          let contato = JSON.parse(JSON.stringify(res));
          if (contato.length > 0) {
            contato[0].id_canal = mensagem.id_canal
            contato[0].origem = mensagem.origem
            contato[0].type = mensagem.type
            this.excluirMensagemTicket(contato[0].protocolo, contato[0].ticket, contato[0].atendimento, contato[0]);
            this.onFinalizaSair(contato);
          }
        });
      } else {
        // inicia a verificacao da acao do bot
        this.validaContato(mensagem).then(res => {
          let contato = JSON.parse(JSON.stringify(res));
          if (contato[0].acesso == -1) {
            this.atualizaContato(contato[0])
            this.onStartAtendimento(contato, mensagem)
          } else if (contato[0].tipo == "Pesquisa") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "sair") || (opc == "cancelar")) {
              let texto =
                "{{2}}, sua solicitação de atendimento foi cancelada.";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              contato[0].noShowPergunta = true;
              this.atualizaContato(contato[0])
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
            } else if ((opc == "1" || opc == "sim" || opc == "sin" || opc == "Sim")) {
              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: "Digite os dados para a consulta."
              };
              this.enviarMsg(msg);
              contato[0].noShowPergunta = false;
              this.atualizaContato(contato[0])
            } else if ((opc == "2" || opc == "não" || opc == "nao" || opc == "Não")) {
              contato[0].noShowPergunta = true;
              this.atualizaContato(contato[0])
              this.onOpcaochat(contato, "0");
            } else {
              let pesquisa = mensagem.body.replace("-", '');
              let result_msg =
                "Não foi encontrado em nossa base nenhum documento de identidade disponível com os dados informados."
              /*   +
                 this.ctrl;
               nao_achou += "Sugestões:" + this.ctrl;
               nao_achou +=
                 "Certifique-se de que todas as palavras estejam escritas corretamente." +
                 this.ctrl;
                 */
              /*
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: "Aguarde! Estamos processando sua pesquisa. ⏳"
            };
            this.enviarMsg(formulario);
            */
              let tmp = this.rg.filter(obj => {
                return obj.rg == pesquisa.toLowerCase();
              });
              console.log(tmp)
              if (tmp.length > 0) {
                result_msg = "Nome : " + tmp[0].nome.toUpperCase() + this.ctrl;
                result_msg += "Nº RG : " + tmp[0].rg + this.ctrl;
                result_msg += "Ano de expedição : " + tmp[0]['ano de expedição'] + this.ctrl;
                result_msg += "Local de retirada : " + tmp[0].local + this.ctrl;
              }
              // setTimeout(() => {
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: result_msg
              };
              this.enviarMsg(formulario)
              let msg = {}
              if (contato[0].origem == "whatsapp") {
                msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  header: contato[0].menu,
                  body: "Deseja fazer uma nova consulta?",
                  footer: this.titulo,
                  rows: [
                    {
                      type: "reply",
                      reply: {
                        id: '1',
                        title: 'Sim'
                      }
                    },
                    {
                      type: "reply",
                      reply: {
                        id: '2',
                        title: 'Não'
                      }
                    }
                  ]
                };
              } else {
                msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: this.msg_recebida
                };
              }
              if (!contato[0].noShowPergunta) {
                setTimeout(() => {
                  this.enviarMsg(msg);
                }, 500);

              }

              //    }, 1000);
            }
          } else if (contato[0].tipo == "Pesquisa Ticket") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "sair") || (opc == "cancelar")) {
              let texto =
                "{{2}}, sua solicitação de atendimento foi cancelada.";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              contato[0].noShowPergunta = true;
              this.atualizaContato(contato[0])
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
            } else if ((opc == "1" || opc == "sim" || opc == "sin" || opc == "Sim")) {
              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: "Digite os dados para a consulta."
              };
              this.enviarMsg(msg);
              contato[0].noShowPergunta = false;
              this.atualizaContato(contato[0])
            } else if ((opc == "2" || opc == "não" || opc == "nao" || opc == "Não")) {
              contato[0].noShowPergunta = true;
              this.atualizaContato(contato[0])
              this.onOpcaochat(contato, "0");
            } else {
              let pesquisa = mensagem.body.replace("-", '');
              let result_msg = "Não foi encontrado em nossa base esta númeração: " + pesquisa
              this.genProvider.onGetKey('dados/' + this.parametros.path + '/ticket', pesquisa).pipe(take(1)).subscribe(data => {
                let tmp = JSON.parse(JSON.stringify(data));
                if (!tmp.time) {
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: result_msg
                  };
                  this.enviarMsg(formulario)
                } else {
                  let msg = '*Consulta de Chamado (Ticket)*' + this.ctrl
                  msg += 'Ticket: ' + tmp.key + this.ctrl
                  msg += 'Data da Criação: ' + new DatePipe('pt-BR').transform(tmp.data_criacao, 'd, MMMM yyyy - HH:mm') + this.ctrl
                  msg += 'Última movimentação: ' + new DatePipe('pt-BR').transform(tmp.time, 'd, MMMM yyyy - HH:mm') + this.ctrl
                  msg += 'Status: ' + tmp.status_ticket + this.ctrl
                  msg += 'Nome do Solicitante: ' + tmp.nome_solicitante + this.ctrl
                  msg += 'Título do Ticket: ' + tmp.titulo_ticket + this.ctrl
                  if (tmp.conteudoTexto) {
                    msg += 'Detalhe: ' + tmp.conteudoTexto + this.ctrl
                  }
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: msg
                  };
                  this.enviarMsg(formulario)
                }

                let msg = {}
                if (contato[0].origem == "whatsapp") {
                  msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    header: contato[0].menu,
                    body: "Deseja fazer uma nova consulta?",
                    footer: this.titulo,
                    rows: [
                      {
                        type: "reply",
                        reply: {
                          id: '1',
                          title: 'Sim'
                        }
                      },
                      {
                        type: "reply",
                        reply: {
                          id: '2',
                          title: 'Não'
                        }
                      }
                    ]
                  };
                } else {
                  msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: this.msg_recebida
                  };
                }
                if (!contato[0].noShowPergunta) {
                  setTimeout(() => {
                    this.enviarMsg(msg);
                  }, 500);
                }
              });
            }
          } else if (contato[0].tipo == "API") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "sair") || (opc == "cancelar")) {
              let texto =
                "{{2}}, sua solicitação de atendimento foi cancelada.";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              contato[0].noShowPergunta = true;
              this.atualizaContato(contato[0])
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
            } else if ((opc == "1" || opc == "sim" || opc == "sin" || opc == "Sim")) {
              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: "Digite os dados para a consulta."
              };
              this.enviarMsg(msg);
              contato[0].noShowPergunta = false;
              this.atualizaContato(contato[0])
            } else if ((opc == "2" || opc == "não" || opc == "nao" || opc == "Não")) {
              contato[0].noShowPergunta = true;
              this.atualizaContato(contato[0])
              this.onOpcaochat(contato, "0");
            } else {
              let pesquisa = mensagem.body.replace(/\D/g, "");
              let result_msg = "Não foi encontrado em nossa base esta númeração: " + pesquisa
              let url = contato[0].api.replace("{{data}}", pesquisa);
              if (pesquisa != "") {
                let headers = new Headers({
                  "Content-Type": "application/x-www-form-urlencoded"
                });
                let options = new RequestOptions({
                  headers: headers,
                  method: "POST"
                });
                let body = {
                  type: "GET API",
                  api_url: url
                }
                this.parametros.url_send
                this.http.post(this.parametros.url_send, body, options).subscribe((res: any) => {
                  let data = (JSON.parse(res._body))
                  if (data.codigo) {
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: data.mensagem
                    };
                    this.enviarMsg(formulario);
                    let msg = {}
                    if (contato[0].origem == "whatsapp") {
                      msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        header: contato[0].menu,
                        body: "Deseja fazer uma nova consulta?",
                        footer: this.titulo,
                        rows: [
                          {
                            type: "reply",
                            reply: {
                              id: '1',
                              title: 'Sim'
                            }
                          },
                          {
                            type: "reply",
                            reply: {
                              id: '2',
                              title: 'Não'
                            }
                          }
                        ]
                      };
                    } else {
                      msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: this.msg_recebida
                      };
                    }
                    if (!contato[0].noShowPergunta) {
                      setTimeout(() => {
                        this.enviarMsg(msg);
                      }, 500);
                    }
                  } else {
                    let historico = ''
                    console.log("Resultado ", data);
                    let reg_historico = data.historico
                    if (reg_historico > 0) {
                      reg_historico.forEach(e => {
                        historico += 'Data Infração: ' + new DatePipe("pt-BR").transform(e.dataInfracao, "dd/MM/yyyy") + this.ctrl +
                          'N. Pontos: ' + e.numeroPontos + this.ctrl +
                          'Infração: ' + e.descMultaCompleta + this.ctrl +
                          'Orgão Autuador' + e.ufOrgaoAutuador + this.ctrl +
                          'Placa do Veículo: ' + e.placaVeiculo + this.ctrl + this.ctrl
                      });
                    }
                    let dados =
                      '*DETRAN - Departamento Estadual de Trânsito do Amazonas*' + this.ctrl + this.ctrl + '*Consulta Pontuação CNH*' + this.ctrl + this.ctrl + "*Dados do Condutor*" + this.ctrl +
                      'Nome: ' + data.nome + this.ctrl +
                      'Nome da Mãe: ' + data.nomeMae + this.ctrl +
                      'Nome do Pai: ' + data.nomePai + this.ctrl +
                      'N. Registro Renach: ' + data.numRegistroRenach + this.ctrl +
                      'CPF: ' + this.validaCampoProvider.formata_cpf(data.cpf) + this.ctrl +
                      'Dt Nascimento: ' + new DatePipe("pt-BR").transform(data.dataNascto, "dd/MM/yyyy") + this.ctrl +
                      'Dt Atualização: ' + new DatePipe("pt-BR").transform(data.dataAtualizacao, "dd/MM/yyyy") + this.ctrl +
                      'Dt Validade CNH: ' + new DatePipe("pt-BR").transform(data.dataValidadeCnh, "dd/MM/yyyy") + this.ctrl +
                      'UF Registro Atual: ' + data.ufRegistroAtual + this.ctrl +
                      'Categoria: ' + data.categoria + this.ctrl +
                      'Pontuação Últimos 12 Meses : ' + data.pontuacao.pontuacao12meses + this.ctrl;
                    if (reg_historico > 0) {
                      dados += 'historico:' + + this.ctrl + historico
                    }
                    result_msg = dados
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: result_msg
                    };
                    this.enviarMsg(formulario);
                    let msg = {}
                    if (contato[0].origem == "whatsapp") {
                      msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        header: contato[0].menu,
                        body: "Deseja fazer uma nova consulta?",
                        footer: this.titulo,
                        rows: [
                          {
                            type: "reply",
                            reply: {
                              id: '1',
                              title: 'Sim'
                            }
                          },
                          {
                            type: "reply",
                            reply: {
                              id: '2',
                              title: 'Não'
                            }
                          }
                        ]
                      };
                    } else {
                      msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: this.msg_recebida
                      };
                    }
                    if (!contato[0].noShowPergunta) {
                      setTimeout(() => {
                        this.enviarMsg(msg);
                      }, 500);
                    }
                  }
                },
                  error => {
                    console.log("erro no retorno ", error);
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem:
                        "No momento este serviço esta indisponível, por favor tente mais tarde."
                    };
                    this.enviarMsg(formulario);
                    this.onOpcaochat(contato, "-1");
                  }
                );
              }
            }
          } else if (contato[0].tipo == "Link_api") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
              //     setTimeout(() => {
              //       this.onOpcaochat(contato, "-1");
              //    }, 5000);
              this.onFinalizaAtendimento(contato);
            } else {
              let headers = new Headers({
                "Content-Type": "application/x-www-form-urlencoded"
              });
              let options = new RequestOptions({
                headers: headers,
                method: "POST"
              });
              let dados = mensagem.body.replace(/\D/g, "");

              let url = contato[0].api.replace("{{data}}", dados);
              if (dados != "") {
                this.http.post(url, dados, options).subscribe(
                  data => {
                    //       this.http.get(url, options).map(data => {
                    // let result = data.json()
                    let result = JSON.parse(JSON.stringify(data));
                    console.log("Resultado ", result);
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: JSON.stringify(result)
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaochat(contato, "-1");
                    }, 5000);
                  },
                  error => {
                    console.log("erro no retorno ", error);
                    let formulario = {
                      origem: 'whatsapp',
                      contato: "559180333070",
                      mensagem: "Ocorreu um erro na solicitação"
                    };
                    let formulario2 = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem:
                        "No momento este serviço esta indisponível, por favor tente mais tarde."
                    };
                    this.enviarMsg(formulario);
                    this.enviarMsg(formulario2);
                    //   setTimeout(() => {
                    //     this.onOpcaochat(contato, "-1");
                    //   }, 5000);
                    this.onFinalizaAtendimento(contato);
                  }
                );
              }

            }
          } else if (contato[0].tipo == "Consulta") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaochat(contato, "-1");
              }, 5000);
              this.onFinalizaAtendimento(contato);
            } else {
              let protocolo = mensagem.body.replace(/\D/g, "");
              let dados = {
                protocolo: this.parametros.instancia,
                token: contato[0].token,
                iddenuncia: protocolo
              };
              let url = contato[0].api.replace("{{data}}", dados);
              if (protocolo != "") {
                this.http.post(url, dados, this.options).subscribe(
                  res => {
                    //   console.log("Resultado ", result);
                    let data = JSON.parse(JSON.stringify(res));
                    //     console.log (data)
                    if (data._body == "null") {
                      let formulario = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem:
                          "Número de protocolo *" +
                          protocolo +
                          "* não existe!" +
                          this.ctrl +
                          "Digite e envie o protocolo." +
                          this.ctrl +
                          this.cancelar
                      };
                      this.enviarMsg(formulario);
                      //                 setTimeout(() => {
                      //                   this.onOpcaochat(contato, "-1");
                      //                }, 5000);
                    } else {
                      let body = JSON.parse(data._body);
                      let msg = "Protocolo: " + body["iddenuncia"] + this.ctrl;
                      msg +=
                        "Última Atualização: " + body["dt_update"] + this.ctrl;
                      msg += "Situação: " + body["situacao"] + this.ctrl + this.ctrl;
                      msg += '*Esta é uma mensagem automática, não responda* 😉'
                      let formulario = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: msg
                      };
                      this.enviarMsg(formulario);
                      setTimeout(() => {
                        this.onOpcaochat(contato, "-1");
                        //this.excluirContato(contato[0].telefone)
                      }, 2000);
                    }
                  },
                  error => {
                    console.log("erro no retorno ", error);
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: "Ocorreu um erro na solicitação"
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaochat(contato, "-1");
                      //this.excluirContato(contato[0].telefone)
                    }, 2000);
                  }
                );
              } else {
                let formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: "Envie um número de protocolo válido."
                };
                this.enviarMsg(formulario);
              }
            }
          } else if (contato[0].tipo == "Consulta Denuncia") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaochat(contato, "-1");
              }, 5000);
            } else {
              let protocolo = mensagem.body.replace(/\D/g, "");
              if (protocolo != "") {
                this.genProvider.onGetfilter('dados/' + this.parametros.path + '/denuncia', 'protocolo', protocolo).subscribe(res => {
                  let data = JSON.parse(JSON.stringify(res));
                  if (data.length == 0) {
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem:
                        "Número de protocolo *" +
                        protocolo +
                        "* não existe!" +
                        this.ctrl +
                        "Digite e envie o protocolo." +
                        this.ctrl +
                        this.cancelar
                    };
                    this.enviarMsg(formulario);
                  } else {
                    let msg = '*Status da sua denúncia*' + this.ctrl
                    msg += 'Protocolo: ' + data[0].protocolo + this.ctrl
                    msg += 'Última Atualização: ' + data[0].data_status + this.ctrl
                    msg += 'Situação: ' + data[0].status_denuncia + this.ctrl + this.ctrl
                    msg += '*Esta é uma mensagem automática, não responda* 😉'
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: msg
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaochat(contato, "-1");
                      //this.excluirContato(contato[0].telefone)
                    }, 2000);
                  }
                },
                  error => {
                    console.log("erro no retorno ", error);
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: "Ocorreu um erro na solicitação"
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaochat(contato, "-1");
                      // this.excluirContato(contato[0].telefone)
                    }, 2000);
                  }
                );
              } else {
                let formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: "Envie um número de protocolo válido."
                };
                this.enviarMsg(formulario);
              }
            }
          } else if (contato[0].tipo == "Mensagem") {
            // else if (opc == "1" || opc == "sim" || opc == "sin")
            clearTimeout(contato[0].timeMsg)
            let opc = mensagem.body.replace(" ", "").trim().toLowerCase();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "mensagem",
                "mensagem_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
              this.excluirMensagens(contato[0].protocolo);
            } else if (opc == "1" || opc == "sim" || opc == "sin" || opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Novo",
                novo: '1'
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "mensagem", dados_msg);
              this.onFinalizaAtendimento(contato);
            } else {
              if (opc == "2" || opc == "não" || opc == "nao") {
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: "Continue com sua mensagem."
                };
                this.enviarMsg(msg);
              } else {
                let dados = {
                  status: "Enviando...",
                  image: "assets/icon/" + contato[0].origem.trim() + ".png",
                  acesso: contato[0].acesso,
                  origem: contato[0].origem,
                  bloqueado: false,
                  coordenadas: contato[0].coordenadas,
                  //  messageNumber: mensagem.messageNumber,
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  nome_solicitante: contato[0].nome,
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body: any;
                dados_body = {
                  status: 'Recebida',
                  protocolo: contato[0].protocolo,
                  key_usuario: '',
                  nome_usuario: '',
                  key_solicitante: '',
                  nome_solicitante: '',
                  key_lotacao: '',
                  nome_lotacao: '',
                  type: mensagem.type,
                  ticket: contato[0].ticket,
                  value: mensagem.body,
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe('pt-BR').transform(
                    Date.now(),
                    'd, MMMM yyyy - HH:mm'
                  ),
                  tipo: 'publica',
                  status_ticket: '0'
                }
                this.genProvider.onSaveObjeto('dados', this.parametros.path + '/mensagem/' + contato[0].protocolo, 'mensagem_body', dados_body);

                this.pesquisaMensagens(contato[0].protocolo).then(data => {
                  let res = JSON.parse(JSON.stringify(data));
                  if (res.length == 0) {
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/mensagem",
                      dados.protocolo,
                      dados
                    );
                    this.mensagens.push(dados);
                  }
                });
                this.mensagens_body.push(dados_body);
                clearTimeout(contato[0].timeMsg)
                let msg = null;
                let t = setTimeout(() => {
                  if (contato[0].origem == "whatsapp") {
                    msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      header: contato[0].menu,
                      body: this.msg_recebida,
                      footer: this.titulo,
                      rows: [
                        {
                          type: "reply",
                          reply: {
                            id: '1',
                            title: 'Sim'
                          }
                        },
                        {
                          type: "reply",
                          reply: {
                            id: '2',
                            title: 'Não'
                          }
                        }
                      ]
                    };
                  } else {
                    msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: this.msg_recebida
                    };
                  }
                  this.enviarMsg(msg);
                }, (this.intervalo_msg_recebida * 1000));
                contato[0].timeMsg = t
                this.atualizaContato(contato[0]);

              }
            }
          } else if (contato[0].tipo == "Mensagem Chat") {
            let opc = mensagem.body.replace(" ", "").trim().toLowerCase();
            clearTimeout(contato[0].timeMsg)
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "chat",
                "chat_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
              this.excluirMensagens(contato[0].protocolo);
            } else if (opc == "1" || opc == "sim" || opc == "sin" || opc == "#") {
              this.onFinalizaAtendimento(contato);
              clearTimeout(contato[0].timeMsg)
              this.pesquisaChat_body(contato[0].protocolo).then(res => {
                let body = JSON.parse(JSON.stringify(res));
                let value = '';
                //     if (body.length > 0) {
                body.forEach(res => {
                  if (res.type == "chat") {
                    value = value + res.value + this.ctrl
                  }
                });

                if (!value) {
                  value = "Apenas Mídia"
                }
                let dados_msg = {
                  key: contato[0].protocolo,
                  origem: contato[0].origem,
                  image: "assets/icon/" + contato[0].origem.trim() + ".png",
                  status: "Novo",
                  novo: '1',
                  time: Date.now(),
                  data_criacao: Date.now(),
                  value: value
                };
                this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
                let mensagem = {
                  author: contato[0].telefone,
                  origem: contato[0].origem,
                  image: contato[0].image,
                  body: "Mensagem (AgentBot)",
                  date: contato[0].time,
                  senderName: contato[0].nome,
                  type: "chat",
                  notifica_usuario: true,
                  value: value
                }
                //  contato[0].key_puc = '';
                //                contato[0].nome_puc = '';
              })
            } else {
              if (opc == "2" || opc == "não" || opc == "nao") {
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: "Continue com sua mensagem."
                };
                this.enviarMsg(msg);
              } else {
                // colçocar a puc defalt
                //                contato[0].key_puc = this.parametros.key_puc;
                //                contato[0].nome_puc = this.parametros.nome_puc;
                let dados = {
                  status: "Enviando...",
                  image: "assets/icon/" + contato[0].origem.trim() + ".png",
                  origem: contato[0].origem,
                  acesso: contato[0].acesso,
                  bloqueado: false,
                  coordenadas: contato[0].coordenadas,
                  //  messageNumber: mensagem.messageNumber,
                  nome_solicitante: contato[0].nome,
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  id_canal: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  key_puc: contato[0].key_puc,
                  //    nome_puc: contato[0].nome_puc,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now(),
                  notifica_usuario: false
                };
                let dados_body: any;
                dados_body = {
                  status: 'Recebida',
                  protocolo: contato[0].protocolo,
                  key_usuario: '',
                  nome_usuario: '',
                  key_solicitante: '',
                  nome_solicitante: '',
                  key_lotacao: '',
                  nome_lotacao: '',
                  type: mensagem.type,
                  ticket: contato[0].ticket,
                  value: mensagem.body,
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe('pt-BR').transform(
                    Date.now(),
                    'd, MMMM yyyy - HH:mm'
                  ),
                  tipo: 'publica',
                  status_ticket: '1'
                }
                this.genProvider.onSaveObjeto('dados', this.parametros.path + '/chat/' + contato[0].protocolo, 'chat_body', dados_body);
                this.pesquisaMensagens(contato[0].protocolo).then(data => {
                  let res = JSON.parse(JSON.stringify(data));
                  if (res.length == 0) {
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/chat",
                      dados.protocolo,
                      dados
                    );
                    this.mensagens.push(dados);
                  }
                });
                this.mensagens_body.push(dados_body);
                clearTimeout(contato[0].timeMsg)
                let msg = null;
                let t = setTimeout(() => {
                  if (contato[0].origem == "whatsapp") {
                    msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      header: contato[0].menu,
                      body: this.msg_recebida,
                      footer: this.titulo,
                      rows: [
                        {
                          type: "reply",
                          reply: {
                            id: '1',
                            title: 'Sim'
                          }
                        },
                        {
                          type: "reply",
                          reply: {
                            id: '2',
                            title: 'Não'
                          }
                        }
                      ]
                    };
                  } else {
                    msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: this.msg_recebida
                    };
                  }
                  this.enviarMsg(msg);
                }, (this.intervalo_msg_recebida * 1000));
                contato[0].timeMsg = t
                this.atualizaContato(contato[0]);
              }
            }
          } else if (contato[0].tipo == "Chat") {
            let opc = mensagem.body.replace(" ", "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
              };
              this.enviarMsg(formulario);
              let unsub = this.genProvider.onGetfilter('dados/' + this.parametros.path + '/chat_fila', "protocolo", contato[0].protocolo).subscribe(data => {
                unsub.unsubscribe();
                let res = JSON.parse(JSON.stringify(data));
                if (res[0].status == 'Novo') {
                  this.onCancelaMsg(
                    contato[0].protocolo,
                    "chat",
                    "chat_body"
                  );
                }
              },
                err => console.log(err)
              );
              this.onOpcaochat(contato, "0");
            } else {
              let dados = {};
              if (contato[0].chatLive == false) {
                // colçocar a puc defalt
                //    contato[0].key_puc = this.parametros.key_puc;
                //    contato[0].nome_puc = this.parametros.nome_puc;
                dados = {
                  status: "Novo",
                  novo: '1',
                  origem: contato[0].origem,
                  image: "assets/icon/" + contato[0].origem.trim() + ".png",
                  acesso: contato[0].acesso,
                  bloqueado: contato[0].bloqueado,
                  coordenadas: contato[0].coordenadas,
                  nome_solicitante: contato[0].nome,
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  id_canal: contato[0].id_canal,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  key_puc: contato[0].key_puc,
                  //  nome_puc: contato[0].nome_puc,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now(),
                  //  messageNumber: mensagem.messageNumber,
                  notifica_usuario: true,
                  chatLive: true
                };
                contato[0].chatLive = true;
                this.atualizaContato(contato[0]);
                this.genProvider.onSaveDocKey(
                  "dados/" + this.parametros.path + "/chat",
                  contato[0].protocolo,
                  dados
                ); // atualiza o registro com a mesma chave
              } else {
                this.pesquisaChat(contato[0].protocolo).then(
                  data => {
                    let res = JSON.parse(JSON.stringify(data));
                    if (res[0].status != 'Novo') {
                      dados = {
                        key: contato[0].protocolo,
                        origem: contato[0].origem,
                        status: "Nova Mensagem",
                        data_envio: new DatePipe("pt-BR").transform(
                          Date.now(),
                          "d, MMMM yyyy - HH:mm"
                        ),
                        finalizada: "nao",
                        type: mensagem.type,
                        value: mensagem.body,
                        time: Date.now()
                      };
                      this.genProvider.onSaveObjeto(
                        "dados",
                        this.parametros.path,
                        "chat",
                        dados
                      );
                    }
                  })
              }
              let dados_body: any;
              dados_body = {
                protocolo: contato[0].protocolo,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                //  messageNumber: mensagem.messageNumber,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto('dados', this.parametros.path + '/chat/' + contato[0].protocolo, 'chat_body', dados_body);

            }
          } else if (contato[0].tipo == "Localizacao") {
            //       let opc = mensagem.body.replace(/\D/g, '').trim();
            let opc = mensagem.body.replace(" ", "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "mensagem",
                "mensagem_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
              this.excluirMensagens(contato[0].protocolo);
            } else if (mensagem.type == "location" && !contato[0].localizacao) {
              this.onLocalizacao(mensagem.body).then(res => {
                let dados = {
                  status: "Enviando...",
                  id_canal: contato[0].id_canal,
                  origem: contato[0].origem,
                  acesso: contato[0].acesso,
                  bloqueado: contato[0].bloqueado,
                  coordenadas: contato[0].coordenadas,
                  //  messageNumber: mensagem.messageNumber,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  //  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  coordenadas: mensagem.body,
                  localizacao: res,
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveDocKey(
                  "dados/" + this.parametros.path + "/mensagem",
                  dados.protocolo,
                  dados
                ); // atualiza o registro com a mesma chave
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "mensagem_body",
                  dados_body
                );
                this.mensagens_body.push(dados_body);
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: this.msg_mensagem
                };
                this.enviarMsg(msg);
                contato[0].localizacao = true;
                this.atualizaContato(contato[0]);
              });
            } else if (mensagem.type != "location" && !contato[0].localizacao) {
              let texto =
                "ATENÇÃO, você precisa primeiro enviar a localização para prosseguir." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
            } else if (opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Novo"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "mensagem",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                menu: contato[0].menu,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now()
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };

              this.pesquisaMensagens(contato[0].protocolo).then(data => {
                let res = JSON.parse(JSON.stringify(data));
                if (res.length == 0) {
                  this.genProvider.onSaveDocKey(
                    "dados/" + this.parametros.path + "/mensagem",
                    dados.protocolo,
                    dados
                  );
                  this.mensagens.push(dados);
                }
              });
              this.mensagens_body.push(dados_body);
              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: this.msg_recebida
              };
              this.enviarMsg(msg);
            }
          } else if (contato[0].tipo == "Sugestao") {
            //       let opc = mensagem.body.replace(/\D/g, '').trim();
            // else if (opc == "1" || opc == "sim" || opc == "sin")
            clearTimeout(contato[0].timeMsg)
            let opc = mensagem.body.replace(" ", "").trim().toLowerCase();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "mensagem",
                "mensagem_body"
              );

              this.enviarMsg(formulario);
              //              setTimeout(() => {
              this.onOpcaochat(contato, "0");
              //            }, 5000);
            } else if (mensagem.type == "location" && !contato[0].localizacao) {
              this.onLocalizacao(mensagem.body).then(res => {
                let dados = {
                  status: "Enviando...",
                  origem: contato[0].origem,
                  acesso: contato[0].acesso,
                  bloqueado: contato[0].bloqueado,
                  coordenadas: contato[0].coordenadas,
                  //  messageNumber: mensagem.messageNumber,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  sugestao: true,
                  localizacao: contato[0].localizacao,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  id_canal: contato[0].id_canal,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  //  messageNumber: mensagem.messageNumber,
                  sugestao: contato[0].sugestao,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  coordenadas: mensagem.body,
                  localizacao: res,
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveDocKey(
                  "dados/" + this.parametros.path + "/mensagem",
                  dados.protocolo,
                  dados
                ); // atualiza o registro com a mesma chave
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "mensagem_body",
                  dados_body
                );

                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: this.msg_mensagem
                };
                this.enviarMsg(msg);
                contato[0].localizacao = true;
                contato[0].sugestao = false;
                this.atualizaContato(contato[0]);
              });
            } else if (mensagem.type != "location" && !contato[0].localizacao) {
              let texto =
                "ATENÇÃO, você precisa primeiro enviar a localização para prosseguir." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
            } else if (opc == "#" && contato[0].sugestao) {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Novo"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "mensagem",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
              // colocar aqui a finalizacao na base de dados colocar um flat de mensagem finalizada e enviar
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else if (opc == "#" && !contato[0].sugestao) {
              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: this.msg_sugestao
              };
              this.enviarMsg(msg);
              contato[0].localizacao = true;
              contato[0].sugestao = true;
              this.atualizaContato(contato[0]);
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                sugestao: true,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                id_canal: contato[0].id_canal,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                menu: contato[0].menu,
                type: mensagem.type,
                value: mensagem.body,
                //  messageNumber: mensagem.messageNumber,
                time: Date.now()
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                //  messageNumber: mensagem.messageNumber,
                telefone: contato[0].telefone,
                id_canal: contato[0].id_canal,
                sugestao: contato[0].sugestao,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveDocKey(
                "dados/" + this.parametros.path + "/mensagem",
                dados.protocolo,
                dados
              ); // atualiza o registro com a mesma chave
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "mensagem_body",
                dados_body
              );

              clearTimeout(contato[0].timeMsg)
              let msg = null;
              let t = setTimeout(() => {
                if (contato[0].origem == "whatsapp") {
                  msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    header: contato[0].menu,
                    body: this.msg_recebida,
                    footer: this.titulo,
                    rows: [
                      {
                        type: "reply",
                        reply: {
                          id: '1',
                          title: 'Sim'
                        }
                      },
                      {
                        type: "reply",
                        reply: {
                          id: '2',
                          title: 'Não'
                        }
                      }
                    ]
                  };
                } else {
                  msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: this.msg_recebida
                  };
                }
                this.enviarMsg(msg);
              }, (this.intervalo_msg_recebida * 1000));
              contato[0].timeMsg = t
              this.atualizaContato(contato[0]);

            }
          } else if (contato[0].tipo == "Midia") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaochat(contato, "-1");
              }, 5000);
            } else if (mensagem.type != "chat" && !this.midiaMensagem) {
              this.midiaMensagem = mensagem.body;
              this.type_midia = mensagem.type;
              let texto = this.msg_midia
              this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  *_0_* para cancelar!*";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
            } else if (mensagem.type != "chat" && this.midiaMensagem) {
              let texto = this.msg_midia
              this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  *_0_* para cancelar!*";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
            } else if (mensagem.type == "chat" && !this.midiaMensagem) {
              let texto =
                "{{2}} você precisa enviar um arquivo válido conforme solicitado *(VÍDEO, ÁUDIO, IMAGEM, PDF, DOCX...)*." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
            } else {
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: this.mensagem.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              //   this.enviarMsg(formulario);
              let dados = {
                status: "Novo",
                novo: '1',
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                //  messageNumber: mensagem.messageNumber,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                menu: contato[0].menu,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now()
              };
              let dados_body_midia = {
                protocolo: contato[0].protocolo,
                // messageNumber: mensagem.messageNumber,
                fromMe: false,
                telefone: contato[0].telefone,
                type: this.type_midia,
                value: this.midiaMensagem,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "mensagem_body", dados_body_midia);
              let dados_body_texto = {
                protocolo: contato[0].protocolo,
                //  messageNumber: mensagem.messageNumber,
                fromMe: false,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "mensagem_body", dados_body_texto);
              this.midiaMensagem = "";
              this.type_midia = "";
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "mensagem", dados);
              this.onFinalizaAtendimento(contato);
            }
          } else if (contato[0].tipo == "Anunciar") {
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = "{{2}}, seu anuncio foi cancelado.";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaochat(contato, "0");
              }, 5000);
            } else if (mensagem.type == "image" && !this.imagemAnuncio) {
              this.imagemAnuncio = mensagem.body;
              let texto =
                "{{2}}, agora você precisa escrever o texto do seu anuncio." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
            } else if (mensagem.type == "image" && this.imagemAnuncio) {
              let texto =
                "{{2}} você precisa enviar agora o texto do seu anuncio." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
            } else if (mensagem.type == "chat" && !this.imagemAnuncio) {
              let texto =
                "{{2}} você precisa enviar uma imagem/foto do seu produto." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
            } else {
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: this.anunciar.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
              let dados = {
                status: "Novo",
                novo: '1',
                token: mensagem.token,
                menu: contato[0].menu,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                type: mensagem.type,
                //  messageNumber: mensagem.messageNumber,
                value: mensagem.body,
                imagem: this.imagemAnuncio,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.imagemAnuncio = "";
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "classificado",
                dados
              );
              setTimeout(() => {
                this.onOpcaochat(contato, "0");
              }, 5000);
            }
          } else if (contato[0].tipo == "Atendimento") {
            let opcao = mensagem.body.replace(/\D/g, "").trim();
            if (opcao == "0") {
              let texto =
                "{{2}}, sua solicitação de atendimento foi cancelada.";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
              setTimeout(() => {
                this.onOpcaochat(contato, "-1");
              }, 5000);
            } else {
              var time = new Date();
              var date = new Date(
                time.getTime() - this.time_resposta * 60 * 1000
              );
              //   console.log (contato[0].time , Date.parse(date.toString()))
              if (contato[0].time < Date.parse(date.toString())) {
                console.log(
                  "tempo de resposta exedido, inicia o menu principal"
                );
                let formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem:
                    "Atenção, você esta há mais de " +
                    this.time_resposta +
                    " minutos de inatividade, você será redirecionado para o início do atendimento. Obrigado."
                };
                //   this.enviarMsg(formulario);
                this.onStartAtendimento(contato, mensagem);
              } else if (opcao == "0" && contato[0].nivel < 200) {
                this.onOpcaochat(contato, "-1");
              } else if (contato[0].nivel == 200) {
                let dados = {
                  //    status: 'Espera',
                  key: contato[0].protocolo,
                  menu: contato[0].menu,
                  protocolo: contato[0].protocolo,
                  //  messageNumber: mensagem.messageNumber,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  type: mensagem.type || "chat",
                  value: "Enviou uma mensagem...",
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                let dados_body = {
                  protocolo: contato[0].protocolo,
                  //  messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type || "chat",
                  value: mensagem.body,
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "chat_body",
                  dados_body
                );
                //      this.genProvider.onSaveObjeto('dados', this.parametros.path, 'atendimento', dados)
              } else {
                this.filtroOpcao(this.puc, parseInt(opcao)).then(
                  res => {
                    let menu = JSON.parse(JSON.stringify(res));
                    if (menu.length > 0) {
                      let dataAtual = new Date();
                      let expira = dataAtual.setDate(dataAtual.getHours() + 1);

                      let dados = {
                        //        key: contato[0].protocolo,
                        status: "Novo",
                        image: "assets/icon/" + contato[0].origem.trim() + ".png",
                        novo: '1',
                        key_puc: menu[0].key,
                        //  nome_puc: menu[0].nome,
                        acesso: contato[0].acesso,
                        menu: menu[0].nome,
                        bloqueado: contato[0].bloqueado,
                        coordenadas: contato[0].coordenadas,
                        data_criacao: Date.now(),
                        data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
                        data_nascimento: "",
                        invalida: contato[0].invalida,
                        localizacao: contato[0].localizacao,
                        nivel: contato[0].nivel,
                        nome: contato[0].nome,
                        nome_solicitante: contato[0].nome,
                        telefone: contato[0].telefone,
                        id_canal: contato[0].id_canal,
                        tipo: contato[0].tipo,
                        key_pergunta: contato[0].key_pergunta,
                        protocolo: contato[0].protocolo,
                        key_master: contato[0].key_master,
                        key_child: contato[0].key_child,
                        time: expira,
                        type: mensagem.type,
                        value: mensagem.body,
                        //  messageNumber: mensagem.messageNumber,
                        notifica_usuario: true
                      };

                      //     this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/chat",dados.protocolo,dados); // atualiza o registro com a mesma chave
                      //     console.log (dados)
                      let formulario = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: this.atendimento.replace(
                          "{{2}}",
                          contato[0].nome
                        )
                      };
                      this.enviarMsg(formulario);
                      contato[0].nivel = 200;
                      contato[0].menu = menu[0].nome;
                      contato[0].key_puc = menu[0].key || '';
                      //    contato[0].nome_puc = menu[0].nome;
                      this.atualizaContato(contato[0]);
                      let msg = {
                        author: contato[0].telefone,
                        body: "Aguardando atendimento...",
                        date: contato[0].time,
                        senderName: contato[0].nome,
                        type: "chat",
                        notifica_usuario: true,
                        value: "Aguardando atendimento..."
                      }
                      this.notificarAtendente(msg, contato);
                    } else {
                      let mensagem = this.pergunta.opcao_invalida_principal.replace(
                        "{{2}}",
                        contato[0].nome
                      );
                      if (contato[0].nivel > 0) {
                        mensagem = this.pergunta.opcao_invalida.replace(
                          "{{2}}",
                          contato[0].nome
                        );
                      }
                      if (this.mensagem_full.body.substring(0, 4) == "http") {
                        mensagem = this.pergunta.opcao_invalida_outros.replace(
                          "{{2}}",
                          contato[0].nome
                        );
                      }

                      let formulario = {};
                      if (this.opcao_invalida_midia) {
                        formulario = {
                          origem: contato[0].origem,
                          contato: contato[0].id_canal,
                          caption:
                            mensagem +
                            this.ctrl +
                            this.ctrl +
                            this.msg_navegacao,
                          midia: this.opcao_invalida_midia
                        };
                        this.enviarMsg(formulario);
                        formulario = {
                          origem: contato[0].origem,
                          contato: contato[0].id_canal,
                          mensagem:
                            mensagem +
                            this.ctrl +
                            this.ctrl +
                            this.msg_navegacao
                        };
                        this.enviarMsg(formulario);
                      } else {
                        let formulario = {
                          origem: contato[0].origem,
                          contato: contato[0].id_canal,
                          mensagem:
                            mensagem +
                            this.ctrl +
                            this.ctrl +
                            this.msg_navegacao
                        };
                        this.enviarMsg(formulario);
                      }
                    }
                  }
                );
              }
            }
          } else if (contato[0].tipo == "Ticket") {
            clearTimeout(contato[0].timeMsg)
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto =
                "{{2}}, sua solicitação de atendimento foi cancelada.";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              // this.onCancelaMsg(contato[0].protocolo,"chat","chat_body");
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
              this.pesquisaChat(contato[0].protocolo).then(res => {
                let data = JSON.parse(JSON.stringify(res));
                if (data.length > 0) {
                  this.excluirMensagemTicket(contato[0].protocolo, contato[0].ticket, contato[0].atendimento, contato[0]);
                }
              })
            } else {
              if (opc == "0" && contato[0].nivel < 200) {
                this.onOpcaochat(contato, "-1");
              } else if (contato[0].nivel == 200) {
                if (opc == "1" || opc == "sim" || opc == "sin" || opc == "#") {
                  let dados_msg = {
                    key: contato[0].protocolo,
                    origem: contato[0].origem,
                    image: "assets/icon/" + contato[0].origem.trim() + ".png",
                    status: "Novo",
                    novo: '1',
                    time: Date.now(),
                    data_criacao: Date.now(),
                    ticket: contato[0].ticket,
                  };
                  this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
                  let mensagem = {
                    author: contato[0].telefone,
                    id_canal: contato[0].id_canal,
                    origem: contato[0].origem,
                    image: "assets/icon/" + contato[0].origem.trim() + ".png",
                    body: contato[0].menu,
                    date: contato[0].time,
                    senderName: contato[0].nome,
                    type: "chat",
                    notifica_usuario: true,
                    value: ""
                  }
                  let dados_ticket = {
                    key: contato[0].ticket,
                    status_ticket: "Novo",
                    ticket: contato[0].ticket,
                    protocolo: contato[0].protocolo
                  };
                  this.genProvider.onSaveObjeto("dados", this.parametros.path, "ticket", dados_ticket);
                  let msg_resp = "Abertura de Chamado Ticket Nº " + contato[0].ticket + this.ctrl;
                  msg_resp += 'Data: ' + new DatePipe('pt-BR').transform(Date.now(), 'd, MMMM yyyy - HH:mm') + this.ctrl
                  msg_resp += 'Status: Registrado' + this.ctrl
                  msg_resp += 'Opção de atendimento: ' + contato[0].menu + this.ctrl
                  msg_resp += 'Aberta por : ' + contato[0].nome + this.ctrl + this.ctrl
                  msg_resp += '*Esta é uma mensagem automática, não responda* 😉'
                  let msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: msg_resp
                  };
                  // enviar email p/ ticket
                  let data_movto = {
                    ticket: contato[0].ticket,
                    protocolo: contato[0].protocolo,
                    status: 'Novo',
                    key_usuario: '000000',
                    key_lotacao: null,
                    key_lotacao_tramitacao: null,
                    key_usuario_destino: null,
                    key_puc: null,
                    time: Date.now(),
                    canal: contato[0].origem,
                    conteudo: "Ticket aberto por agentBot"
                  }
                  this.genProvider.onSaveObjeto('dados', this.parametros.path, 'ticket_movimentacao', data_movto);
                  this.onFinalizaAtendimento(contato);
                  setTimeout(() => {
                    this.enviarMsg(msg);

                  }, 1000);
                } else {
                  let dados_body: any;
                  dados_body = {
                    status: 'Recebida',
                    protocolo: contato[0].protocolo,
                    key_usuario: '',
                    nome_usuario: '',
                    key_solicitante: '',
                    nome_solicitante: '',
                    key_lotacao: '',
                    nome_lotacao: '',
                    type: mensagem.type,
                    ticket: contato[0].ticket,
                    value: mensagem.body,
                    time: Date.now(),
                    data_criacao: Date.now(),
                    data_hora: new DatePipe('pt-BR').transform(
                      Date.now(),
                      'd, MMMM yyyy - HH:mm'
                    ),
                    tipo: 'publica',
                    status_ticket: '1'
                  }
                  this.genProvider.onSaveObjeto('dados', this.parametros.path + '/chat/' + contato[0].protocolo, 'chat_body', dados_body);
                  //  this.genProvider.onSaveObjeto('dados', this.parametros.path + '/ticket/' + contato[0].ticket, 'ticket_body', dados_body);

                  clearTimeout(contato[0].timeMsg)
                  let msg = null;
                  let t = setTimeout(() => {
                    if (contato[0].origem == "whatsapp") {
                      msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        header: contato[0].menu,
                        body: this.msg_recebida,
                        footer: this.titulo,
                        rows: [
                          {
                            type: "reply",
                            reply: {
                              id: '1',
                              title: 'Sim'
                            }
                          },
                          {
                            type: "reply",
                            reply: {
                              id: '2',
                              title: 'Não'
                            }
                          }
                        ]
                      };
                    } else {
                      msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: this.msg_recebida
                      };
                    }
                    this.enviarMsg(msg);
                  }, (this.intervalo_msg_recebida * 1000));
                  contato[0].timeMsg = t
                  this.atualizaContato(contato[0]);
                }
              } else {
                this.filtroOpcao(this.puc, parseInt(opc)).then(
                  res => {
                    let menu = JSON.parse(JSON.stringify(res));
                    if (menu.length > 0) {
                      let dados_ticket = {
                        status_ticket: "Enviando",
                        compartilhado: false,
                        copia_usuario: false,
                        distribuicao: false,
                        encaminhado: false,
                        encerrado: false,
                        status: "Recebido",
                        data_criacao: Date.now(),
                        data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
                        key_puc: menu[0].key || contato[0].key_puc,
                        //   nome_puc: menu[0].nome,
                        nome_usuario: this.parametros.nome,
                        key_usuario: this.parametros.key_usuario,
                        key_solicitante: contato[0].telefone,
                        nome_solicitante: contato[0].nome,
                        key_catalogo: '',
                        nome_catalogo: '',
                        key_subcatalogo: '',
                        nome_subcatalogo: '',
                        key_lotacao: '',
                        nome_lotacao: '',
                        canal: contato[0].origem,
                        conteudo: '',
                        time: Date.now(),
                        enviar_resposta_solicitante: true,
                        id_canal: contato[0].id_canal,
                        key_responsavel: null,
                        nome_responsavel: null,
                        observacao_interna: "",
                        qtd_interacao: "",
                        resposta: "",
                        telefone: contato[0].telefone,
                        type: mensagem.type,
                        tipo_ticket: "Externo",
                        titulo_ticket: contato[0].menu,
                        prioridade: 'Nenhuma',
                        tramitacao: '0'

                      };
                      this.genProvider.onSaveIncrementZeroDate("dados/" + this.parametros.path + "/ticket", dados_ticket, "ticket", 6).then(t => {
                        contato[0].ticket = t
                        let atendimento = {
                          status: "Novo",
                          protocolo: contato[0].protocolo,
                          ticket: contato[0].ticket,
                          key_puc: menu[0].key,
                          key_usuario: null,
                          key_solicitante: contato[0].telefone,
                          nome_solicitante: contato[0].nome,
                          origem: contato[0].origem,
                          id_canal: contato[0].id_canal,
                          telefone: contato[0].telefone,
                          data_criacao: Date.now(),
                          time: Date.now(),
                          tempo: ''
                        };
                        this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/atendimento", atendimento.protocolo, atendimento).then(key => {
                          //  this.genProvider.onSaveIncrement("dados/" + this.parametros.path + "/atendimento", atendimento, "atendimento").then(key => {
                          contato[0].atendimento = key
                        })
                      });
                      let dados = {
                        status: "Enviando",
                        origem: contato[0].origem,
                        acesso: contato[0].acesso,
                        key_puc: menu[0].key || '',
                        image: "assets/icon/" + contato[0].origem.trim() + ".png",
                        bloqueado: false,
                        coordenadas: contato[0].coordenadas,
                        data_criacao: Date.now(),
                        data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
                        data_nascimento: "",
                        invalida: contato[0].invalida,
                        localizacao: contato[0].localizacao,
                        nivel: contato[0].nivel,
                        nome: contato[0].nome,
                        nome_solicitante: contato[0].nome,
                        telefone: contato[0].telefone,
                        id_canal: contato[0].id_canal,
                        tipo: contato[0].tipo,
                        key_pergunta: contato[0].key_pergunta,
                        protocolo: contato[0].protocolo,
                        key_master: contato[0].key_master,
                        key_child: contato[0].key_child,
                        menu: contato[0].menu,
                        type: mensagem.type,
                        value: mensagem.body,
                        time: Date.now(),
                        notifica_usuario: false
                      };
                      this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/chat", dados.protocolo, dados);
                      let formulario = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: this.atendimento.replace(
                          "{{2}}",
                          contato[0].nome
                        )
                      };
                      this.enviarMsg(formulario);
                      contato[0].nivel = 200;
                      contato[0].menu = menu[0].nome;
                      this.atualizaContato(contato[0]);
                    } else {
                      let mensagem = this.pergunta.opcao_invalida_principal.replace(
                        "{{2}}",
                        contato[0].nome
                      );
                      if (contato[0].nivel > 0) {
                        mensagem = this.pergunta.opcao_invalida.replace(
                          "{{2}}",
                          contato[0].nome
                        );
                      }
                      if (this.mensagem_full.body.substring(0, 4) == "http") {
                        mensagem = this.pergunta.opcao_invalida_outros.replace(
                          "{{2}}",
                          contato[0].nome
                        );
                      }

                      let formulario = {};
                      if (this.opcao_invalida_midia) {
                        formulario = {
                          origem: contato[0].origem,
                          contato: contato[0].id_canal,
                          caption:
                            mensagem +
                            this.ctrl +
                            this.ctrl +
                            this.msg_navegacao,
                          midia: this.opcao_invalida_midia
                        };
                        this.enviarMsg(formulario);
                        formulario = {
                          origem: contato[0].origem,
                          contato: contato[0].id_canal,
                          mensagem:
                            mensagem +
                            this.ctrl +
                            this.ctrl +
                            this.msg_navegacao
                        };
                        this.enviarMsg(formulario);
                      } else {
                        let formulario = {
                          origem: contato[0].origem,
                          contato: contato[0].id_canal,
                          mensagem:
                            mensagem +
                            this.ctrl +
                            this.ctrl +
                            this.msg_navegacao
                        };
                        this.enviarMsg(formulario);
                      }
                    }
                  }
                );
              }
            }
          } else if (contato[0].tipo == "Ticket PUC") {
            clearTimeout(contato[0].timeMsg)
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto =
                "{{2}}, sua solicitação de atendimento foi cancelada.";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              // this.onCancelaMsg(contato[0].protocolo,"chat","chat_body");
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
              this.pesquisaChat(contato[0].protocolo).then(res => {
                let data = JSON.parse(JSON.stringify(res));
                if (data.length > 0) {
                  this.excluirMensagemTicket(contato[0].protocolo, contato[0].ticket, contato[0].atendimento, contato[0]);
                }
              })
            } else if ((opc == "1" || opc == "sim" || opc == "sin" || opc == "Sim" || opc == "#") && (contato[0].ticket)) {
              let dados_msg = {
                key: contato[0].protocolo,
                origem: contato[0].origem,
                image: "assets/icon/" + contato[0].origem.trim() + ".png",
                status: "Novo",
                novo: '1',
                time: Date.now(),
                data_criacao: Date.now(),
                ticket: contato[0].ticket,
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
              let mensagem = {
                author: contato[0].telefone,
                id_canal: contato[0].id_canal,
                origem: contato[0].origem,
                image: "assets/icon/" + contato[0].origem.trim() + ".png",
                body: contato[0].menu,
                date: contato[0].time,
                senderName: contato[0].nome,
                type: "chat",
                notifica_usuario: true,
                value: ""
              }
              let dados_ticket = {
                key: contato[0].ticket,
                status_ticket: "Novo",
                ticket: contato[0].ticket,
                protocolo: contato[0].protocolo
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "ticket", dados_ticket);
              let msg_resp = "Abertura de Chamado Ticket Nº " + contato[0].ticket + this.ctrl;
              msg_resp += 'Data: ' + new DatePipe('pt-BR').transform(Date.now(), 'd, MMMM yyyy - HH:mm') + this.ctrl
              msg_resp += 'Status: Registrado' + this.ctrl
              msg_resp += 'Opção de atendimento: ' + contato[0].menu + this.ctrl
              msg_resp += 'Aberta por : ' + contato[0].nome + this.ctrl + this.ctrl
              msg_resp += '*Esta é uma mensagem automática, não responda* 😉'
              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: msg_resp
              };
              let data_movto = {
                ticket: contato[0].ticket,
                protocolo: contato[0].protocolo,
                status: 'Novo',
                key_usuario: '000000',
                key_lotacao: null,
                key_lotacao_tramitacao: null,
                key_usuario_destino: null,
                key_puc: null,
                time: Date.now(),
                canal: contato[0].origem,
                conteudo: "Ticket aberto por agentBot"
              }
              this.genProvider.onSaveObjeto('dados', this.parametros.path, 'ticket_movimentacao', data_movto);
              this.onFinalizaAtendimento(contato);
              setTimeout(() => {
                this.enviarMsg(msg);
              }, 1000);
            } else {
              if (opc == "2" || opc == "não" || opc == "nao" || opc == "Não") {
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: "Continue com sua mensagem."
                };
                this.enviarMsg(msg);
              } else {
                if (!contato[0].ticket) {
                  let dados_ticket = {
                    status_ticket: "Enviando",
                    compartilhado: false,
                    copia_usuario: false,
                    distribuicao: false,
                    encaminhado: false,
                    encerrado: false,
                    status: "Recebido",
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    key_puc: contato[0].key_puc,
                    nome_usuario: this.parametros.nome,
                    key_usuario: this.parametros.key_usuario,
                    key_solicitante: contato[0].telefone,
                    nome_solicitante: contato[0].nome,
                    key_catalogo: '',
                    nome_catalogo: '',
                    key_subcatalogo: '',
                    nome_subcatalogo: '',
                    key_lotacao: '',
                    nome_lotacao: '',
                    canal: contato[0].origem,
                    conteudo: '',
                    time: Date.now(),
                    data_criacao: Date.now(),
                    enviar_resposta_solicitante: true,
                    id_canal: contato[0].id_canal,
                    key_responsavel: null,
                    nome_responsavel: null,
                    observacao_interna: "",
                    qtd_interacao: "",
                    resposta: "",
                    telefone: contato[0].telefone,
                    type: mensagem.type,
                    tipo_ticket: "Externo",
                    titulo_ticket: contato[0].menu,
                    prioridade: 'Nenhuma',
                    tramitacao: '0'
                  };
                  let dados = {
                    status: "Enviando",
                    origem: contato[0].origem,
                    acesso: contato[0].acesso,
                    key_puc: contato[0].key_puc,
                    image: "assets/icon/" + contato[0].origem.trim() + ".png",
                    bloqueado: false,
                    coordenadas: contato[0].coordenadas,
                    data_nascimento: "",
                    invalida: contato[0].invalida,
                    localizacao: contato[0].localizacao,
                    nivel: contato[0].nivel,
                    nome: contato[0].nome,
                    nome_solicitante: contato[0].nome,
                    telefone: contato[0].telefone,
                    id_canal: contato[0].id_canal,
                    tipo: contato[0].tipo,
                    key_pergunta: contato[0].key_pergunta,
                    protocolo: contato[0].protocolo,
                    key_master: contato[0].key_master,
                    key_child: contato[0].key_child,
                    menu: contato[0].menu,
                    type: mensagem.type,
                    value: mensagem.body,
                    time: Date.now(),
                    data_criacao: Date.now(),
                    data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
                    notifica_usuario: false
                  };
                  this.genProvider.onSaveIncrementZeroDate("dados/" + this.parametros.path + "/ticket", dados_ticket, "ticket", 6).then(t => {
                    contato[0].ticket = t
                    //                 this.genProvider.onSaveObjeto('dados', this.parametros.path + '/ticket/' + contato[0].ticket, 'ticket_body', dados_body);
                    let atendimento = {
                      status: "Novo",
                      protocolo: contato[0].protocolo,
                      ticket: contato[0].ticket,
                      key_puc: contato[0].key_puc,
                      key_usuario: null,
                      key_solicitante: contato[0].telefone,
                      nome_solicitante: contato[0].nome,
                      origem: contato[0].origem,
                      id_canal: contato[0].id_canal,
                      telefone: contato[0].telefone,
                      data_criacao: Date.now(),
                      time: Date.now(),
                      tempo: ''
                    };
                    this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/atendimento", atendimento.protocolo, atendimento).then(key => {
                      //  this.genProvider.onSaveIncrement("dados/" + this.parametros.path + "/atendimento", atendimento, "atendimento").then(key => {
                      contato[0].atendimento = key
                    })
                  })
                  this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/chat", dados.protocolo, dados);
                  this.atualizaContato(contato[0])
                }
                let dados_body: any;

                dados_body = {
                  protocolo: contato[0].protocolo,
                  status: 'Recebida',
                  tipo: 'publica',
                  key_usuario: this.parametros.key_usuario,
                  nome_usuario: this.parametros.nome_usuario,
                  key_lotacao: this.parametros.key_lotacao,
                  nome_lotacao: this.lotacao,
                  ticket: contato[0].ticket,
                  telefone: contato[0].telefone,
                  id_canal: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  status_ticket: '1'
                };
                this.genProvider.onSaveObjeto('dados', this.parametros.path + '/chat/' + contato[0].protocolo, 'chat_body', dados_body);
                //   if (contato[0].ticket) {
                //     this.genProvider.onSaveObjeto('dados', this.parametros.path + '/ticket/' + contato[0].ticket, 'ticket_body', dados_body);
                //   }
                clearTimeout(contato[0].timeMsg)
                let msg = null;
                let t = setTimeout(() => {
                  if (contato[0].origem == "whatsapp") {
                    msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      header: contato[0].menu,
                      body: this.msg_recebida,
                      footer: this.titulo,
                      rows: [
                        {
                          type: "reply",
                          reply: {
                            id: '1',
                            title: 'Sim'
                          }
                        },
                        {
                          type: "reply",
                          reply: {
                            id: '2',
                            title: 'Não'
                          }
                        }
                      ]
                    };
                  } else {
                    msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: this.msg_recebida
                    };
                  }
                  this.enviarMsg(msg);
                }, (this.intervalo_msg_recebida * 1000));
                contato[0].timeMsg = t
                this.atualizaContato(contato[0]);
              }
            }
          } else if (contato[0].tipo == "Ticket NTE") {
            clearTimeout(contato[0].timeMsg)
            if (contato[0].conteudo === undefined) {
              contato[0].conteudo = '';
            }
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto =
                "{{2}}, sua solicitação de atendimento foi cancelada.";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              // this.onCancelaMsg(contato[0].protocolo,"chat","chat_body");
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
              this.pesquisaChat(contato[0].protocolo).then(res => {
                let data = JSON.parse(JSON.stringify(res));
                if (data.length > 0) {
                  this.excluirMensagemTicket(contato[0].protocolo, contato[0].ticket, contato[0].atendimento, contato[0]);
                }
              })
            } else if (mensagem.type == "chat" && !contato[0].nome) {
              if (mensagem.body.length < 3) {
                let texto =
                  "ATENÇÃO, você precisa informar um *nome* válido." +
                  this.ctrl +
                  this.ctrl +
                  "*A qualquer momento digite  0 para cancelar!*";
                let formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
                };
                this.enviarMsg(formulario);
              } else {
                contato[0].nome = mensagem.body
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: "Seu melhor *e-mail*, por favor.✉️"
                };
                this.enviarMsg(msg);
                this.atualizaContato(contato[0]);
              }
            } else if (mensagem.type == "chat" && !contato[0].telefone) {
              /*
              contato[0].nome = mensagem.body
              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: "Por favor qual su menlhor email"
              };
              this.enviarMsg(msg);
              this.atualizaContato(contato[0]);
              */

            } else if (mensagem.type == "chat" && !contato[0].email) {
              this.validaCampoProvider.validaEmail(mensagem.body).then(res => {
                if (!res) {
                  let texto =
                    "ATENÇÃO, você precisa informar um e-mail válido." +
                    this.ctrl +
                    this.ctrl +
                    "*A qualquer momento digite  0 para cancelar!*";
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
                  };
                  this.enviarMsg(formulario);
                } else {
                  contato[0].email = res
                  this.atualizaContato(contato[0]);
                  let msg1 = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: "🤝Agora vou abrir seu ticket."
                  };
                  this.enviarMsg(msg1);
                  let msg2 = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: "🤓 Assim que finalizar vou mandar uma cópia lá no seu 📧 e-mail"
                  };
                  setTimeout(() => {
                    this.enviarMsg(msg2);
                    let msg3 = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: contato[0].texto_menu + this.ctrl + this.msg_navegacao
                    };
                    setTimeout(() => {
                      this.enviarMsg(msg3);
                    }, 500);
                  }, 500);
                  /*
                                    let msg4 = {
                                      origem: contato[0].origem,
                                      contato: contato[0].id_canal,
                                      mensagem: "📮Seu novo ticket é o:👉 "+contato[0].ticket+" 👈"
                                    };
                                    setTimeout(() => {
                                      this.enviarMsg(msg3);
                                    }, 1000);
                                  */
                }
              })
            } else if ((opc == "1" || opc == "sim" || opc == "sin" || opc == "Sim" || opc == "#") && (contato[0].ticket)) {
              let dados_msg = {
                key: contato[0].protocolo,
                origem: contato[0].origem,
                image: "assets/icon/" + contato[0].origem.trim() + ".png",
                status: "Novo",
                novo: '1',
                time: Date.now(),
                data_criacao: Date.now(),
                ticket: contato[0].ticket,
                email: contato[0].email,
                nome: contato[0].nome
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
              let mensagem = {
                author: contato[0].telefone,
                id_canal: contato[0].id_canal,
                origem: contato[0].origem,
                image: "assets/icon/" + contato[0].origem.trim() + ".png",
                body: contato[0].menu,
                date: contato[0].time,
                senderName: contato[0].nome,
                type: "chat",
                notifica_usuario: true,
                value: "",
                email: contato[0].email,
                nome: contato[0].nome
              }
              let dados_ticket = {
                key: contato[0].ticket,
                status_ticket: "Novo",
                ticket: contato[0].ticket,
                protocolo: contato[0].protocolo,
                email: contato[0].email,
                nome: contato[0].nome
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "ticket", dados_ticket);
              let assunto = "Abertura de Chamado Ticket Nº " + contato[0].ticket;
              let msg_resp = "Abertura de Chamado Ticket Nº " + contato[0].ticket + this.ctrl;
              msg_resp += 'Data: ' + new DatePipe('pt-BR').transform(Date.now(), 'd, MMMM yyyy - HH:mm') + this.ctrl
              msg_resp += 'Status: Registrado' + this.ctrl
              msg_resp += 'Opção de atendimento: ' + contato[0].menu + this.ctrl
              msg_resp += 'Aberta por : ' + contato[0].nome + this.ctrl + this.ctrl
              msg_resp += 'Nosso *TMA* é de 4 horas no horário comercial, e de 24 horas para tratativas.' + this.ctrl + this.ctrl
              msg_resp += '*Esta é uma mensagem automática, não responda* 😉'


              let $mensagem = "<h3><FONT COLOR=red>Abertura de Chamado Ticket Nº " + contato[0].ticket + "</FONT></h3><br><br>" +
                "<b>Data: </b><i>" + new DatePipe('pt-BR').transform(Date.now(), 'd, MMMM yyyy - HH:mm') + "</i></FONT><br><br>" +
                "<b>Status: </b><i>Registrado</i><br><br>" +
                "<b>Assunto: </b><i>" + contato[0].menu + "</i><br><br>" +
                "<b>Aberta por: </b>" + contato[0].nome + "<br/><br>" + contato[0].conteudo + "<br><br>" +
                "<b>TMA (Tempo Médio de Atendimento) 4 horas; TMR (Tempo Médio de Resposta) 24 horas, todos no horário de atendimento comercial.</b><br>" +
                "<b>Esta é uma mensagem automática, não responda!</b></br>"

              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: msg_resp
              };
              // console.log (encodeURI(msg_resp))
              //             console.log (decodeURI(msg_resp))
              // enviar email p/ ticket
              let email = {
                contato: contato[0].email,
                assunto: assunto,
                mensagem: $mensagem
              }
              this.onSendEmail(email)
              let data_movto = {
                ticket: contato[0].ticket,
                protocolo: contato[0].protocolo,
                status: 'Novo',
                key_usuario: '000000',
                key_lotacao: null,
                key_lotacao_tramitacao: null,
                key_usuario_destino: null,
                key_puc: null,
                time: Date.now(),
                canal: contato[0].origem,
                conteudo: "Ticket aberto por agentBot"
              }
              this.genProvider.onSaveObjeto('dados', this.parametros.path, 'ticket_movimentacao', data_movto);
              let msg2 = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: "📮Anote seu novo ticket:👉 " + contato[0].ticket + " 👈"
              };
              //  setTimeout(() => {
              this.enviarMsg(msg);
              this.enviarMsg(msg2);
              setTimeout(() => {
                this.onFinalizaAtendimento(contato);
              }, 1000);
            } else {
              if (opc == "2" || opc == "não" || opc == "nao" || opc == "Não") {
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: "Continue com sua mensagem."
                };
                this.enviarMsg(msg);
              } else {
                if (!contato[0].ticket) {
                  let dados_ticket = {
                    status_ticket: "Enviando",
                    compartilhado: false,
                    copia_usuario: false,
                    distribuicao: false,
                    encaminhado: false,
                    encerrado: false,
                    status: "Recebido",
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    key_puc: contato[0].key_puc,
                    nome_usuario: this.parametros.nome,
                    key_usuario: this.parametros.key_usuario,
                    key_solicitante: contato[0].telefone,
                    nome_solicitante: contato[0].nome,
                    key_catalogo: '',
                    nome_catalogo: '',
                    key_subcatalogo: '',
                    nome_subcatalogo: '',
                    key_lotacao: '',
                    nome_lotacao: '',
                    canal: contato[0].origem,
                    conteudo: '',
                    time: Date.now(),
                    data_criacao: Date.now(),
                    enviar_resposta_solicitante: true,
                    id_canal: contato[0].id_canal,
                    key_responsavel: null,
                    nome_responsavel: null,
                    observacao_interna: "",
                    qtd_interacao: "",
                    resposta: "",
                    telefone: contato[0].telefone,
                    type: mensagem.type,
                    tipo_ticket: "Externo",
                    titulo_ticket: contato[0].menu,
                    prioridade: 'Nenhuma',
                    tramitacao: '0'
                  };
                  let dados = {
                    status: "Enviando",
                    origem: contato[0].origem,
                    acesso: contato[0].acesso,
                    key_puc: contato[0].key_puc,
                    image: "assets/icon/" + contato[0].origem.trim() + ".png",
                    bloqueado: false,
                    coordenadas: contato[0].coordenadas,
                    data_nascimento: "",
                    invalida: contato[0].invalida,
                    localizacao: contato[0].localizacao,
                    nivel: contato[0].nivel,
                    nome: contato[0].nome,
                    nome_solicitante: contato[0].nome,
                    telefone: contato[0].telefone,
                    id_canal: contato[0].id_canal,
                    tipo: contato[0].tipo,
                    key_pergunta: contato[0].key_pergunta,
                    protocolo: contato[0].protocolo,
                    key_master: contato[0].key_master,
                    key_child: contato[0].key_child,
                    menu: contato[0].menu,
                    type: mensagem.type,
                    value: mensagem.body,
                    time: Date.now(),
                    data_criacao: Date.now(),
                    data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
                    notifica_usuario: false
                  };
                  this.genProvider.onSaveIncrementZeroDate("dados/" + this.parametros.path + "/ticket", dados_ticket, "ticket", 6).then(t => {
                    contato[0].ticket = t
                    //  this.genProvider.onSaveObjeto('dados', this.parametros.path + '/ticket/' + contato[0].ticket, 'ticket_body', dados_body);
                    let atendimento = {
                      status: "Novo",
                      protocolo: contato[0].protocolo,
                      ticket: contato[0].ticket,
                      key_puc: contato[0].key_puc,
                      key_usuario: null,
                      key_solicitante: contato[0].telefone,
                      nome_solicitante: contato[0].nome,
                      origem: contato[0].origem,
                      id_canal: contato[0].id_canal,
                      telefone: contato[0].telefone,
                      data_criacao: Date.now(),
                      time: Date.now(),
                      tempo: ''
                    };
                    this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/atendimento", atendimento.protocolo, atendimento).then(key => {
                      //  this.genProvider.onSaveIncrement("dados/" + this.parametros.path + "/atendimento", atendimento, "atendimento").then(key => {
                      contato[0].atendimento = key
                    })
                  })
                  this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/chat", dados.protocolo, dados);
                  this.atualizaContato(contato[0])
                }
                let dados_body: any;

                dados_body = {
                  protocolo: contato[0].protocolo,
                  status: 'Recebida',
                  tipo: 'publica',
                  key_usuario: this.parametros.key_usuario,
                  nome_usuario: this.parametros.nome_usuario,
                  key_lotacao: this.parametros.key_lotacao,
                  nome_lotacao: this.lotacao,
                  ticket: contato[0].ticket,
                  telefone: contato[0].telefone,
                  id_canal: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  status_ticket: '1'
                };
                if (mensagem.type == "chat") {
                  contato[0].conteudo = contato[0].conteudo + mensagem.body + this.ctrl;
                }
                this.genProvider.onSaveObjeto('dados', this.parametros.path + '/chat/' + contato[0].protocolo, 'chat_body', dados_body);
                //   if (contato[0].ticket) {
                //      this.genProvider.onSaveObjeto('dados', this.parametros.path + '/ticket/' + contato[0].ticket, 'ticket_body', dados_body);
                //    }
                clearTimeout(contato[0].timeMsg)
                let msg = null;
                let t = setTimeout(() => {
                  if (contato[0].origem == "whatsapp") {
                    msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      header: contato[0].menu,
                      body: this.msg_recebida,
                      footer: this.titulo,
                      rows: [
                        {
                          type: "reply",
                          reply: {
                            id: '1',
                            title: 'Sim'
                          }
                        },
                        {
                          type: "reply",
                          reply: {
                            id: '2',
                            title: 'Não'
                          }
                        }
                      ]
                    };
                  } else {
                    msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: this.msg_recebida
                    };
                  }
                  this.enviarMsg(msg);
                }, (this.intervalo_msg_recebida * 1000));
                contato[0].timeMsg = t
                this.atualizaContato(contato[0]);
              }
            }
          } else if (contato[0].tipo == "Template") {
            //            clearTimeout(contato[0].timeMsg)
            if (contato[0].conteudo === undefined) {
              contato[0].conteudo = '';
            }
            let opc = mensagem.body.replace(/\D/g, "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto =
                "{{2}}, sua solicitação de atendimento foi cancelada.";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              // this.onCancelaMsg(contato[0].protocolo,"chat","chat_body");
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
              this.pesquisaChat(contato[0].protocolo).then(res => {
                let data = JSON.parse(JSON.stringify(res));
                if (data.length > 0) {
                  this.excluirMensagemTicket(contato[0].protocolo, contato[0].ticket, contato[0].atendimento, contato[0]);
                }
              })
            }
            if (opc == "#finalizar") {
              let dados_msg = {
                key: contato[0].protocolo,
                key_template: contato[0].key_template,
                origem: contato[0].origem,
                image: "assets/icon/" + contato[0].origem.trim() + ".png",
                status: "Novo",
                novo: '1',
                time: Date.now(),
                data_criacao: Date.now(),
                nome: contato[0].nome,
                value: contato[0].conteudo
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
              this.onSavePerguntaTemplate(contato[0].protocolo);
              if (this.parametros.webhookDenuncia) {
                let msg2 = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: "📮Sua mensagem foi finalizada com sucesso!" + this.ctrl + "Anote seu protocolo 👉 " + contato[0].protocolo + " 👈"
                };
                this.enviarMsg(msg2);
              }
              setTimeout(() => {
                this.onFinalizaAtendimento(contato);
              }, 1000);
              contato[0].finaliza = true;
            }
            if (!contato[0].resgistrando) {
              let dados = {
                status: "registrando",
                origem: contato[0].origem,
                acesso: contato[0].acesso,
                key_puc: contato[0].key_puc,
                image: "assets/icon/" + contato[0].origem.trim() + ".png",
                bloqueado: false,
                coordenadas: contato[0].coordenadas,
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                nome_solicitante: contato[0].nome,
                telefone: contato[0].telefone,
                id_canal: contato[0].id_canal,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                menu: contato[0].menu,
                type: mensagem.type,
                value: "Denúncia Anônima",
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm"),
                notifica_usuario: false
              };
              let atendimento = {
                status: "novo",
                protocolo: contato[0].protocolo,
                key_puc: contato[0].key_puc,
                key_usuario: null,
                key_solicitante: contato[0].telefone,
                nome_solicitante: contato[0].nome,
                origem: contato[0].origem,
                id_canal: contato[0].id_canal,
                telefone: contato[0].telefone,
                data_criacao: Date.now(),
                time: Date.now(),
                tempo: ''
              };
              this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/atendimento", atendimento.protocolo, atendimento).then(key => {
                contato[0].atendimento = key
              })
              this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/chat", dados.protocolo, dados);
              contato[0].resgistrando = true;
              this.atualizaContato(contato[0])
            }
            // gravar interacao
            if (!contato[0].finaliza) {
              let dados_body = {
                protocolo: contato[0].protocolo,
                telefone: contato[0].telefone,
                id_canal: contato[0].telefone,
                type: 'chat',
                value: contato[0].titulo_pergunta,
                field: contato[0].field,
                pergunta: true,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto('dados', this.parametros.path + '/chat/' + contato[0].protocolo, 'chat_body', dados_body);
              if (mensagem.type == "chat") {
                contato[0].conteudo = contato[0].conteudo + dados_body.value + this.ctrl;
              }
              dados_body = {
                protocolo: contato[0].protocolo,
                telefone: contato[0].telefone,
                id_canal: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                field: contato[0].field,
                pergunta: false,
                time: Date.now() + 1,
                data_criacao: Date.now() + 1,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto('dados', this.parametros.path + '/chat/' + contato[0].protocolo, 'chat_body', dados_body);

              contato[0].titulo_pergunta = '';
              contato[0].acao = null;
              contato[0].value = null;
              this.atualizaContato(contato[0]);
            }
            if (contato[0].n_pergunta >= 1) {
              /*
              console.log (contato[0].validacao)
              console.log (contato[0].acao)
              console.log (contato[0].type)
              console.log (contato[0].value)
              */

              let n_temp = contato[0].n_pergunta - 1
              let temp = contato[0].template[n_temp]
              if (contato[0].n_pergunta > contato[0].template.length) {
                console.log("Finaliza")
                let dados_msg = {
                  key: contato[0].protocolo,
                  key_template: contato[0].key_template,
                  origem: contato[0].origem,
                  image: "assets/icon/" + contato[0].origem.trim() + ".png",
                  status: "Novo",
                  novo: '1',
                  time: Date.now(),
                  data_criacao: Date.now(),
                  nome: contato[0].nome,
                  value: contato[0].conteudo
                };
                this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
                this.onSavePerguntaTemplate(contato[0].protocolo);
                if (this.parametros.webhookDenuncia) {
                  let msg2 = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: "📮Sua mensagem foi finalizada com sucesso!" + this.ctrl + "Anote seu protocolo 👉 " + contato[0].protocolo + " 👈"
                  };
                  this.enviarMsg(msg2);
                }
                setTimeout(() => {
                  this.onFinalizaAtendimento(contato);
                }, 1000);
                contato[0].finaliza = true;
              } else if (contato[0].validacao != null) {
                if (contato[0].validacao == 'texto' && mensagem.body.length < 1) {
                  let msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: temp.respota_false
                  }
                  this.enviarMsg(msg);
                  contato[0].acao = null;
                  contato[0].value = null;
                  contato[0].n_pergunta = contato[0].n_pergunta - 1;
                  this.atualizaContato(contato[0]);
                  setTimeout(() => {
                    this.onTemplateShow(contato);
                  }, 1000);
                } else if (contato[0].validacao == 'email') {
                  this.validaCampoProvider.validaEmail(mensagem.body).then(res => {
                    if (res == null) {
                      let msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: temp.respota_false
                      }
                      this.enviarMsg(msg);
                      contato[0].acao = null;
                      contato[0].value = null;
                      contato[0].n_pergunta = contato[0].n_pergunta - 1;
                      this.atualizaContato(contato[0]);
                      setTimeout(() => {
                        this.onTemplateShow(contato);
                      }, 1000);

                    } else {
                      this.onTemplateShow(contato);
                    }
                  })
                } else if (contato[0].validacao == 'celular') {
                  this.validaCampoProvider.validaCelular(mensagem.body).then(res => {
                    if ((res == null) || (res == false)) {
                      let msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: temp.respota_false
                      }
                      this.enviarMsg(msg);
                      contato[0].acao = null;
                      contato[0].value = null;
                      contato[0].n_pergunta = contato[0].n_pergunta - 1;
                      this.atualizaContato(contato[0]);
                      setTimeout(() => {
                        this.onTemplateShow(contato);
                      }, 1000);

                    } else {
                      this.onTemplateShow(contato);
                    }
                  })
                } else if (contato[0].validacao == 'cpf') {
                  this.validaCampoProvider.valida_cpf(mensagem.body).then(res => {
                    if ((res == null) || (res == false)) {
                      let msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: temp.respota_false
                      }
                      this.enviarMsg(msg);
                      contato[0].acao = null;
                      contato[0].value = null;
                      contato[0].n_pergunta = contato[0].n_pergunta - 1;
                      this.atualizaContato(contato[0]);
                      setTimeout(() => {
                        this.onTemplateShow(contato);
                      }, 1000);

                    } else {
                      this.onTemplateShow(contato);
                    }
                  })
                } else if (contato[0].validacao == 'cnpj') {
                  this.validaCampoProvider.valida_cnpj(mensagem.body).then(res => {
                    if ((res == null) || (res == false)) {
                      let msg = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: temp.respota_false
                      }
                      this.enviarMsg(msg);
                      contato[0].acao = null;
                      contato[0].value = null;
                      contato[0].n_pergunta = contato[0].n_pergunta - 1;
                      this.atualizaContato(contato[0]);
                      setTimeout(() => {
                        this.onTemplateShow(contato);
                      }, 1000);

                    } else {
                      this.onTemplateShow(contato);
                    }
                  })
                } else if (contato[0].validacao == 'imagem') {
                  if (contato[0].type != 'jpeg') {
                    let msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: temp.respota_false
                    }
                    this.enviarMsg(msg);
                    contato[0].acao = null;
                    contato[0].value = null;
                    contato[0].n_pergunta = contato[0].n_pergunta - 1;
                    this.atualizaContato(contato[0]);
                    setTimeout(() => {
                      this.onTemplateShow(contato);
                    }, 1000);

                  } else {
                    this.onTemplateShow(contato);
                  }
                } else if (contato[0].validacao == 'video') {
                  if (contato[0].type != 'mp4') {
                    let msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: temp.respota_false
                    }
                    this.enviarMsg(msg);
                    contato[0].acao = null;
                    contato[0].value = null;
                    contato[0].n_pergunta = contato[0].n_pergunta - 1;
                    this.atualizaContato(contato[0]);
                    setTimeout(() => {
                      this.onTemplateShow(contato);
                    }, 1000);

                  } else {
                    this.onTemplateShow(contato);
                  }
                } else if (contato[0].validacao == 'audio') {
                  if (contato[0].type != 'ogg') {
                    let msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: temp.respota_false
                    }
                    this.enviarMsg(msg);
                    contato[0].acao = null;
                    contato[0].value = null;
                    contato[0].n_pergunta = contato[0].n_pergunta - 1;
                    this.atualizaContato(contato[0]);
                    setTimeout(() => {
                      this.onTemplateShow(contato);
                    }, 1000);

                  } else {
                    this.onTemplateShow(contato);
                  }
                } else if (contato[0].validacao == 'documento') {
                  if (contato[0].type != 'pdf') {
                    let msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: temp.respota_false
                    }
                    this.enviarMsg(msg);
                    contato[0].acao = null;
                    contato[0].value = null;
                    contato[0].n_pergunta = contato[0].n_pergunta - 1;
                    this.atualizaContato(contato[0]);
                    setTimeout(() => {
                      this.onTemplateShow(contato);
                    }, 1000);

                  } else {
                    this.onTemplateShow(contato);
                  }
                } else if (contato[0].validacao == 'conteudo') {
                  let msg_finaliza = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    header: contato[0].menu,
                    body: this.msg_recebida,
                    footer: this.titulo,
                    rows: [
                      {
                        type: "reply",
                        reply: {
                          id: 'Sim',
                          title: 'Sim, já finalizei'
                        }
                      }
                    ]
                  };
                  if (mensagem.body != 'Sim') {
                    this.enviarMsg(msg_finaliza);
                  } else {
                    let i = contato[0].n_pergunta + 1
                    if (i > contato[0].template.length) {
                      this.onFinalizaTemplate(contato);
                    } else {
                      console.log(mensagem.body)
                      contato[0].validacao = null;
                      contato[0].acao = null;
                      contato[0].value = null;
                      contato[0].type = null
                      this.atualizaContato(contato[0]);
                      this.onTemplateShow(contato);
                    }
                  }
                } else {
                  this.onTemplateShow(contato);
                }
              } else if (temp.rows) {
                let resposta = temp.rows.filter(obj => {
                  return obj.id == mensagem.body
                })
                if (resposta.length == 0) {
                  let msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: "Por favor selecione um dos botões!"
                  }
                  this.enviarMsg(msg);
                  contato[0].acao = null;
                  contato[0].value = null;
                  contato[0].n_pergunta = contato[0].n_pergunta - 1;
                  this.atualizaContato(contato[0]);
                  setTimeout(() => {
                    this.onTemplateShow(contato);
                  }, 1000);

                } else {
                  let acao = temp.rows;
                  let result = acao.filter(obj => {
                    return obj.id == mensagem.body
                  })
                  if (result.length > 0) {
                    if (result[0].acao == 'goto') {
                      let link = contato[0].template.filter(res => {
                        return res.numero == result[0].value
                      })
                      console.log(link)
                      if (link.length > 0) {
                        let i = contato[0].template.indexOf(link[0]);
                        contato[0].n_pergunta = i
                        this.atualizaContato(contato[0]);
                        this.onTemplateShowAll(contato)
                      }
                    } else if (result[0].acao == '0') {
                      let texto =
                        "Sua solicitação de atendimento foi cancelada.";
                      let formulario = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

                      };
                      // this.onCancelaMsg(contato[0].protocolo,"chat","chat_body");
                      this.enviarMsg(formulario);
                      this.onOpcaochat(contato, "0");
                    } else if (result[0].acao == 'sair') {
                      let texto =
                        "Seu atendimento esta sendo finalizado.";
                      let formulario = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
                      };
                      // this.onCancelaMsg(contato[0].protocolo,"chat","chat_body");
                      this.enviarMsg(formulario);
                      this.onOpcaochat(contato, "-1");
                    } else if (result[0].acao == '#finalizar') {
                      let dados_msg = {
                        key: contato[0].protocolo,
                        key_template: contato[0].key_template,
                        origem: contato[0].origem,
                        image: "assets/icon/" + contato[0].origem.trim() + ".png",
                        status: "Novo",
                        novo: '1',
                        time: Date.now(),
                        data_criacao: Date.now(),
                        nome: contato[0].nome,
                        value: contato[0].conteudo
                      };
                      this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
                      this.onSavePerguntaTemplate(contato[0].protocolo);
                      if (this.parametros.webhookDenuncia) {
                        let msg2 = {
                          origem: contato[0].origem,
                          contato: contato[0].id_canal,
                          mensagem: "📮Sua mensagem foi finalizada com sucesso!" + this.ctrl + "Anote seu protocolo 👉 " + contato[0].protocolo + " 👈"
                        };
                        this.enviarMsg(msg2);
                      }
                      setTimeout(() => {
                        this.onFinalizaAtendimento(contato);
                      }, 1000);
                      contato[0].finaliza = true;
                    } else {
                      this.onTemplateShow(contato)
                    }
                  }
                }
              } else {
                if (temp.type == 'list') {
                  let resposta = temp.rows.filter(obj => {
                    return obj.id == mensagem.body
                  })
                  if (resposta.length == 0) {
                    let msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: "Por favor selecione uma das opções da lista!"
                    }
                    this.enviarMsg(msg);
                    contato[0].acao = null;
                    contato[0].value = null;
                    contato[0].n_pergunta = contato[0].n_pergunta - 1;
                    this.atualizaContato(contato[0]);
                    setTimeout(() => {
                      this.onTemplateShow(contato);
                    }, 1000);

                  } else {
                    this.onTemplateShow(contato);
                  }
                } else if (temp.type == 'reply') {
                  let resposta = temp.rows.filter(obj => {
                    return obj.id == mensagem.body
                  })
                  if (resposta.length == 0) {
                    let msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: "Por favor selecione um dos botões!"
                    }
                    this.enviarMsg(msg);
                    contato[0].acao = null;
                    contato[0].value = null;
                    contato[0].n_pergunta = contato[0].n_pergunta - 1;
                    this.atualizaContato(contato[0]);
                    setTimeout(() => {
                      this.onTemplateShow(contato);
                    }, 1000);

                  } else {
                    this.onTemplateShow(contato);
                  }
                } else {
                  this.onTemplateShow(contato);
                }
              }
            }
          } else if (contato[0].tipo == "Denuncia Localizacao") {
            clearTimeout(contato[0].timeMsg)
            let opc = mensagem.body.replace(" ", "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "denuncia",
                "denuncia_body"
              );
              this.enviarMsg(formulario);
              //              setTimeout(() => {
              this.onOpcaochat(contato, "0");
              //            }, 5000);
            } else if (mensagem.type == "location" && !contato[0].localizacao) {
              this.onLocalizacao(mensagem.body).then(res => {
                let dados = {
                  status: "Enviando...",
                  origem: contato[0].origem,
                  acesso: contato[0].acesso,
                  bloqueado: contato[0].bloqueado,
                  //   messageNumber: mensagem.messageNumber,
                  coordenadas: mensagem.body,
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  data_nascimento: "",
                  invalida: contato[0].invalida,
                  localizacao: res,
                  nivel: contato[0].nivel,
                  nome: contato[0].nome,
                  telefone: contato[0].telefone,
                  id_canal: contato[0].id_canal,
                  tipo: contato[0].tipo,
                  key_pergunta: contato[0].key_pergunta,
                  protocolo: contato[0].protocolo,
                  key_master: contato[0].key_master,
                  key_child: contato[0].key_child,
                  menu: contato[0].menu,
                  type: mensagem.type,
                  value: mensagem.body,
                  time: Date.now()
                };

                let dados_body = {
                  protocolo: contato[0].protocolo,
                  //    messageNumber: mensagem.messageNumber,
                  telefone: contato[0].telefone,
                  type: mensagem.type,
                  value: mensagem.body,
                  coordenadas: mensagem.body,
                  localizacao: res,
                  time: Date.now(),
                  data_criacao: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  )
                };
                this.genProvider.onSaveDocKey(
                  "dados/" + this.parametros.path + "/denuncia",
                  dados.protocolo,
                  dados
                ); // atualiza o registro com a mesma chave
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "denuncia_body",
                  dados_body
                );

                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: this.msg_denuncia
                };
                this.enviarMsg(msg);
                contato[0].localizacao = true;
                this.atualizaContato(contato[0]);
              });
            } else if (mensagem.type != "location" && !contato[0].localizacao) {
              let texto =
                "ATENÇÃO, você precisa primeiro enviar a localização para prosseguir com a sua denúncia." +
                this.ctrl +
                this.ctrl +
                "*A qualquer momento digite  0⃣ para cancelar!*";
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.enviarMsg(formulario);
            } else if (opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Novo"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
              // colocar aqui a finalizacao na base de dados colocar um flat de mensagem finalizada e enviar
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                //    messageNumber: mensagem.messageNumber,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                id_canal: contato[0].id_canal,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                menu: contato[0].menu,
                countNatureza: contato[0].countNatureza,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                natureza: contato[0].natureza
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                //      messageNumber: mensagem.messageNumber,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveDocKey(
                "dados/" + this.parametros.path + "/denuncia",
                dados.protocolo,
                dados
              ); // atualiza o registro com a mesma chave
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia_body",
                dados_body
              );

              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: this.msg_recebida
              };
              this.enviarMsg(msg);
            }
          } else if (contato[0].tipo == "Denuncia Natureza_old") {
            let opc = mensagem.body.replace(" ", "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "denuncia",
                "denuncia_body"
              );
              this.enviarMsg(formulario);
              //              setTimeout(() => {
              this.onOpcaochat(contato, "0");
              //            }, 5000);
            } else if (contato[0].countNatureza == -2) {
              let opcao = mensagem.body.substring(0, 1).toLowerCase();
              if (opcao == "s") {
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem:
                    "Agora você já pode continuar com a sua denúncia, você pode enviar vídeos, audios, localização e textos."
                };
                this.enviarMsg(msg);
                contato[0].countNatureza = -1;
                this.atualizaContato(contato[0]);
              } else {
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: "Digite novamente o tipo da denúncia."
                };
                this.enviarMsg(msg);
                contato[0].countNatureza = 0;
                this.atualizaContato(contato[0]);
              }
            } else if (contato[0].countNatureza >= 0) {
              this.pesquisaPerguntachatbot(
                mensagem.body,
                this.natureza,
                0
              ).then(res => {
                let result = JSON.parse(JSON.stringify(res));
                if (result.length > 0) {
                  let dados = {
                    status: "Enviando...",
                    acesso: contato[0].acesso,
                    bloqueado: contato[0].bloqueado,
                    coordenadas: contato[0].coordenadas,
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    data_nascimento: "",
                    invalida: contato[0].invalida,
                    localizacao: contato[0].localizacao,
                    nivel: contato[0].nivel,
                    nome: contato[0].nome,
                    telefone: contato[0].telefone,
                    id_canal: contato[0].id_canal,
                    tipo: contato[0].tipo,
                    key_pergunta: contato[0].key_pergunta,
                    protocolo: contato[0].protocolo,
                    key_master: contato[0].key_master,
                    key_child: contato[0].key_child,
                    menu: contato[0].menu,
                    countNatureza: contato[0].countNatureza,
                    type: mensagem.type,
                    value: mensagem.body,
                    time: Date.now(),
                    data_criacao: Date.now(),
                    natureza: result[0].nome
                  };

                  this.genProvider.onSaveDocKey(
                    "dados/" + this.parametros.path + "/denuncia",
                    dados.protocolo,
                    dados
                  ); // atualiza o registro com a mesma chave
                  let msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      result[0].resposta +
                      this.ctrl +
                      this.ctrl +
                      "*Para confirmar o tipo de denúncia digite apenas _S_ para SIM ou _N_ digitar outra.*"
                  };
                  this.enviarMsg(msg);
                  contato[0].natureza = result[0].nome;
                  contato[0].countNatureza = -2;
                  this.atualizaContato(contato[0]);
                } else {
                  if (contato[0].countNatureza == 3) {
                    let dados = {
                      status: "Enviando...",
                      acesso: contato[0].acesso,
                      bloqueado: contato[0].bloqueado,
                      coordenadas: contato[0].coordenadas,
                      data_hora: new DatePipe("pt-BR").transform(
                        Date.now(),
                        "d, MMMM yyyy - HH:mm"
                      ),
                      data_nascimento: "",
                      invalida: contato[0].invalida,
                      localizacao: contato[0].localizacao,
                      nivel: contato[0].nivel,
                      nome: contato[0].nome,
                      telefone: contato[0].telefone,
                      id_canal: contato[0].id_canal,
                      tipo: contato[0].tipo,
                      key_pergunta: contato[0].key_pergunta,
                      protocolo: contato[0].protocolo,
                      key_master: contato[0].key_master,
                      key_child: contato[0].key_child,
                      menu: contato[0].menu,
                      countNatureza: contato[0].countNatureza,
                      type: mensagem.type,
                      value: mensagem.body,
                      time: Date.now(),
                      data_criacao: Date.now(),
                      natureza: "OUTRO"
                    };
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/denuncia",
                      dados.protocolo,
                      dados
                    ); // atualiza o registro com a mesma chave
                    let msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: this.msg_padrao_denuncia
                    };
                    this.enviarMsg(msg);
                    contato[0].natureza = "OUTRO";
                    contato[0].countNatureza = -1;
                    this.atualizaContato(contato[0]);
                  } else {
                    contato[0].countNatureza = contato[0].countNatureza + 1;
                    let texto =
                      "ATENÇÃO, você precisa primeiro informar qual tipo de delito vc quer denunciar." +
                      this.ctrl +
                      this.ctrl +
                      "*A qualquer momento digite  0⃣ para cancelar!*";
                    if (contato[0].countNatureza == 1) {
                      texto = this.invalida01_padrao_denuncia;
                    } else if (contato[0].countNatureza == 2) {
                      texto = this.invalida02_padrao_denuncia;
                    } else if (contato[0].countNatureza == 3) {
                      texto = this.invalida03_padrao_denuncia;
                    }
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

                    };
                    this.enviarMsg(formulario);
                    this.atualizaContato(contato[0]);
                  }
                }
              });
            } else if (opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Novo"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
              // colocar aqui a finalizacao na base de dados colocar um flat de mensagem finalizada e enviar
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                menu: contato[0].menu,
                countNatureza: contato[0].countNatureza,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                natureza: contato[0].natureza
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveDocKey(
                "dados/" + this.parametros.path + "/denuncia",
                dados.protocolo,
                dados
              ); // atualiza o registro com a mesma chave
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia_body",
                dados_body
              );

              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: this.msg_recebida
              };
              this.enviarMsg(msg);
            }
          } else if (contato[0].tipo == "Denuncia Natureza") {
            clearTimeout(contato[0].timeMsg)
            let opc = mensagem.body.replace(" ", "").trim();
            if ((opc == "0") || (opc == "cancela") || (opc == "cancelar")) {
              let texto = this.cancela_mensagem;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              this.onCancelaMsg(
                contato[0].protocolo,
                "denuncia",
                "denuncia_body"
              );
              this.enviarMsg(formulario);
              this.onOpcaochat(contato, "0");
            } else if (contato[0].countNatureza >= 0) {
              this.pesquisaPerguntachatbot(
                mensagem.body,
                this.natureza,
                0
              ).then(res => {
                let result = JSON.parse(JSON.stringify(res));
                if (result.length > 0) {
                  let dados = {
                    status: "Enviando...",
                    acesso: contato[0].acesso,
                    bloqueado: contato[0].bloqueado,
                    coordenadas: contato[0].coordenadas,
                    //  messageNumber: mensagem.messageNumber,
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    data_nascimento: "",
                    invalida: contato[0].invalida,
                    localizacao: contato[0].localizacao,
                    nivel: contato[0].nivel,
                    nome: contato[0].nome,
                    telefone: contato[0].telefone,
                    id_canal: contato[0].id_canal,
                    tipo: contato[0].tipo,
                    key_pergunta: contato[0].key_pergunta,
                    protocolo: contato[0].protocolo,
                    key_master: contato[0].key_master,
                    key_child: contato[0].key_child,
                    menu: contato[0].menu,
                    countNatureza: contato[0].countNatureza,
                    type: mensagem.type,
                    value: mensagem.body,
                    time: Date.now(),
                    data_criacao: Date.now(),
                    natureza: result[0].nome
                  };

                  this.genProvider.onSaveDocKey(
                    "dados/" + this.parametros.path + "/denuncia",
                    dados.protocolo,
                    dados
                  ); // atualiza o registro com a mesma chave
                  let msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      result[0].resposta +
                      this.ctrl +
                      this.ctrl +
                      "Para cancelar esta denúncia é so digitar e enviar *_0_* (Zero)"
                  };
                  this.enviarMsg(msg);
                  contato[0].natureza = result[0].nome;
                  contato[0].countNatureza = -1;
                  this.atualizaContato(contato[0]);
                } else {
                  if (contato[0].countNatureza == 3) {
                    let dados = {
                      status: "Enviando...",
                      acesso: contato[0].acesso,
                      bloqueado: contato[0].bloqueado,
                      coordenadas: contato[0].coordenadas,
                      //   messageNumber: mensagem.messageNumber,
                      data_hora: new DatePipe("pt-BR").transform(
                        Date.now(),
                        "d, MMMM yyyy - HH:mm"
                      ),
                      data_nascimento: "",
                      invalida: contato[0].invalida,
                      localizacao: contato[0].localizacao,
                      nivel: contato[0].nivel,
                      nome: contato[0].nome,
                      telefone: contato[0].telefone,
                      id_canal: contato[0].id_canal,
                      tipo: contato[0].tipo,
                      key_pergunta: contato[0].key_pergunta,
                      protocolo: contato[0].protocolo,
                      key_master: contato[0].key_master,
                      key_child: contato[0].key_child,
                      menu: contato[0].menu,
                      countNatureza: contato[0].countNatureza,
                      type: mensagem.type,
                      value: mensagem.body,
                      time: Date.now(),
                      data_criacao: Date.now(),
                      natureza: "OUTRO"
                    };
                    this.genProvider.onSaveDocKey(
                      "dados/" + this.parametros.path + "/denuncia",
                      dados.protocolo,
                      dados
                    ); // atualiza o registro com a mesma chave
                    let msg = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: this.msg_padrao_denuncia
                    };
                    this.enviarMsg(msg);
                    contato[0].natureza = "OUTRO";
                    contato[0].countNatureza = -1;
                    this.atualizaContato(contato[0]);
                  } else {
                    contato[0].countNatureza = contato[0].countNatureza + 1;
                    let texto = "";
                    if (contato[0].countNatureza == 1) {
                      texto = this.invalida01_padrao_denuncia;
                    } else if (contato[0].countNatureza == 2) {
                      texto = this.invalida02_padrao_denuncia;
                    } else if (contato[0].countNatureza == 3) {
                      texto = this.invalida03_padrao_denuncia;
                    }
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

                    };
                    this.enviarMsg(formulario);
                    this.atualizaContato(contato[0]);
                  }
                }
              });
            } else if (opc == "#") {
              let dados_msg = {
                key: contato[0].protocolo,
                status: "Novo"
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia",
                dados_msg
              );
              this.onFinalizaAtendimento(contato);
              // colocar aqui a finalizacao na base de dados colocar um flat de mensagem finalizada e enviar
              // para webhook verificar tambem no temporizador para finalizar e mandar para o webhook tamnem
            } else {
              let dados = {
                status: "Enviando...",
                acesso: contato[0].acesso,
                bloqueado: contato[0].bloqueado,
                coordenadas: contato[0].coordenadas,
                // messageNumber: mensagem.messageNumber,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                data_nascimento: "",
                invalida: contato[0].invalida,
                localizacao: contato[0].localizacao,
                nivel: contato[0].nivel,
                nome: contato[0].nome,
                telefone: contato[0].telefone,
                id_canal: contato[0].id_canal,
                tipo: contato[0].tipo,
                key_pergunta: contato[0].key_pergunta,
                protocolo: contato[0].protocolo,
                key_master: contato[0].key_master,
                key_child: contato[0].key_child,
                menu: contato[0].menu,
                countNatureza: contato[0].countNatureza,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                natureza: contato[0].natureza
              };
              let dados_body = {
                protocolo: contato[0].protocolo,
                //  messageNumber: mensagem.messageNumber,
                telefone: contato[0].telefone,
                type: mensagem.type,
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveDocKey(
                "dados/" + this.parametros.path + "/denuncia",
                dados.protocolo,
                dados
              ); // atualiza o registro com a mesma chave
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "denuncia_body",
                dados_body
              );
              clearTimeout(contato[0].timeMsg)
              let msg = null;
              let t = setTimeout(() => {
                if (contato[0].origem == "whatsapp") {
                  msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    header: contato[0].menu,
                    body: this.msg_recebida,
                    footer: this.titulo,
                    rows: [
                      {
                        type: "reply",
                        reply: {
                          id: '1',
                          title: 'Sim'
                        }
                      },
                      {
                        type: "reply",
                        reply: {
                          id: '2',
                          title: 'Não'
                        }
                      }
                    ]
                  };
                } else {
                  msg = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: this.msg_recebida
                  };
                }
                this.enviarMsg(msg);
              }, (this.intervalo_msg_recebida * 1000));
              contato[0].timeMsg = t
              this.atualizaContato(contato[0]);

            }
          } else if (contato[0].tipo == "whatscall") {
            if (contato[0].nivel == 200) {
              let whatscall = {
                telefone: contato[0].telefone,
                nome: contato[0].nome,
                value: mensagem.body,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                status: "Espera",
                type: mensagem.type || "chat",
                fromMe: false,
                time: Date.now()
              };
              let dados_whats = {
                key: contato[0].telefone,
                finalizada: "nao",
                status: "Respondeu...",
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "primeiro_atendimento",
                dados_whats
              );
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "whatscall",
                whatscall
              );
            } else {
              let whatscall = {
                telefone: contato[0].telefone,
                nome: contato[0].nome,
                value: mensagem.body,
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                ),
                status: "Espera",
                type: mensagem.type || "chat",
                fromMe: false,
                time: Date.now()
              };
              let dados_whats = {
                key: contato[0].telefone,
                finalizada: "nao",
                status: "Respondeu...",
                value: mensagem.body,
                time: Date.now(),
                data_criacao: Date.now(),
                data_hora: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "primeiro_atendimento",
                dados_whats
              );
              this.genProvider.onSaveObjeto(
                "dados",
                this.parametros.path,
                "whatscall",
                whatscall
              );
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: this.atendimento.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

              };
              //     this.enviarMsg(formulario);
              contato[0].nivel = 200;
              this.atualizaContato(contato[0]);
            }
          } else if (contato[0].status != "Bloqueado") {
            if (contato[0].acesso == 1) {
            } else {
              if (contato[0].status == "Bloqueado") {
                console.log("Contato bloqueado");
              } else {
                this.onchatStart(mensagem, contato);
              }
            }
          } else {
            console.log("Usuario Boqueado ", contato[0].telefone);
          }
        });
      }
    }
  }

  onStartAtendimento(contato, mensagem?: any) {
    setTimeout(() => {
      if (this.bem_vindo_midia) {
        if (this.type_bem_vindo_midia == "mp4") {
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            caption: "",
            midia: this.bem_vindo_midia,
            type_midia: this.type_bem_vindo_midia
          };
          this.enviarMsg(formulario);
          this.onchatStartNew(mensagem, contato);
        }
      } else if (this.bem_vindo_midia) {
        let formulario = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          midia: this.bem_vindo_midia,
          type_midia: this.type_bem_vindo_midia
        };
        this.enviarMsg(formulario);
        this.onchatStartNew(mensagem, contato);
      } else {
        let protocolo = this.ctrl + new DatePipe("pt-BR").transform(Date.now(), "HH:mm:ss");
        if (this.informaProtocolo) {
          protocolo =
            this.ctrl + "*Seu Protocolo: " + contato[0].protocolo + "*";
        } else {
          protocolo = '*Sair* - Encerrar atendimento'
        }
        this.filtroNivel(this.menus, 0, null).then(menu => {
          this.onMontaMenu(menu, contato[0]).then((result: any) => {
            let res = result.menu;
            let menuOpcao = res;
            if (this.pergunta.type_midia) {
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                caption: menuOpcao +
                  this.ctrl +
                  this.rodape +
                  this.ctrl +
                  protocolo,
                mensagem: menuOpcao +
                  this.ctrl +
                  this.rodape +
                  this.ctrl +
                  protocolo,
                midia: this.pergunta.imagem,
                type_midia: this.pergunta.type_midia
              };

              if (this.menu_texto_ativo) {
                this.menu_texto = this.menu_texto.replace(
                  "{{4}}",
                  this.saudacao
                );
                formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  caption:
                    this.menu_texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
                    this.ctrl +
                    this.rodape +
                    this.ctrl +
                    protocolo,
                  mensagem:
                    this.menu_texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
                    this.ctrl +
                    this.rodape +
                    this.ctrl +
                    protocolo,
                  midia: this.pergunta.imagem,
                  type_midia: this.pergunta.type_midia
                };
              }

              this.enviarMsg(formulario);
              this.onchatStartNew(mensagem, contato);
            } else {
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: menuOpcao +
                  this.ctrl +
                  this.rodape +
                  this.ctrl +
                  protocolo
              };
              if (this.menu_texto_ativo) {
                this.menu_texto = this.menu_texto.replace(
                  "{{4}}",
                  this.saudacao
                );
                formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem:
                    this.menu_texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
                    this.ctrl +
                    this.rodape +
                    this.ctrl +
                    protocolo
                };
              }

              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                header: this.titulo,
                body: this.pergunta.segunda_saudacao + this.ctrl,
                footer: protocolo,
                title: "Menu Principal",
                button: "Menu",
                rows: result.rows,
                list: true
              };
              if (this.menu_principal_lista) {
                this.enviarMsg(msg);
              } else {
                if (this.pergunta.segunda_saudacao) {
                  let formulario_saudacao = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: this.pergunta.segunda_saudacao
                  };
                  this.enviarMsg(formulario_saudacao);
                }
                setTimeout(() => {
                  this.enviarMsg(formulario);
                }, 1000);
              }
              this.onchatStartNew(mensagem, contato);
            }
          }
          );
        });

      }
      if (!this.primeiro_atendimento) {
        this.onOpcaochat(contato, this.opcao_autobot);
      }
    }, 1000);

  }
  async onchatStartNew(mensagem, contato) {
    contato[0].time = Date.now();
    contato[0].nivel = 0;
    contato[0].opcao = "0";
    contato[0].tipo = "Pergunta";
  }
  onchatStart(mensagem, contato) {
    /*
    if (contato[0].nivel == 0) {
      this.pesquisaPergunta(this.menus, mensagem.body).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        console.log(data)
        if (data.length > 0) {
          if (data[0].saudacao) {
            let formulario = {
              contato: contato[0].id_canal,
              mensagem: data[0].saudacao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

            };
            this.enviarMsg(formulario);
          }
          mensagem.body = data[0].numero.toString();
          this.onchat(mensagem, contato);
        } else {
          console.log("aqui")
          console.log(mensagem.body, this.chatbot)
          this.pesquisaPerguntachatbot(mensagem.body, this.chatbot, 0).then(
            result => {
              let dt = JSON.parse(JSON.stringify(result));
              console.log(dt)
              if (dt.length > 0) {
                if (dt[0].rodape) {
                  dt[0].resposta =
                    dt[0].resposta + this.ctrl + this.pergunta.rodape_bot;
                }
                let texto = dt[0].resposta.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
  ;
                let formulario = {
                  contato: contato[0].id_canal,
                  mensagem: texto
                };
                this.enviarMsg(formulario);
                if (dt[0].anexo_midia) {
                  let frm = {
                    contato: contato[0].id_canal,
                    midia: dt[0].anexo_midia,
                    caption: dt[0].anexo_fullName,
                    type_midia: dt[0].anexo_type_midia
                  };
                  //         setTimeout(() => {
                  this.enviarMsg(frm);
                  //         }, 5000);
                }
                if (dt[0].retornaMenu == "true") {
                  setTimeout(() => {
                    this.onOpcaochat(contato, "#");
                  }, this.parametros.menu_automatico_tempo * 1000);
                }
                // encaminhar inicio
                if (dt[0].acaobot == "true") {
                  let formulario = {
                    contato: contato[0].id_canal,
                    mensagem: dt[0].texto_acao
                  };
                  if (dt[0].texto_acao.length > 0) {
                    this.enviarMsg(formulario);
                  }
                  this.onOpcaochat(contato, dt[0].opcao_acao);
                }

                // fim
              } else {
                this.onchat(mensagem, contato);
              }
            }
          );
        }
      });
    } else {
      */
    this.pesquisaPerguntaNivel(this.menus, mensagem.body, contato[0].nivel).then(res => {
      let data = JSON.parse(JSON.stringify(res));
      if (data.length > 0) {
        if (data[0].saudacao) {
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: data[0].saudacao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
          };
          this.enviarMsg(formulario);
        }
        mensagem.body = data[0].numero.toString();
        this.onchat(mensagem, contato);
      } else {
        this.pesquisaPerguntachatbot(mensagem.body, this.chatbot, contato[0].nivel).then(
          result => {
            let dt = JSON.parse(JSON.stringify(result));
            if (dt.length > 0) {
              let texto_resp = dt[0].resposta
              if (dt[0].rodape) {
                dt[0].resposta =
                  dt[0].resposta + this.ctrl + this.pergunta.rodape_bot;
              }
              let texto = dt[0].resposta.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome));
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto
              };
              if (texto_resp.length > 0) {
                this.enviarMsg(formulario);
              }
              if (dt[0].anexo_midia) {
                let frm = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  midia: dt[0].anexo_midia,
                  caption: dt[0].anexo_fullName,
                  type_midia: dt[0].anexo_type_midia
                };
                this.enviarMsg(frm);
              }
              if (dt[0].retornaMenu == "true") {
                setTimeout(() => {
                  this.onOpcaochat(contato, "#");
                }, this.parametros.menu_automatico_tempo * 1000);
              }
              // encaminhar inicio
              if (dt[0].acaobot == "true") {
                let formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: dt[0].texto_acao
                };
                if (dt[0].texto_acao.length > 0) {
                  this.enviarMsg(formulario);
                }
                this.onOpcaoChatIntensao(contato, dt[0].key_opcao_acao, mensagem);
              }
            } else {
              this.onchat(mensagem, contato);
            }
          }
        );
      }
    });
    // }
  }
  onchat(mensagem, contato) {
    let opcao: any;
    this.mensagem_full = mensagem;
    if (mensagem.body.substring(0, 5).toLowerCase() == "*sair") {
      opcao = "*sair";
      this.excluirMensagemTicket(contato[0].protocolo, contato[0].ticket, contato[0].atendimento, contato);
      this.onFinalizaSair(contato);
    } else if (mensagem.body.substring(0, 4).toLowerCase() == "sair") {
      opcao = "*sair";
      this.excluirMensagemTicket(contato[0].protocolo, contato[0].ticket, contato[0].atendimento, contato);
      this.onFinalizaSair(contato);
    } else if (mensagem.body.substring(0, 1) == "#") {
      opcao = "#";
    } else {
      opcao = mensagem.body.replace(/\D/g, "");
    }
    if (opcao == "") {
      //    console.log( 'opcao invalida ', contato[0] )
      contato[0].invalida = contato[0].invalida + 1;
      contato[0].time = Date.now();
      this.atualizaContato(contato[0]);
      let mensagem = "";
      if (contato[0].invalida == 1) {
        mensagem = this.pergunta.opcao_invalida_principal.replace(
          "{{2}}",
          contato[0].nome
        );
      } else if (contato[0].invalida == 2) {
        mensagem = this.pergunta.opcao_invalida_principal_2.replace(
          "{{2}}",
          contato[0].nome
        );
      } else if (contato[0].invalida == 3) {
        mensagem = this.pergunta.opcao_invalida_principal_3.replace(
          "{{2}}",
          contato[0].nome
        );
        this.onSavePergunta(contato[0], this.mensagem_full)
      } else if (contato[0].invalida == 4) {
        mensagem = this.pergunta.atendimento_final.replace(
          "{{2}}",
          contato[0].nome
        );
        this.onSavePergunta(contato[0], this.mensagem_full)
      }
      if (contato[0].nivel > 0) {
        mensagem = this.pergunta.opcao_invalida.replace(
          "{{2}}",
          contato[0].nome
        );
      }
      if (this.mensagem_full.body.substring(0, 4) == "http") {
        mensagem = this.pergunta.opcao_invalida_outros.replace(
          "{{2}}",
          contato[0].nome
        );
      }

      let formulario = {};

      if (this.opcao_invalida_midia) {
        formulario = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
          midia: this.opcao_invalida_midia
        };
        this.enviarMsg(formulario);
        formulario = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
        };
        this.enviarMsg(formulario);
        if (this.opcao_invalida_midia) {
          formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
            midia: this.opcao_invalida_midia
          };
          this.enviarMsg(formulario);
          formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
          };
          this.enviarMsg(formulario);
        }
      } else {
        let formulario = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
        };
        if (contato[0].invalida < 3) {
          this.enviarMsg(formulario);
        } else {
          this.enviarMsg(formulario);
          if (this.finaliza_atendimento == "true") {
            this.onFinalizaAtendimento(contato);
          } else if (this.acaobot == "true") {
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: this.texto_acao
            };
            this.enviarMsg(formulario);
            console.log(contato, this.opcao_acao)
            this.onOpcaochat(contato, this.opcao_acao);
          }
        }
      }
    } else {
      this.onOpcaochat(contato, opcao, mensagem.body);
    }

  }

  onOpcaochat(contato, opcao, mensagem?: any) {
    let msg_value = mensagem;
    this.atualizaContato(contato[0]);
    if (opcao == "-2") {
      // finaliza atendimento
      this.filtroNivel(this.menus, 0, null).then(menu => {
        this.onMontaMenu(menu, contato[0]).then((result: any) => {
          let res = result.menu;
          let menuOpcao = res;
          let msg = "";
          let hora =
            this.ctrl + new DatePipe("pt-BR").transform(Date.now(), "HH:mm:ss");
          if (this.informaProtocolo) {
            msg =
              this.atendimento_final.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
              +
              this.ctrl +
              "*Protocolo :" +
              contato[0].protocolo +
              "*";
          } else {
            msg =
              this.atendimento_final.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
              +
              this.ctrl +
              hora;
          }
          let protocolo = msg;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: msg,
            // midia: this.pergunta.midia
          };
          let menuOpc = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            header: this.titulo,
            body: this.pergunta.segunda_saudacao + this.ctrl,
            footer: protocolo,
            title: "Menu Principal",
            button: "Menu",
            rows: result.rows,
            list: true
          };
          if (this.menu_principal_lista) {
            this.enviarMsg(menuOpc);
          } else {
            if (this.pergunta.segunda_saudacao) {
              let formulario_saudacao = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: this.pergunta.segunda_saudacao
              };
              this.enviarMsg(formulario_saudacao);
            }
            setTimeout(() => {
              this.enviarMsg(formulario);
            }, 1000);
          }
        });
      });
    } else if (opcao == "-1") {
      let tmp_contato = contato[0]
      let msg = "";
      let hora = this.ctrl + new DatePipe("pt-BR").transform(Date.now(), "HH:mm:ss");
      if (this.informaProtocolo) {
        if (tmp_contato.nome) {
          msg =
            this.atendimento_final.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(tmp_contato.nome))
            +
            this.ctrl +
            "*Protocolo :" +
            tmp_contato.protocolo +
            "*";
        } else {
          msg = "Atendimento finalizado!"
        }

      } else {
        msg =
          this.atendimento_final.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(tmp_contato.nome))
          +
          this.ctrl +
          hora;
      }

      let formulario = {
        origem: tmp_contato.origem,
        contato: tmp_contato.id_canal,
        mensagem: msg,
        //   midia: this.pergunta.midia
      };
      this.enviarMsg(formulario);
      this.excluirContato(tmp_contato);
    } else if (opcao == "0") {
      if (contato[0].enquete) {
        this.onEncerraEnquete(contato)
      } else {
        this.filtroNivel(this.menus, 0, null).then(menu => {
          this.onMontaMenu(menu, contato[0]).then((result: any) => {
            let res = result.menu;
            let menuOpcao = res;
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: menuOpcao + this.ctrl + this.rodape
            };
            if (this.menu_texto_ativo) {
              this.menu_texto = this.menu_texto.replace("{{4}}", this.saudacao);
              formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem:
                  this.menu_texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
                  +
                  this.ctrl +
                  this.rodape
              };
            }
            let menuOpc = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              header: this.titulo,
              body: this.pergunta.segunda_saudacao + this.ctrl,
              footer: '*Sair* - Encerrar atendimento',
              title: "Menu Principal",
              button: "Menu",
              rows: result.rows,
              list: true
            };
            if (this.menu_principal_lista) {
              this.enviarMsg(menuOpc);
            } else {
              if (this.pergunta.segunda_saudacao) {
                let formulario_saudacao = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: this.pergunta.segunda_saudacao
                };
                this.enviarMsg(formulario_saudacao);
              }
              setTimeout(() => {
                this.enviarMsg(formulario);
              }, 1000);
            }
            let dados = {
              id_canal: contato[0].id_canal,
              telefone: contato[0].telefone,
              data_hora: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              ),
              nivel: 0,
              protocolo: contato[0].protocolo,
              invalida: 0,
              acesso: 0,
              status: "Ativo",
              online: "on",
              origem: contato[0].origem,
              nome: contato[0].nome,
              image: contato[0].image,
              coordenadas: "",
              localizacao: "",
              data_nascimento: "",
              tipo: "Pergunta",
              time: Date.now(),
              data_criacao: Date.now(),
              bloqueado: false
            };
            this.atualizaContato(dados);
          });
        });
      }
    } else if (opcao == "#") {
      if (contato[0].nivel <= 1) {
        this.filtroNivel(this.menus, 0, null).then(menu => {
          this.onMontaMenu(menu, contato[0]).then((result: any) => {
            console.log(menu)
            let res = result.menu;
            let menuOpcao = res;
            (contato[0].time = Date.now());
            contato[0].nivel = 0;
            contato[0].key_master = menu[0].key_master;
            contato[0].key_child = menu[0].key_child;
            contato[0].uid = menu[0].uid;
            contato[0].key_pergunta = this.key_pergunta;
            contato[0].opcao = opcao;
            //          contato[0].menu = menu[0].texto;
            contato[0].menu_lista = menu[0].menu_lista || false
            contato[0].tipo = "Pergunta";
            contato[0].localizacao = false;
            contato[0].data_hora = new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm");
            console.log(contato[0])
            this.atualizaContato(contato[0]);
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              //                 caption: menuOpcao +this.ctrl+this.rodape ,
              mensagem: menuOpcao + this.ctrl + this.rodape
              //midia: this.pergunta.midia
            };
            if (this.menu_texto_ativo) {
              this.menu_texto = this.menu_texto.replace("{{4}}", this.saudacao);
              formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem:
                  this.menu_texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
                  +
                  this.ctrl +
                  this.rodape
                //midia: this.pergunta.midia
              };
            }

            let menuOpc = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              header: this.titulo,
              body: this.pergunta.segunda_saudacao + this.ctrl,
              footer: "*Sair* - Encerrar atendimento",
              title: "Menu Principal",
              button: "Menu",
              rows: result.rows,
              list: true
            };
            if (this.menu_principal_lista) {
              this.enviarMsg(menuOpc);
            } else {
              this.enviarMsg(formulario);
            }
          });
        });
      } else {
        this.onMenosNivel(contato);
      }
    } else if (contato[0].tipo == "Pergunta") {
      if (contato[0].nivel == 0) {
        //    console.log ('nivel 0 colocar aqui se a pessoa mandou um audio ou texto', opcao, mensagem)
        // sempre verificar se e uma opcao, se nao for vefiricar o tamanho da string para direcionar
        // e gravar como mensagem envianda.
        this.filtroNivel(this.menus, contato[0].nivel, contato[0].key_child).then(res => {
          this.filtroOpcao(res, parseInt(opcao)).then(res => {
            let menu = JSON.parse(JSON.stringify(res));
            if (menu.length > 0) {
              this.onMaisNivel(menu[0], contato);
            } else {
              if (opcao != "*sair") {
                let mensagem = this.pergunta.opcao_invalida_principal.replace(
                  "{{2}}",
                  contato[0].nome
                );
                if (contato[0].nivel == 0) {
                  // gravar pergunta
                  let data = {
                    telefone: contato[0].telefone,
                    value: msg_value,
                    date: Date.now(),
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    nome: contato[0].nome,
                    status: "Novo"
                  };
                  this.genProvider.onSaveObjeto(
                    "dados",
                    this.parametros.path,
                    "intensao",
                    data
                  );
                }

                if (contato[0].nivel > 0) {
                  mensagem = this.pergunta.opcao_invalida.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }
                if (this.mensagem_full.body.substring(0, 4) == "http") {
                  mensagem = this.pergunta.opcao_invalida_outros.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }

                let formulario = {};

                if (this.opcao_invalida_midia) {
                  formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    caption:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
                    midia: this.opcao_invalida_midia
                  };
                  this.enviarMsg(formulario);
                  formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                } else {
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                }
              }
            }
          });
        });
      } else {
        this.filtroMaster(this.menus, contato[0].key_master).then(res => {
          this.filtroNivel(res, contato[0].nivel, contato[0].key_child).then(res => {
            this.filtroOpcao(res, parseInt(opcao)).then(res => {
              let menu = JSON.parse(JSON.stringify(res));
              if (menu.length > 0) {
                this.onMaisNivel(menu[0], contato);
              } else {
                console.log("Opção não Existe ", opcao);
                let mensagem = this.pergunta.opcao_invalida_principal.replace(
                  "{{2}}",
                  contato[0].nome
                );
                if (contato[0].nivel == 0) {
                  // gravar pergunta
                  let data = {
                    telefone: contato[0].telefone,
                    value: msg_value,
                    date: Date.now(),
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    nome: contato[0].nome,
                    status: "Novo"
                  };
                  this.genProvider.onSaveObjeto(
                    "dados",
                    this.parametros.path,
                    "intensao",
                    data
                  );
                }

                if (contato[0].nivel > 0) {
                  mensagem = this.pergunta.opcao_invalida.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }
                if (this.mensagem_full.body.substring(0, 4) == "http") {
                  mensagem = this.pergunta.opcao_invalida_outros.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }

                let formulario = {};

                if (this.opcao_invalida_midia) {
                  formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    caption:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
                    midia: this.opcao_invalida_midia
                  };
                  this.enviarMsg(formulario);
                  formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                } else {
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                }
              }
            });
          });
        });
      }
    } else if (contato[0].tipo == "Pergunta Mensagem") {
      if (contato[0].nivel == 0) {
        //    console.log ('nivel 0 colocar aqui se a pessoa mandou um audio ou texto', opcao, mensagem)
        // sempre verificar se e uma opcao, se nao for vefiricar o tamanho da string para direcionar
        // e gravar como mensagem envianda.
        console.log("nivel = 0")
        this.filtroNivel(this.menus, contato[0].nivel, contato[0].key_child).then(res => {
          this.filtroOpcao(res, parseInt(opcao)).then(res => {
            let menu = JSON.parse(JSON.stringify(res));
            if (menu.length > 0) {
              this.onMaisNivel(menu[0], contato);
            } else {
              if (opcao != "*sair") {
                let mensagem = this.pergunta.opcao_invalida_principal.replace(
                  "{{2}}",
                  contato[0].nome
                );
                if (contato[0].nivel == 0) {
                  // gravar pergunta
                  let data = {
                    telefone: contato[0].telefone,
                    value: msg_value,
                    date: Date.now(),
                    data_hora: new DatePipe("pt-BR").transform(
                      Date.now(),
                      "d, MMMM yyyy - HH:mm"
                    ),
                    nome: contato[0].nome,
                    status: "Novo"
                  };
                  this.genProvider.onSaveObjeto(
                    "dados",
                    this.parametros.path,
                    "intensao",
                    data
                  );
                }

                if (contato[0].nivel > 0) {
                  mensagem = this.pergunta.opcao_invalida.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }
                if (this.mensagem_full.body.substring(0, 4) == "http") {
                  mensagem = this.pergunta.opcao_invalida_outros.replace(
                    "{{2}}",
                    contato[0].nome
                  );
                }

                let formulario = {};

                if (this.opcao_invalida_midia) {
                  formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    caption:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
                    midia: this.opcao_invalida_midia
                  };
                  this.enviarMsg(formulario);
                  formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                } else {
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                  };
                  this.enviarMsg(formulario);
                }
              }
            }
          });
        });
      } else {
        //  this.filtroMaster(this.menus, contato[0].key_master).then(res => {
        this.filtroNivel(this.menus, contato[0].nivel, contato[0].key_child).then(res => {
          this.filtroOpcao(res, parseInt(opcao)).then(res => {
            let menu = JSON.parse(JSON.stringify(res));
            console.log(menu)
            if (menu.length > 0) {
              if (menu[0].tipo == "Voltar Opcao") {
                if (menu[0].valtarAll = "true") {
                  this.onOpcaochat(contato, "0");
                } else if (menu[0].nivel == 1) {
                  this.onOpcaochat(contato, "0");
                } else {
                  this.onMenosNivel(contato);
                }

              } else {
                console.log('mais nivel', menu[0], contato)
                this.onMaisNivel(menu[0], contato);
              }
            } else {
              console.log("Opção não Existe ", opcao);
              let mensagem = this.pergunta.opcao_invalida_principal.replace(
                "{{2}}",
                contato[0].nome
              );
              if (contato[0].nivel == 0) {
                // gravar pergunta
                let data = {
                  telefone: contato[0].telefone,
                  value: msg_value,
                  date: Date.now(),
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  nome: contato[0].nome,
                  status: "Novo"
                };
                this.genProvider.onSaveObjeto(
                  "dados",
                  this.parametros.path,
                  "intensao",
                  data
                );
              }

              if (contato[0].nivel > 0) {
                mensagem = this.pergunta.opcao_invalida.replace(
                  "{{2}}",
                  contato[0].nome
                );
              }
              if (this.mensagem_full.body.substring(0, 4) == "http") {
                mensagem = this.pergunta.opcao_invalida_outros.replace(
                  "{{2}}",
                  contato[0].nome
                );
              }

              let formulario = {};

              if (this.opcao_invalida_midia) {
                formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  caption:
                    mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
                  midia: this.opcao_invalida_midia
                };
                this.enviarMsg(formulario);
                formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem:
                    mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                };
                this.enviarMsg(formulario);
              } else {
                let formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem:
                    mensagem + this.ctrl + this.ctrl + this.msg_navegacao
                };
                this.enviarMsg(formulario);
              }
            }
          });
        });
        //  });
      }
    } else if (contato[0].tipo == "Pesquisa_Existe") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuPublicidade(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        //    console.log (data[0])
        if (data.length > 0) {
          let element = data[0];
          let nome = new CamelcasePipe().transform(element.nome).trim();
          let telefone = this.validaCampoProvider.validaTelefoneZap(
            element.telefone
          );
          let texto = "*" + nome + "*" + this.ctrl;

          if (element.mostra_localizacao) {
            texto += "_" + element.localizacao + "_" + this.ctrl;
          } else {
            texto += "_" + element.complemento + "_" + this.ctrl;
          }
          texto += telefone + this.ctrl + this.ctrl;

          texto += element.texto + this.ctrl + this.ctrl + this.msg_navegacao;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.midia,
            type_midia: element.type_midia,
            caption: texto || ""
          };
          this.enviarMsg(formulario);
          let localizacao = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            localizacao: element.localizacao || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            latitude: element.latitude,
            longitude: element.longitude
          };
          this.sendAll(localizacao, "localizacao");
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          console.log("opcao invalida ", contato[0]);
          contato[0].invalida = contato[0].invalida + 1;
          contato[0].time = Date.now();
          this.atualizaContato(contato[0]);

          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //   this.onOpcaochat(contato, '#');
    } else if (contato[0].tipo == "Publicidade") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuPublicidade(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        if (data.length > 0) {
          let element = data[0];
          let nome = new CamelcasePipe().transform(element.nome).trim();
          let telefone = this.validaCampoProvider.validaTelefoneZap(
            element.telefone
          );
          let texto = "*" + nome + "*" + this.ctrl;

          if (element.mostra_localizacao) {
            texto += "_" + element.localizacao + "_" + this.ctrl;
          } else {
            texto += "_" + element.complemento + "_" + this.ctrl;
          }
          if (telefone) {
            texto += telefone + this.ctrl;
          }
          if (element.desconto) {
            texto +=
              "*Desconto de até " +
              element.desconto +
              "%*" +
              this.ctrl +
              this.ctrl;
          } else {
            texto += this.ctrl;
          }
          /*      texto += "Publicado: " + element.data_hora + this.ctrl+ this.ctrl; */
          texto += element.texto + this.ctrl + this.ctrl + this.msg_navegacao;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.midia,
            type_midia: element.type_midia,
            caption: texto || ""
          };
          this.enviarMsg(formulario);
          let localizacao = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            localizacao: element.localizacao || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            latitude: element.latitude,
            longitude: element.longitude
          };
          //                   setTimeout(() => {
          this.sendAll(localizacao, "localizacao");
          //                    }, 5000);

          /*
                              if (i >= data.length){
                                setTimeout(() => {
                                  let formulario = {
                                    contato: contato[0].id_canal,
                                    mensagem: '*Total da Lista: '+i+'*',
                                    type_midia : menu[0].type_midia
                                  };
                                  this.enviarMsg(formulario);
                                  this.onOpcaochat(contato, '#');
                              }, 5000);
                              }
                  */
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //   this.onOpcaochat(contato, '#');
    } else if (contato[0].tipo == "Noticia") {
      console.log("situacao do menu 2");
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuNoticia(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        if (data.length > 0) {
          let element = data[0];
          //      let data_publicacao = new DatePipe('pt-BR').transform(element.data_hora, 'd, MMMM yyyy ');
          let texto = "*" + element.titulo + "*" + this.ctrl;
          texto += "_" + element.data_hora + "_" + this.ctrl;
          //      texto += "Publicado: " + element.data_hora + this.ctrl+ this.ctrl; */
          texto += this.ctrl + element.descricao + this.ctrl + this.ctrl;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.midia,
            type_midia: element.type_midia,
            caption: texto || ""
          };
          this.enviarMsg(formulario);
          setTimeout(() => {
            this.onOpcaochat(contato, "#");
          }, 5000);
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //   this.onOpcaochat(contato, '#');
    } else if (contato[0].tipo == "Galeria") {
      let opc = opcao.replace(/\D/g, "").trim();
      let msg = {
        origem: contato[0].origem,
        contato: contato[0].id_canal,
        mensagem: "⏳ Aguarde..."
      };
      this.enviarMsg(msg);
      this.filtroMenuGaleria(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        if (data.length > 0) {
          let element = data[0];
          let titulo = new CamelcasePipe().transform(element.titulo).trim();
          let texto = "";
          if (
            element.type_midia == "jpg" ||
            element.type_midia == "jpeg" ||
            element.type_midia == "png"
          ) {
            texto = "*🖼 " + titulo + "*" + this.ctrl;
          } else if (element.type_midia == "mp4") {
            texto = "*📹 " + titulo + "*" + this.ctrl;
          } else if (element.type_midia == "ogg") {
            texto = "*🔊 " + titulo + "*" + this.ctrl;
          } else {
            texto = "*📰 " + titulo + "*" + this.ctrl;
          }
          texto += element.descricao + this.ctrl;
          texto += element.data_hora + this.ctrl +
            this.ctrl +
            this.msg_navegacao;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.midia,
            type_midia: element.type_midia,
            caption: texto || ""
          };
          //        console.log (formulario)
          this.enviarMsg(formulario);
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel == 0) {
            // gravar pergunta
            let data = {
              telefone: contato[0].telefone,
              value: msg_value,
              date: Date.now(),
              data_hora: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              ),
              nome: contato[0].nome,
              status: "Novo"
            };
            this.genProvider.onSaveObjeto(
              "dados",
              this.parametros.path,
              "intensao",
              data
            );
          }

          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      // this.onOpcaochat(contato, '#');
    } else if (contato[0].tipo == "EnqueteEncerrada") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuEnqueteEncerrada(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));

        if (data.length > 0) {
          let navegacao =
            "A qualquer momento digite 0⃣ para voltar ao menu principal ou digite o número de uma nova enquete.";
          let element = data[0];
          let titulo = new CamelcasePipe().transform(element.nome).trim();
          let texto = "*" + titulo + "*" + this.ctrl;
          texto += "_" + element.texto + "_" + this.ctrl + this.ctrl;
          texto += "Iniciada em: " + element.data_hora + this.ctrl;
          texto += "Encerrada em: " + element.data_encerramento + this.ctrl;
          texto +=
            "Participantes: " +
            element.votos +
            this.ctrl +
            this.ctrl +
            navegacao;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
            midia: element.imgChart,
            type_midia: "jpg",
            caption: texto
          };
          //        console.log (formulario)
          this.enviarMsg(formulario);
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //   this.onOpcaochat(contato, '#');
    } else if (contato[0].tipo == "Enquete") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuEnquete(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        // verificar usuario
        if (data.length > 0) {
          this.onContatoEnquete(
            contato[0].telefone,
            data[0].key_enquete
          ).then(res => {
            let result = JSON.parse(JSON.stringify(res));
            console.log(res)
            if (result.length == 0) {
              this.onMontaMenuEnqueteOpcao(data[0].key_enquete).then(res => {
                let navegacao =
                  "A qualquer momento digite *_0_* para cencelar e voltar ao menu principal";
                let item = JSON.parse(JSON.stringify(res));
                let texto = "";
                if (data[0].mostra_texto) {
                  texto =
                    "*" +
                    data[0].nome +
                    "*" +
                    this.ctrl +
                    data[0].texto +
                    this.ctrl +
                    item +
                    this.ctrl +
                    this.ctrl +
                    navegacao;
                } else {
                  texto =
                    "*" +
                    data[0].nome +
                    "*" +
                    this.ctrl +
                    item +
                    this.ctrl +
                    this.ctrl +
                    navegacao;
                }
                if (item.length > 0) {
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
                    midia: data[0].midia,
                    type_midia: data[0].type_midia,
                    caption: texto || ""
                  };
                  this.enviarMsg(formulario);
                  contato[0].agente = "AgentBot";
                  contato[0].key_agente = '00000'
                  contato[0].acesso = 2;
                  contato[0].time = Date.now();
                  contato[0].nivel = 2;
                  contato[0].tipo = "EnqueteOpcao";
                  this.atualizaContato(contato[0]);
                }
              });
            } else {
              // usuario ja participu desta enquete
              let texto =
                "{{2}} sua participação já foi registrada." +
                this.ctrl +
                "*Selecione outra opção ou digite a qualquer momento digite 0⃣ para voltar ao menu principal*";
              texto = texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
                ;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto || "" //+this.ctrl+this.ctrl+this.msg_navegacao,
              };
              this.enviarMsg(formulario);
            }
          });
        } else {
          console.log("4")
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel == 0) {
            // gravar pergunta
            let data = {
              telefone: contato[0].telefone,
              value: msg_value,
              date: Date.now(),
              data_hora: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              ),
              nome: contato[0].nome,
              status: "Novo"
            };
            this.genProvider.onSaveObjeto(
              "dados",
              this.parametros.path,
              "intensao",
              data
            );
          }

          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};
          if (this.opcao_invalida_midia) {
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });
      //       this.onOpcaochat(contato, '#');
    } else if (contato[0].tipo == "EnqueteOpcao") {
      let opc = opcao.replace(/\D/g, "").trim();
      this.filtroMenuEnqueteOpcao(opc).then(res => {
        let data = JSON.parse(JSON.stringify(res));
        if (data.length > 0) {
          let texto = this.texto_finaliza_enquete;
          let voto = {
            key_enquete: data[0].key_enquete,
            key_enquetePergunta: data[0].key_enquetePergunta,
            numero: data[0].numero,
            texto: data[0].texto,
            data_hora: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            ),
            time: Date.now(),
            data_criacao: Date.now(),
            telefone: contato[0].telefone,
            nome: contato[0].nome,
            localizacao: contato[0].localizacao,
            agente: contato[0].agente,
            key_agente: contato[0].key_agente
          };
          this.genProvider.onSaveIncrement("dados/" + this.parametros.path + "/enquete_voto", voto, "enquete_voto").then(t => {
            // atualiza a opcao
            this.genProvider
              .onUpdateVoto(
                "dados/" + this.parametros.path + "/enquete_item",
                data[0].key_enquetePergunta.toString()
              )
              .then(t => { })
              .catch(e => {
                alert(
                  "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
                );
                console.log(e);
              });
            // atualiza a pergunta
            this.genProvider
              .onUpdateVoto(
                "dados/" + this.parametros.path + "/enquete",
                data[0].key_enquete.toString()
              )
              .then(t => { })
              .catch(e => {
                alert(
                  "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
                );
                console.log(e);
              });
          })
            .catch(e => {
              alert(
                "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
              );
              console.log(e);
            });

          texto = texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
            ;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: texto || "" //+this.ctrl+this.ctrl+this.msg_navegacao,
          };
          this.enviarMsg(formulario);
          setTimeout(() => {
            this.onEncerraEnquete(contato)
          }, 2000);
        } else {
          let mensagem = this.pergunta.opcao_invalida_principal.replace(
            "{{2}}",
            contato[0].nome
          );
          if (contato[0].nivel == 0) {
            // gravar pergunta
            let data = {
              telefone: contato[0].telefone,
              value: msg_value,
              date: Date.now(),
              data_hora: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              ),
              nome: contato[0].nome,
              status: "Novo"
            };
            this.genProvider.onSaveObjeto(
              "dados",
              this.parametros.path,
              "intensao",
              data
            );
          }

          if (contato[0].nivel > 0) {
            mensagem = this.pergunta.opcao_invalida.replace(
              "{{2}}",
              contato[0].nome
            );
          }
          if (this.mensagem_full.body.substring(0, 4) == "http") {
            mensagem = this.pergunta.opcao_invalida_outros.replace(
              "{{2}}",
              contato[0].nome
            );
          }

          let formulario = {};

          if (this.opcao_invalida_midia) {
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              caption: mensagem + this.ctrl + this.ctrl + this.msg_navegacao,
              midia: this.opcao_invalida_midia
            };
            this.enviarMsg(formulario);
            formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          } else {
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: mensagem + this.ctrl + this.ctrl + this.msg_navegacao
            };
            this.enviarMsg(formulario);
          }
        }
      });


      //       this.onOpcaochat(contato, '#');
    }
    /*
    else if (contato[0].tipo == "Notificação") {
     console.log (contato[0])

      this.onMenosNivel(contato);
      let formulario = {
        origem: contato[0].origem,
        contato: contato[0].id_canal,
        mensagem: "teste de notificaçao" //menu[0].texto
      };
      this.enviarMsg(formulario);
    }
    */
  }
  onOpcaoChatIntensao(contato, opcao, mensagem) {
    let res = this.menus.filter(obj => {
      return obj.key == opcao;
    });
    contato[0].nivel = res[0].nivel;
    contato[0].key_child = res[0].key_child;
    contato[0].key_master = res[0].key_master
    mensagem.body = res[0].numero.toString();
    this.onchat(mensagem, contato);
  }
  // fim

  // sequencia do fluxo de opcoes
  onMaisNivel(data, contato) {
    // seleciona um menu de nivel acima com as opcoes de tipo de menu
    let tmp = data.texto.replace(/\n/g, "");
    let menu_opcao = tmp.replace(/\*/g, "");
    let nivel = data.nivel + 1;
    let filtro = nivel.toString() + data.key_master.toString() + data.uid.toString();
    this.filtroMenu(this.menus, filtro).then(res => {
      let menu = JSON.parse(JSON.stringify(res));
      // atualiza contato
      if (menu.length > 0) {
        (contato[0].data_hora = new DatePipe("pt-BR").transform(
          Date.now(),
          "d, MMMM yyyy - HH:mm"
        )),
          (contato[0].acesso = 2);
        //   contato[0].time = Date.now();
        contato[0].nivel = nivel;
        contato[0].key_master = menu[0].key_master;
        contato[0].key_child = menu[0].key_child;
        contato[0].uid = menu[0].uid;
        contato[0].key_pergunta = this.key_pergunta;
        contato[0].tipo = menu[0].tipo;
        contato[0].menu_lista = data.menu_lista;
        contato[0].menu = menu_opcao;
        contato[0].geraTicket = menu[0].geraTicket
        if (menu[0].key_puc) {
          contato[0].key_puc = menu[0].key_puc
        } else {
          contato[0].key_puc = this.parametros.key_puc
        }
        this.atualizaContato(contato[0]);
        if (menu[0].geraTicket) {
          this.registraAtendimento(contato)
        }
        //
        if (menu[0].tipo == "Informação") {
          let navegacao = "*" + this.msg_navegacao + "*";
          if (this.parametros.menu_automatico) {
            navegacao = "";
          }
          let tempo = 0;
          menu.forEach(res => {
            let texto = res.texto + this.ctrl + navegacao;
            setTimeout(() => {
              this.onEnviaMenu(texto, res, contato, "banner");
            }, tempo);
            tempo = 1000;
          });
          if (this.parametros.menu_automatico) {
            setTimeout(() => {
              if (menu[0].valtarAll = "true") {
                this.onOpcaochat(contato, "0");
              } else if (menu[0].nivel == 1) {
                this.onOpcaochat(contato, "0");
              } else {
                this.onMenosNivel(contato);
              }
            }, this.parametros.menu_automatico_tempo * 1000);
          }
        } else if (menu[0].tipo == "Link") {
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: menu[0].texto + this.ctrl + menu[0].link,
            preview_url: true
          };
          this.enviarMsg(formulario);
          if (this.parametros.menu_automatico) {
            setTimeout(() => {
              if (menu[0].valtarAll = "true") {
                this.onOpcaochat(contato, "0");
              } else if (menu[0].nivel == 1) {
                this.onOpcaochat(contato, "0");
              } else {
                this.onMenosNivel(contato);
              }
            }, this.parametros.menu_automatico_tempo * 1000);
          }
        } else if (menu[0].tipo == "Informação com menu") {
          let navegacao = "*" + this.msg_navegacao + "*";
          if (this.parametros.menu_automatico) {
            navegacao = "";
          }
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: menu[0].texto + this.ctrl,
          };
          this.enviarMsg(formulario);
          this.filtroMaster(this.menus, contato[0].key_master).then(res => {
            this.filtroNivel(res, contato[0].nivel, contato[0].key_child).then(result => {
              let data = JSON.parse(JSON.stringify(result));
              const index = data.indexOf(data[0]);
              data.splice(index, 1);
              if (data.length > 0) {
                this.onMontaMenu(data, contato[0]).then((result: any) => {
                  let res = result.menu;
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem: res + this.ctrl + navegacao,
                  };
                  setTimeout(() => {
                    this.enviarMsg(formulario);
                  }, 1000);
                  contato[0].data_hora = new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm");
                  contato[0].acesso = 2;
                  contato[0].time = Date.now();
                  contato[0].nivel = nivel;
                  contato[0].key_master = data[0].key_master;
                  contato[0].key_child = data[0].key_child;
                  contato[0].uid = data[0].uid;
                  contato[0].key_pergunta = this.key_pergunta;
                  contato[0].tipo = data[0].tipo;
                  this.atualizaContato(contato[0]);
                });
              }
            });
          });

        } else if ((menu[0].tipo == "Pesquisa") || (menu[0].tipo == "Pesquisa Ticket")) {
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: menu[0].texto,
          };
          this.enviarMsg(formulario);
        } else if (menu[0].tipo == "API") {
          let texto =
            menu[0].texto +
            this.ctrl +
            "Para cancelar, digite e envie apenas o número *_0_* ou *sair*";
          contato[0].api = menu[0].api || "";
          this.atualizaContato(contato[0]);
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Consulta") {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          contato[0].api = menu[0].api || "";
          contato[0].token = menu[0].token;
          this.atualizaContato(contato[0]);
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Consulta Denuncia") {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.atualizaContato(contato[0]);
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if ((menu[0].tipo == "Mensagem") || (menu[0].tipo == "Mensagem Chat")) {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (contato[0].tipo == "Ticket NTE") {
          contato[0].nome = null
          contato[0].email = null
          contato[0].texto_menu = menu[0].texto
          this.atualizaContato(contato[0])
          let msg = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: "Vejo que deseja abrir um chamado, para continuar preciso de algumas informações."
          };
          this.enviarMsg(msg);
          setTimeout(() => {
            msg = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: "😊 Qual é o seu *nome*?"
            };
            this.enviarMsg(msg);
          }, 1000);
        } else if (contato[0].tipo == "Ticket Valida") {
          contato[0].valida = null
          contato[0].nome = null
          contato[0].campo = menu[0].campo
          contato[0].tabela = menu[0].tabela
          contato[0].texto_menu = menu[0].texto
          this.atualizaContato(contato[0])
          let msg = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: "Vejo que deseja abrir um chamado, para continuar preciso de algumas informações."
          };
          this.enviarMsg(msg);
          setTimeout(() => {
            msg = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: "😊 Qual é o seu *nome*?"
            };
            this.enviarMsg(msg);
          }, 1000);
        } else if (menu[0].tipo == "Chat") {
          //      contato[0].chatLive = false;
          //      this.atualizaContato(contato[0]);
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
          // Notificar Atendente
          let mensagem = {
            author: contato[0].id_canal,
            body: "Aguardando atendimento...",
            date: contato[0].time,
            senderName: contato[0].nome,
            type: "chat",
            notifica_usuario: true
          }
          contato[0].key_puc = this.parametros.key_puc;
          contato[0].nome_puc = this.parametros.nome_puc;
          contato[0].key_pergunta = '';
          contato[0].chatLive = false;
          let dados = {
            status: "Novo",
            origem: contato[0].origem,
            acesso: contato[0].acesso,
            bloqueado: contato[0].bloqueado,
            coordenadas: contato[0].coordenadas,
            data_hora: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            ),
            data_nascimento: "",
            invalida: contato[0].invalida,
            localizacao: contato[0].localizacao,
            nivel: contato[0].nivel,
            nome: contato[0].nome,
            telefone: contato[0].telefone,
            id_canal: contato[0].id_canal,
            image: contato[0].image,
            tipo: contato[0].tipo,
            key_pergunta: contato[0].key_pergunta,
            protocolo: contato[0].protocolo,
            key_master: contato[0].key_master,
            key_child: contato[0].key_child,
            key_puc: contato[0].key_puc,
            nome_puc: contato[0].nome_puc,
            menu: contato[0].menu,
            type: mensagem.type,
            value: mensagem.body,
            time: Date.now(),
            data_criacao: Date.now(),
            //  messageNumber: '',
            notifica_usuario: true,
            chatLive: true,
            novo: '1'
          };
          contato[0].chatLive = true;
          this.atualizaContato(contato[0]);
          this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/chat", contato[0].protocolo, dados); // atualiza o registro com a mesma chave
          this.notificarAtendente(mensagem, contato);
          this.onWebHookMsg(contato[0].protocolo)
        } else if (menu[0].tipo == "Localizacao") {
          contato[0].localizacao = false;
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Sugestao") {
          contato[0].sugestao = false;
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Ouvidoria") {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (contato[0].tipo == "Denuncia") {
          contato[0].texto_menu = menu[0].texto
          contato[0].n_pergunta = 1;
          contato[0].titulo_pergunta = ''
          this.atualizaContato(contato[0])
          let msg = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            header: contato[0].texto_menu,
            body: "O Crime está ocorrendo neste momento?",
            footer: "*Sair* - Cancelar a denúncia.",
            rows: [
              {
                type: "reply",
                reply: {
                  id: 'Sim',
                  title: 'Sim'
                }
              },
              {
                type: "reply",
                reply: {
                  id: 'Não',
                  title: 'Não'
                }
              }
            ]
          };
          this.enviarMsg(msg);
        } else if (contato[0].tipo == "Template") {
          contato[0].texto_menu = menu[0].texto
          contato[0].n_pergunta = 1;
          contato[0].titulo_pergunta = '',
            contato[0].key_template = menu[0].key_template;
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          let msg = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: texto
          }
          this.enviarMsg(msg);
          console.log(menu[0].key_template)
          this.genProvider.onSearchArray(this.template, 'key', menu[0].key_template).then(res => {
            let data = JSON.parse(JSON.stringify(res))
            let temp = data.array
            contato[0].template = temp.filter(res => {
              return res.status != 'cancelado'
            });
            this.atualizaContato(contato[0])
            if (contato[0].template[0].type == 'text') {
              let msg = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: contato[0].template[0].texto
              }
              contato[0].validacao = contato[0].template[0].validacao || null;
              contato[0].acao = contato[0].template[0].rows || null
              contato[0].type = contato[0].template[0].type || null
              contato[0].value = contato[0].template[0].value || null
              contato[0].titulo_pergunta = contato[0].template[0].texto
              contato[0].field = contato[0].template[0].field
              this.atualizaContato(contato[0])
              setTimeout(() => {
                this.enviarMsg(msg);
              }, 1000);
            } else if (contato[0].template[0].type == 'reply') {
              let btn_item = []
              let template: any = [];
              let msg_template: any = [];
              template = contato[0].template[0]
              template.rows.forEach(b => {
                let i = {
                  type: "reply",
                  reply: {
                    id: b.id,
                    title: b.title
                  }
                }
                btn_item.push(i)
              })
              msg_template = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                header: template.header,
                body: template.body,
                footer: template.footer,
                rows: btn_item
              };
              contato[0].validacao = contato[0].template[0].validacao || null;
              contato[0].acao = contato[0].template[0].rows || null
              contato[0].type = 'reply'
              contato[0].value = contato[0].template[0].value || null
              contato[0].titulo_pergunta = contato[0].template[0].body
              contato[0].field = contato[0].template[0].field
              this.atualizaContato(contato[0])
              setTimeout(() => {
                this.enviarMsg(msg_template);
              }, 1000);
            } else if (contato[0].template[0].type == 'list') {
              let template: any = [];
              let msg_template: any = [];
              template = contato[0].template[0]
              msg_template = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                header: template.header,
                body: template.body,
                footer: template.footer,
                title: template.title,
                button: template.button,
                list: true,
                rows: template.rows
              };
              contato[0].validacao = contato[0].template[0].validacao || null;
              contato[0].type = 'list'
              contato[0].acao = contato[0].template[0].rows || null
              contato[0].value = contato[0].template[0].value || null
              contato[0].titulo_pergunta = contato[0].template[0].body
              contato[0].field = contato[0].template[0].field
              this.atualizaContato(contato[0])
              setTimeout(() => {
                this.enviarMsg(msg_template);
              }, 1000);

            }
          });
        } else if (menu[0].tipo == "Denuncia Natureza") {
          contato[0].countNatureza = 0;
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Denuncia Localizacao") {
          contato[0].localizacao = false;
          let texto = menu[0].texto + this.ctrl + this.cancelar_denuncia;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Saude") {
          contato[0].localizacao = false;
          contato[0].saude = 0;
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          this.onEnviaMenu(texto, menu[0], contato, "banner");
        } else if (menu[0].tipo == "Publicidade") {
          //   console.log ('situacao do menu', menu[0])
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            midia: menu[0].midia,
            mensagem: menu[0].texto,
            caption: menu[0].texto,
            type_midia: menu[0].type_midia
          };
          //    this.enviarMsg(formulario);

          let dataAtual = new Date();
          let inicio = dataAtual.setDate(dataAtual.getDate());
          let url = "dados/" + this.parametros.path + "/cliente";
          let subscription = this.genProvider
            .onGetFilterOrder(url, "nome", "categoria", menu[0].key_child)
            .subscribe(
              data => {
                let publicidade = data;
                subscription.unsubscribe();
                let i = 0;
                //       setTimeout(() => {
                if (publicidade.length > 0) {
                  this.filtroPublicidade(publicidade, inicio).then(res => {
                    let data = JSON.parse(JSON.stringify(res));
                    if (data.length > 0) {
                      this.onMontaMenuPublicidade(data).then(res => {
                        let formulario = {
                          contato: contato[0].id_canal,
                          mensagem:
                            menu[0].texto +
                            this.ctrl +
                            res +
                            this.ctrl +
                            this.msg_navegacao,
                          caption:
                            menu[0].texto +
                            this.ctrl +
                            res +
                            this.ctrl +
                            this.msg_navegacao,
                          midia: menu[0].midia,
                          type_midia: menu[0].type_midia
                        };
                        this.enviarMsg(formulario);
                      });
                    } else {
                      let formulario = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem:
                          menu[0].texto +
                          this.ctrl +
                          "*Desculpe! No momento esta opção não esta disponível.*!*",
                        caption:
                          menu[0].texto +
                          this.ctrl +
                          "*Desculpe! No momento esta opção não esta disponível.*!*",
                        midia: menu[0].midia,
                        type_midia: menu[0].type_midia
                      };
                      this.enviarMsg(formulario);
                      setTimeout(() => {
                        this.onOpcaochat(contato, "#");
                      }, 5000);
                    }
                  });
                } else {
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      menu[0].texto +
                      this.ctrl +
                      "*Desculpe! No momento esta opção não esta disponível.*!*",
                    caption:
                      menu[0].texto +
                      this.ctrl +
                      "*Desculpe! No momento esta opção não esta disponível.*!*",
                    midia: menu[0].midia,
                    type_midia: menu[0].type_midia
                  };
                  this.enviarMsg(formulario);
                  setTimeout(() => {
                    this.onOpcaochat(contato, "#");
                  }, 5000);
                }
                //    }, 5000);
              },
              err => console.log(err)
            );
        } else if (menu[0].tipo == "Noticia") {
          console.log("Monta o Menu com as Noticias");
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            midia: menu[0].midia,
            mensagem: menu[0].texto,
            caption: menu[0].texto,
            type_midia: menu[0].type_midia
          };
          //    this.enviarMsg(formulario);

          let dataAtual = new Date();
          let inicio = dataAtual.setDate(dataAtual.getDate());
          let url = "dados/" + this.parametros.path + "/noticia";
          let subscription = this.genProvider
            .onGetFilterOrder(url, "titulo", "publicar_ate", inicio, ">=")
            .subscribe(
              data => {
                //  let subscription = this.genProvider.onGetFilterOrder(url, 'data_pubicacao', 'status', 'Ativo').subscribe(data => {
                let noticia = data;
                subscription.unsubscribe();
                let i = 0;
                //       setTimeout(() => {
                if (noticia.length > 0) {
                  this.filtroNoticia(noticia, inicio).then(res => {
                    let data = JSON.parse(JSON.stringify(res));
                    if (data.length > 0) {
                      this.onMontaMenuNoticia(data).then(res => {
                        let formulario = {
                          origem: contato[0].origem,
                          contato: contato[0].id_canal,
                          mensagem:
                            menu[0].texto +
                            this.ctrl +
                            res +
                            this.ctrl +
                            this.msg_navegacao,
                          caption:
                            menu[0].texto +
                            this.ctrl +
                            res +
                            this.ctrl +
                            this.msg_navegacao,
                          midia: menu[0].midia,
                          type_midia: menu[0].type_midia
                        };
                        this.enviarMsg(formulario);
                      });
                    } else {
                      let formulario = {
                        origem: contato[0].origem,
                        contato: contato[0].id_canal,
                        mensagem:
                          menu[0].texto +
                          this.ctrl +
                          "*Desculpe! Não existe notícias no momento!*",
                        caption:
                          menu[0].texto +
                          this.ctrl +
                          "*Desculpe! Não existe notícias no momento!*",
                        midia: menu[0].midia,
                        type_midia: menu[0].type_midia
                      };
                      this.enviarMsg(formulario);
                      setTimeout(() => {
                        this.onOpcaochat(contato, "#");
                      }, 5000);
                    }
                  });
                } else {
                  let formulario = {
                    origem: contato[0].origem,
                    contato: contato[0].id_canal,
                    mensagem:
                      menu[0].texto +
                      this.ctrl +
                      "*Desculpe! Não existe notícias no momento!*",
                    caption:
                      menu[0].texto +
                      this.ctrl +
                      "*Desculpe! Não existe notícias no momento!*",
                    midia: menu[0].midia,
                    type_midia: menu[0].type_midia
                  };
                  this.enviarMsg(formulario);
                  setTimeout(() => {
                    this.onOpcaochat(contato, "#");
                  }, 5000);
                }
                //    }, 5000);
              },
              err => console.log(err)
            );
        } else if (menu[0].tipo == "Galeria") {
          let texto = menu[0].texto;
          let midia = "";
          let type_midia = "";
          midia = menu[0].midia;
          type_midia = menu[0].type_midia;
          let subscription = this.genProvider
            .onGetAllFilterPageDesc("dados/" + this.parametros.path + "/galeria", "ordem", "status", "Ativo", 999).subscribe(
              res => {
                subscription.unsubscribe();
                let galeria = JSON.parse(JSON.stringify(res));
                subscription.unsubscribe();
                let i = 0;
                if (galeria.length > 0) {
                  this.onMontaMenuGaleria(galeria).then(res => {
                    let formulario = {
                      origem: contato[0].origem,
                      midia: midia,
                      type_midia: type_midia,
                      contato: contato[0].id_canal,
                      mensagem:
                        texto +
                        this.ctrl +
                        res +
                        this.ctrl +
                        this.msg_navegacao,
                      caption:
                        texto + this.ctrl + res + this.ctrl + this.msg_navegacao
                    };
                    this.enviarMsg(formulario);
                  });
                } else {
                  let formulario = {
                    origem: contato[0].origem,
                    midia: midia,
                    type_midia: type_midia,
                    contato: contato[0].id_canal,
                    mensagem:
                      "*Desculpe! Não existe videos/imagens/documentos disponíveis no momento!*",
                    caption:
                      "*Desculpe! Não existe videos/imagens/documentos disponíveis no momento!*"
                  };
                  this.enviarMsg(formulario);
                  setTimeout(() => {
                    this.onOpcaochat(contato, "#");
                  }, 3000);
                }
              },
              err => console.log(err)
            );
        } else if (menu[0].tipo == "Classificado") {
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            midia: menu[0].midia,
            mensagem: menu[0].texto,
            caption: menu[0].texto,
            type_midia: menu[0].type_midia
          };
          this.enviarMsg(formulario);

          setTimeout(() => {
            let dataAtual = new Date();
            let inicio = dataAtual.setDate(dataAtual.getDate() - 5); // subtrai 3 dias
            //      let fim = dataFinal.setDate(dataFinal.getDate() + 1);
            //      let iniDate = new DatePipe('pt-BR').transform(inicio, 'yyyy-MM-dd');
            //      let finDate = new DatePipe('pt-BR').transform(fim, 'yyyy-MM-dd');
            let subscription = this.genProvider
              .onGetFilterOrder(
                "dados/" + this.parametros.path + "/classificado",
                "status",
                "time",
                inicio,
                ">="
              )
              .subscribe(
                data => {
                  subscription.unsubscribe();
                  let classificados = JSON.parse(JSON.stringify(data));
                  let i = 0;
                  let contador = 0;
                  if (classificados.length > 0) {
                    this.filtroClassificado(classificados, menu_opcao).then(
                      res => {
                        let data = JSON.parse(JSON.stringify(res));
                        if (data.length > 0) {
                          data.forEach(element => {
                            i++;
                            contador++;
                            let nome = new CamelcasePipe()
                              .transform(element.nome)
                              .trim();
                            let telefone = this.validaCampoProvider.validaTelefoneZap(
                              element.telefone
                            );
                            let texto = "*" + nome + "*" + this.ctrl;
                            texto += "*" + telefone + "*" + this.ctrl;
                            texto +=
                              "_" +
                              element.data_hora +
                              "_" +
                              this.ctrl +
                              this.ctrl;
                            texto += element.value + this.ctrl;
                            let formulario = {
                              origem: contato[0].origem,
                              contato: contato[0].id_canal,
                              mensagem: texto,
                              caption: texto,
                              midia: element.imagem,
                              type_midia: menu[0].type_midia
                            };
                            this.enviarMsg(formulario);
                            if (i >= data.length) {
                              setTimeout(() => {
                                let formulario = {
                                  origem: contato[0].origem,
                                  contato: contato[0].id_canal,
                                  mensagem: "*Total da Lista: " + i + "*",
                                  type_midia: menu[0].type_midia
                                };
                                //   this.enviarMsg(formulario);
                                this.onOpcaochat(contato, "#");
                              }, 10000);
                            }
                          });
                        } else {
                          let formulario = {
                            origem: contato[0].origem,
                            contato: contato[0].id_canal,
                            mensagem:
                              "*" +
                              menu_opcao +
                              "*" +
                              this.ctrl +
                              this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
                              menu +
                              this.ctrl +
                              this.msg_navegacao
                          };
                          this.enviarMsg(formulario);
                          formulario = {
                            origem: contato[0].origem,
                            contato: contato[0].id_canal,
                            mensagem:
                              "*Desculpe! No momento esta opção não esta disponível.*!*"
                          };
                          this.enviarMsg(formulario);
                          setTimeout(() => {
                            this.onOpcaochat(contato, "#");
                          }, 5000);
                        }
                      }
                    );
                  } else {
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem:
                        "*" +
                        menu_opcao +
                        "*" +
                        this.ctrl +
                        this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
                        menu +
                        this.ctrl +
                        this.msg_navegacao
                    };
                    this.enviarMsg(formulario);
                    formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem:
                        "*Desculpe! No momento esta opção não esta disponível.*!*"
                    };
                    this.enviarMsg(formulario);
                    setTimeout(() => {
                      this.onOpcaochat(contato, "#");
                    }, 5000);
                  }
                },
                err => console.log(err)
              );
          }, 5000);
        } else if (menu[0].tipo == "Midia") {
          let texto = menu[0].texto + this.ctrl + this.cancelar;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
            ,
            caption: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
            ,
            midia: menu[0].midia,
            type_midia: menu[0].type_midia
          };
          this.enviarMsg(formulario);
        } else if (menu[0].tipo == "Anunciar") {
          let texto = menu[0].texto;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
            ,
            caption: texto.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
            ,
            midia: menu[0].midia,
            type_midia: menu[0].type_midia
          };
          this.enviarMsg(formulario);
        } else if (menu[0].tipo == "Ticket") {
          let texto_menu = menu[0].texto;
          if (texto_menu == null) {
            texto_menu = "";
          } else {
            let tmp = texto_menu.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
              ;
            texto_menu = tmp;
          }
          this.onMontaMenuTicket().then(res => {
            let texto =
              texto_menu +
              this.ctrl +
              "*" +
              menu_opcao +
              "*" +
              this.ctrl +
              this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
              this.ctrl +
              res +
              this.ctrl +
              this.msg_navegacao;
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: texto,
              caption: texto,
              midia: menu[0].midia,
              type_midia: menu[0].type_midia
            };
            this.enviarMsg(formulario);
          });
        } else if (menu[0].tipo == "Atendimento") {
          let texto_menu = menu[0].texto;
          if (texto_menu == null) {
            texto_menu = "";
          } else {
            let tmp = texto_menu.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
              ;
            texto_menu = tmp;
          }
          this.onMontaMenuAtendimento().then(res => {
            let texto =
              texto_menu +
              this.ctrl +
              "*" +
              menu_opcao +
              "*" +
              this.ctrl +
              this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
              this.ctrl +
              res +
              this.ctrl +
              this.msg_navegacao;
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: texto,
              caption: texto,
              midia: menu[0].midia,
              type_midia: menu[0].type_midia
            };
            this.enviarMsg(formulario);
          });
        } else if (menu[0].tipo == "EnqueteEncerrada") {
          // INCIO
          let texto_menu = menu[0].texto;
          if (texto_menu == null) {
            texto_menu = "";
          } else {
            let tmp = texto_menu.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
              ;
            texto_menu = tmp;
          }
          if (this.enqueteEncerrada.length > 0) {
            this.onMontaMenuEnqueteEncerrada().then(res => {
              let texto =
                texto_menu +
                this.ctrl +
                "*" +
                menu_opcao +
                "*" +
                this.ctrl +
                this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
                this.ctrl +
                res +
                this.ctrl +
                this.msg_navegacao;
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto,
                caption: texto,
                midia: menu[0].midia,
                type_midia: menu[0].type_midia
              };
              this.enviarMsg(formulario);
            });
          } else {
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem:
                "No momento não existe enquetes encerradas disponíveis.",
              caption: "No momento não existe enquetes encerradas disponíveis.",
              midia: menu[0].midia,
              type_midia: menu[0].type_midia
            };
            this.enviarMsg(formulario);
            setTimeout(() => {
              this.onOpcaochat(contato, "0");
            }, 5000);
          }
        } else if (menu[0].tipo == "Enquete") {
          let texto_menu = menu[0].texto;
          if (texto_menu == null) {
            texto_menu = "";
          } else {
            let tmp = texto_menu.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))
              ;
            texto_menu = tmp;
          }
          this.onMontaMenuEnquete().then(res => {
            let texto =
              texto_menu +
              this.ctrl +
              "*" +
              menu_opcao +
              "*" +
              this.ctrl +
              this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
              this.ctrl +
              res +
              this.ctrl +
              this.msg_navegacao;
            let formulario = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              mensagem: texto,
              caption: texto,
              midia: menu[0].midia,
              type_midia: menu[0].type_midia
            };
            this.enviarMsg(formulario);
          });
        } else {
          // monta o menu de opcao
          this.onMontaMenu(menu, contato[0]).then((result: any) => {
            let res = result.menu;
            let formulario = {};
            if (data.tipo == "Pergunta Mensagem") {
              formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: data.saudacao + this.ctrl + res + this.ctrl + this.msg_navegacao
              };
            } else if (menu[0].numero > 0) {
              formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem:
                  "*" +
                  menu_opcao +
                  "*" +
                  this.ctrl +
                  this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
                  res +
                  this.ctrl +
                  this.msg_navegacao,
                caption:
                  "*" +
                  menu_opcao +
                  "*" +
                  this.ctrl +
                  this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) +
                  res +
                  this.ctrl +
                  this.msg_navegacao
              };
            } else {
              formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: menu[0].texto + this.ctrl + this.msg_navegacao
              };
            }
            let msg = {
              origem: contato[0].origem,
              contato: contato[0].id_canal,
              header: contato[0].menu,
              body: this.pergunta.segunda_saudacao + this.ctrl,
              footer: this.ctrl + "*Sair* - Encerrar atendimento" + this.ctrl + "*#* - Voltar" + this.ctrl + "*0* - Início",
              title: contato[0].menu,
              button: "Menu",
              rows: result.rows,
              list: true
            };
            if (contato[0].menu_lista) {
              this.enviarMsg(msg);
            } else {
              this.enviarMsg(formulario);
            }
          });
        }
      } else {
        let texto =
          "*Desculpe, no momento esta opção não esta disponível.*" + this.ctrl;

        let formulario = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          mensagem: texto
        };
        this.enviarMsg(formulario);
        setTimeout(() => {
          this.onOpcaochat(contato, "0");
        }, 5000);
      }
      // fim
    });
  }
  onMenosNivel(contato) {
    let nivel = contato[0].nivel - 1;
    if (nivel <= -1) {
      nivel = 0;
    }
    if (nivel == 0) {
      this.filtroNivel(this.menus, 0, null).then(menu => {
        this.onMontaMenu(menu, contato[0]).then((result: any) => {
          let res = result.menu;
          let menu = res;
          let formulario = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            mensagem: this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) + menu + this.ctrl + this.rodape,
            caption: this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) + menu + this.ctrl + this.rodape
          };
          let msg = {
            origem: contato[0].origem,
            contato: contato[0].id_canal,
            header: contato[0].menu,
            body: this.pergunta.segunda_saudacao + this.ctrl,
            footer: this.ctrl + "*Sair* - Encerrar atendimento" + this.ctrl + "*#* - Voltar" + this.ctrl + "*0* - Início",
            title: contato[0].menu,
            button: "Menu",
            rows: result.rows,
            list: true
          };
          if (this.menu_principal_lista) {
            this.enviarMsg(msg);
          } else {
            this.enviarMsg(formulario);
          }

          (contato[0].data_hora = new DatePipe("pt-BR").transform(
            Date.now(),
            "d, MMMM yyyy - HH:mm"
          )),
            contato[0].time = Date.now();
          contato[0].nivel = 0;
          contato[0].key_master = 0;
          contato[0].key_child = 0;
          contato[0].uid = 0;
          contato[0].key_pergunta = this.key_pergunta;
          contato[0].opcao = 0;
          contato[0].tipo = "Pergunta";
          //   contato[0].menu = menu_opcao;
          this.atualizaContato(contato[0]);
          //     this.genProvider.onSaveDocKey('dados/' + this.parametros.path + '/contato', contato.telefone, contato[0]).then(t => {}).catch(e => {console.log('Atenção, Erro.')});
        });
      });
    } else {
      this.filtroUid(this.menus, contato[0].key_child.toString()).then(res => {
        let uid = JSON.parse(JSON.stringify(res));
        let filtro =
          nivel.toString() +
          contato[0].key_master.toString() +
          uid[0].key_child.toString();
        this.filtroUid(this.menus, uid[0].key_child.toString()).then((res_menu_list: any) => {
          let menu_ant = JSON.parse(JSON.stringify(res_menu_list));
          contato[0].menu = menu_ant[0].texto;
          contato[0].menu_lista = menu_ant[0].menu_lista;
          this.filtroMenu(this.menus, filtro).then(res => {
            let menu = JSON.parse(JSON.stringify(res));
            this.onMontaMenu(menu, contato[0]).then((result: any) => {
              let res = result.menu;
              let menu_opc = res;
              let formulario = null
              if (menu[0].numero > 0) {
                formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem:
                    this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) + menu_opc + this.ctrl + this.msg_navegacao,
                  caption:
                    this.escolha_opcao.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome)) + menu_opc + this.ctrl + this.msg_navegacao
                };
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  header: contato[0].menu,
                  body: this.pergunta.segunda_saudacao + this.ctrl,
                  footer: this.ctrl + "*Sair* - Encerrar atendimento" + this.ctrl + "*#* - Voltar" + this.ctrl + "*0* - Início",
                  title: contato[0].menu,
                  button: "Menu",
                  rows: result.rows,
                  list: true
                };
                if (contato[0].menu_lista) {
                  this.enviarMsg(msg);
                } else {
                  this.enviarMsg(formulario);
                }
                contato[0].data_hora = new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm");
                contato[0].acesso = 2;
                contato[0].time = Date.now();
                contato[0].nivel = nivel;
                contato[0].key_master = menu[0].key_master;
                contato[0].key_child = menu[0].key_child;
                contato[0].uid = menu[0].uid;
                contato[0].key_pergunta = this.key_pergunta;
                contato[0].tipo = menu[0].tipo;
                this.atualizaContato(contato[0]);
              } else {
                let navegacao = "*" + this.msg_navegacao + "*";
                if (this.parametros.menu_automatico) {
                  navegacao = "";
                }
                let formulario = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  mensagem: menu[0].texto + this.ctrl,
                };
                let msg = {
                  origem: contato[0].origem,
                  contato: contato[0].id_canal,
                  header: contato[0].menu,
                  body: this.pergunta.segunda_saudacao + this.ctrl,
                  footer: "Digite *sair* para encerrar seu atendimento.",
                  title: contato[0].menu,
                  button: "Menu",
                  rows: result.rows,
                  list: true
                };
                if (contato[0].menu_lista) {
                  this.enviarMsg(msg);
                } else {
                  this.enviarMsg(formulario);
                }

                let data = menu;
                contato[0].data_hora = new DatePipe("pt-BR").transform(Date.now(), "d, MMMM yyyy - HH:mm");
                contato[0].acesso = 2;
                contato[0].time = Date.now();
                contato[0].nivel = nivel;
                contato[0].key_master = data[0].key_master;
                contato[0].key_child = data[0].key_child;
                contato[0].uid = data[0].uid;
                contato[0].key_pergunta = this.key_pergunta;
                contato[0].tipo = data[0].tipo;
                this.atualizaContato(contato[0]);
                const index = data.indexOf(data[0]);
                data.splice(index, 1);
                if (data.length > 0) {
                  this.onMontaMenu(data, contato[0]).then((result: any) => {
                    let res = result.menu;
                    let formulario = {
                      origem: contato[0].origem,
                      contato: contato[0].id_canal,
                      mensagem: res + this.ctrl + navegacao,
                    };
                    setTimeout(() => {
                      this.enviarMsg(formulario);
                    }, 1000);
                  });
                }
              }
              // this.genProvider.onSaveDocKey('dados/' + this.parametros.path + '/contato', contato[0].telefone, contato[0]).then(t => {}).catch(e => {console.log('Atenção, erro ao salvar dados.')});
            });
          });

        });

      });
    }
    // atualiza
  }

  onVoltaOpcao(contato) {
    let nivel = contato[0].nivel - 1;
    if (nivel <= -1) {
      nivel = 0;
    }
    if (nivel == 0) {
      this.filtroNivel(this.menus, 0, null).then(menu => {
        this.onMontaMenu(menu, contato[0]).then((result: any) => {
          let res = result.menu;
          let menu = res;
          (contato[0].data_hora = new DatePipe("pt-BR").transform(
            Date.now(),
            "d, MMMM yyyy - HH:mm"
          )),
            (contato[0].time = Date.now());
          contato[0].nivel = 0;
          contato[0].key_master = 0;
          contato[0].key_child = 0;
          contato[0].uid = 0;
          contato[0].key_pergunta = this.key_pergunta;
          contato[0].opcao = 0;
          contato[0].tipo = "Pergunta";
          this.atualizaContato(contato[0]);
          //     this.genProvider.onSaveDocKey('dados/' + this.parametros.path + '/contato', contato.telefone, contato[0]).then(t => {}).catch(e => {console.log('Atenção, Erro.')});
        });
      });
    } else {
      //  console.log ('nivel > 0')
      this.filtroUid(this.menus, contato[0].key_child.toString()).then(res => {
        let uid = JSON.parse(JSON.stringify(res));
        let filtro =
          nivel.toString() +
          contato[0].key_master.toString() +
          uid[0].key_child.toString();
        this.filtroMenu(this.menus, filtro).then(res => {
          let menu = JSON.parse(JSON.stringify(res));
          this.onMontaMenu(menu, contato[0]).then((result: any) => {
            let res = result.menu;
            let menu_opc = res;
            (contato[0].data_hora = new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            )),
              contato[0].acesso = 2;
            contato[0].time = Date.now();
            contato[0].nivel = nivel;
            contato[0].key_master = menu[0].key_master;
            contato[0].key_child = menu[0].key_child;
            contato[0].uid = menu[0].uid;
            contato[0].key_pergunta = this.key_pergunta;
            contato[0].tipo = menu[0].tipo;
            this.atualizaContato(contato[0]);
            // this.genProvider.onSaveDocKey('dados/' + this.parametros.path + '/contato', contato[0].telefone, contato[0]).then(t => {}).catch(e => {console.log('Atenção, erro ao salvar dados.')});
          });
        });
      });
    }
    // atualiza
  }
  // fim

  //finaliza atendimento
  onEncerraEnquete(contato) {
    if (this.finaliza_chatbot) {
      this.onOpcaochat(contato, "-1");
    } else {
      this.genProvider.onIncrementKeyDateTime().then((keyValue: any) => {
        contato[0].protocolo = keyValue;
        this.onOpcaochat(contato, "0");
      });
    }
  }
  onFinalizaSair(contato) {
    if (contato[0].timeMsg) {
      clearTimeout(contato[0].timeMsg)
    }
    this.onOpcaochat(contato, "-1");
  }
  onFinalizaAtendimento(contato) {
    this.onIntegracao(contato[0].protocolo);
    if (!this.enquete_final) {
      let formulario = {
        origem: contato[0].origem,
        contato: contato[0].id_canal,
        mensagem: this.mensagem.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

      };
      if (this.finaliza_chatbot) {
        this.onOpcaochat(contato, "-1");
      } else {
        this.genProvider.onIncrementKeyDateTime().then((keyValue: any) => {
          contato[0].protocolo = keyValue;
          this.onOpcaochat(contato, "0");
        });
      }
    } else {
      this.onFinalizaAtendimentoEnquete(contato)
    }

  }
  onFinalizaAtendimentoEnquete(contato) {
    this.onWebHookMsg(contato[0].protocolo);
    let formulario = {
      origem: contato[0].origem,
      contato: contato[0].id_canal,
      mensagem: this.mensagem.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

    };
    let tmp_contato = contato[0]
    this.excluirContato(tmp_contato);
    this.enviarMsg(formulario);
    if (contato.agente) {
      contato[0].agente = contato.agente
      contato[0].key_agente = contato.key_agente
      contato[0].enquete = true
    } else {
      contato[0].agente = "AgenteBot"
      contato[0].key_agente = "000001"
      contato[0].enquete = true
    }
    //  this.atualizaContato(contato)
    setTimeout(() => {
      this.onOpenEnquete(contato, this.opcao_enquete);
    }, 2000);

  }
  onFinalizaAtendimentochat(contato) {
    if (this.enquete_final) {
      this.onFinalizaAtendimentoEnquete(contato)
    } else {
      this.onFinalizaAtendimento(contato)
    }
  }
  onFinalizachat(data) {
    let contato = [data]
    if (this.parametros.plataforma == "181") {
      this.mensagem = "Seu atendiento foi finalizado.";
      let formulario = {
        origem: contato[0].origem,
        contato: contato[0].id_canal,
        mensagem: this.mensagem.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

      };
      if (this.enquete_final) {
        if (contato[0].faz_enquete) {
          this.onOpenEnquete(contato, this.opcao_enquete);
        } else {
          this.enviarMsg(formulario);
          let tmp_contato = contato[0]
          this.excluirContato(tmp_contato);
        }
      } else {
        this.enviarMsg(formulario);
        let tmp_contato = contato[0]
        this.excluirContato(tmp_contato);
      }

    } else {
      if (!this.mensagem) {
        this.mensagem = "{{2}}, seu atendiento foi finalizado.";
      }
      let formulario = {
        contato: contato[0].id_canal,
        mensagem: this.mensagem.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

      };
      if (this.enquete_final) {
        if (contato[0].faz_enquete) {
          this.onOpenEnquete(contato, this.opcao_enquete);
        } else {
          this.enviarMsg(formulario);
          let tmp_contato = contato[0]
          this.excluirContato(tmp_contato);
        }
      } else {
        this.enviarMsg(formulario);
        let tmp_contato = contato[0]
        this.excluirContato(tmp_contato);
      }
    }
  }
  onOpenEnquete(contato, key) {
    this.onMontaMenuEnquete().then(log => {
      if (log) {
        this.filtroMenuEnqueteKey(key).then(menu => {
          let data = JSON.parse(JSON.stringify(menu));
          this.onMontaMenuEnqueteOpcao(key).then(res => {
            let navegacao =
              "A qualquer momento digite *_0_* para cencelar.";
            let item = JSON.parse(JSON.stringify(res));
            let texto = "";
            if (data[0].mostra_texto) {
              texto =
                "*" +
                data[0].nome +
                "*" +
                this.ctrl +
                data[0].texto +
                this.ctrl +
                item +
                this.ctrl +
                this.ctrl +
                navegacao;
            } else {
              texto =
                "*" +
                data[0].nome +
                "*" +
                this.ctrl +
                item +
                this.ctrl +
                this.ctrl +
                navegacao;
            }
            if (item.length > 0) {
              let formulario = {
                origem: contato[0].origem,
                contato: contato[0].id_canal,
                mensagem: texto || "", //+this.ctrl+this.ctrl+this.msg_navegacao,
                midia: data[0].midia,
                type_midia: data[0].type_midia,
                caption: texto || ""
              };
              this.enviarMsg(formulario);
              contato[0].acesso = 2;
              contato[0].time = Date.now();
              contato[0].nivel = 2;
              contato[0].tipo = "EnqueteOpcao";
              this.atualizaContato(contato[0]);
            }
          });
        });
      } else {
        if (!this.mensagem) {
          this.mensagem = "{{2}}, seu atendiento foi finalizado.";
        }
        let formulario = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          mensagem: this.mensagem.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

        };
        this.enviarMsg(formulario);
        let tmp_contato = contato[0]
        this.excluirContato(tmp_contato);
      }
    });
  }
  onFinalizaMensagem(contato) {
    if (!this.mensagem) {
      this.mensagem = "{{2}}, seu atendiento foi finalizado.";
    }
    let formulario = {
      origem: contato[0].origem,
      contato: contato[0].id_canal,
      mensagem: this.mensagem.replace("{{2}}", this.validaCampoProvider.pegaPrimeraPalavra(contato[0].nome))

    };
    this.enviarMsg(formulario);
    this.onWebHookMsg(contato[0].protocolo);
    setTimeout(() => {
      this.excluirProtocolo(contato[0].protocolo);
      this.onOpcaochat(contato, "-2");
    }, 3000);
  }
  // fim

  //monta menus de opcao
  onContatoEnquete(contato, key) {
    return new Promise(resolve => {
      this.genProvider
        .onGetFilterOrder(
          "dados/" + this.parametros.path + "/enquete_voto",
          "key_enquete",
          "telefone",
          contato
        )
        .subscribe(
          data => {
            let res = JSON.parse(JSON.stringify(data));
            let tmp = res.filter(obj => {
              return obj.key_enquete == key;
            });
            resolve(tmp);
          },
          err => console.log(err)
        );
    });
  }
  onMontaMenu(menu, contato?: any) { /* monta todos os menus de opcao*/
    //  console.log(menu)
    menu.sort(function (a, b) {
      if (a.numero > b.numero) {
        return 1;
      }
      if (a.numero < b.numero) {
        return -1;
      }
      return 0;
    });
    let mensagem = "";
    let rows = [];

    return new Promise(resolve => {
      if (menu[0].numero > 0) {
        for (let index = 0; index < menu.length; index++) {
          if (!menu[index].emoji) {
            menu[index].emoji = "";
          } else {
            menu[index].emoji = menu[index].emoji + "";
          }
          let numero = ''
          if (this.mostra_numero_menu) {
            numero = this.ctrl + "*" + menu[index].numero + "* - "
          } else {
            numero = this.ctrl + ''
          }
          mensagem +=
            numero +
            menu[index].emoji +
            menu[index].texto;
          let row = {
            id: menu[index].numero.toString(),
            title: menu[index].texto,
            description: menu[index].saudacao || menu[index].texto
          }
          rows.push(row)
          if (index + 1 == menu.length) {
            if (contato.nivel > 0) {
              let result = {
                menu: mensagem + this.ctrl + this.msgMenu + this.ctrl,
                rows: rows
              }
              resolve(result);
            } else {
              row = {
                id: 'sair',
                title: 'Sair',
                description: '🤝Finalizar atendimento'
              }
              rows.push(row)
              let result = {
                menu: mensagem + this.ctrl + this.ctrl + '*Sair* - 🤝Finalizar atendimento' + this.ctrl,
                rows: rows
              }
              resolve(result);
            }
          }
        }
      } else {
        resolve(menu[0].texto)
      }
    });
  }
  onMontaMenuAtendimento() {
    let menu = this.puc;
    let mensagem = "";
    menu.sort(function (a, b) {
      if (a.numero > b.numero) {
        return 1;
      }
      if (a.numero < b.numero) {
        return -1;
      }
      return 0;
    });
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        } else {
          menu[index].emoji = menu[index].emoji + "";
        }
        let numero = ''
        if (this.mostra_numero_menu) {
          numero = this.ctrl + "*" + menu[index].numero + "* - "
        } else {
          numero = this.ctrl + ''
        }
        mensagem +=
          numero +
          menu[index].emoji +
          menu[index].nome;
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuTicket() {
    let menu = this.puc;
    menu.sort(function (a, b) {
      if (a.numero > b.numero) {
        return 1;
      }
      if (a.numero < b.numero) {
        return -1;
      }
      return 0;
    });
    let mensagem = "";
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        } else {
          menu[index].emoji = menu[index].emoji + "";
        }
        let numero = ''
        if (this.mostra_numero_menu) {
          numero = this.ctrl + "*" + menu[index].numero + "* - "
        } else {
          numero = this.ctrl + ''
        }
        mensagem +=
          numero +
          menu[index].emoji +
          menu[index].nome;
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuEnqueteOpcao(key) {
    let mensagem = "";
    let menu = this.enqueteOpcao.filter(obj => {
      return obj.key_enquete == key;
    });
    menu.sort(function (a, b) {
      if (a.numero > b.numero) {
        return 1;
      }
      if (a.numero < b.numero) {
        return -1;
      }
      return 0;
    });
    this.menuEnqueteOpcao = menu;
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        }
        mensagem +=
          this.ctrl +
          "*" +
          menu[index].numero +
          "* - " +
          menu[index].emoji +
          " " +
          menu[index].texto;
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuEnquete() {
    let menu = this.enquete;
    let mensagem = "";
    this.menu_enquete = [];
    return new Promise(resolve => {
      if (menu.length > 0) {
        for (let index = 0; index < menu.length; index++) {
          if (!menu[index].emoji) {
            menu[index].emoji = "";
          }
          let tmp = {
            numero: index + 1,
            emoji: menu[index].emoji,
            nome: menu[index].titulo,
            midia: menu[index].imagem,
            texto: menu[index].pergunta,
            key_enquete: menu[index].key_enquete,
            data_hora: menu[index].data_hora,
            type_midia: menu[index].type_midia,
            key: menu[index].key,
            mostra_texto: menu[index].mostra_texto
            // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
          };
          let pergunta = "";
          if (menu[index].mostra_texto) {
            pergunta = menu[index].pergunta;
          }
          this.menu_enquete.push(tmp);
          mensagem +=
            this.ctrl +
            "*" +
            (index + 1) +
            "* ] *" +
            menu[index].emoji +
            " " +
            menu[index].titulo +
            "*" +
            this.ctrl +
            pergunta;
          if (index + 1 == menu.length) {
            resolve(mensagem + this.ctrl);
          }
        }
      } else {
        resolve(null);
      }

    });
  }
  onMontaMenuEnqueteEncerrada() {
    let menu = this.enqueteEncerrada;
    let mensagem = "";
    this.menu_enquete_encerrada = [];
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        }
        let tmp = {
          numero: index + 1,
          emoji: menu[index].emoji,
          nome: menu[index].titulo,
          midia: menu[index].imagem,
          texto: menu[index].pergunta,
          key_enquete: menu[index].key_enquete,
          data_hora: menu[index].data_hora,
          type_midia: menu[index].type_midia,
          key: menu[index].key,
          imgChart: menu[index].imgChart,
          votos: menu[index].votos,
          data_encerramento: menu[index].data_encerramento
          // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
        };
        this.menu_enquete_encerrada.push(tmp);
        //        mensagem += this.ctrl+'*'+(index+1)+ '* ] *' + menu[index].emoji +" "+ menu[index].titulo +'*'+ this.ctrl+ menu[index].pergunta
        mensagem +=
          this.ctrl +
          "*" +
          (index + 1) +
          "* ] *" +
          menu[index].emoji +
          " " +
          menu[index].titulo +
          "*";
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuPesquisa(pesquisa) {
    let menu = pesquisa;
    let mensagem = "";
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        if (!menu[index].emoji) {
          menu[index].emoji = "";
        }
        mensagem +=
          this.ctrl +
          "*" +
          menu[index].numero +
          "* - " +
          menu[index].emoji +
          " " +
          menu[index].texto;
        //         mensagem += '*'+menu[index].numero + '* - ' + menu[index].nome +this.ctrl;
        //      mensagem +=`[ *${menu[index].numero}* ] ${menu[index].texto}`;
        if (index + 1 == menu.length) {
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuGaleria(dados) {
    let menu = dados;
    let mensagem = "";
    this.galeria = [];
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        let tmp = {
          numero: index + 1,
          titulo: menu[index].titulo,
          midia: menu[index].midia,
          descricao: menu[index].descricao,
          data_hora: menu[index].data_hora,
          type_midia: menu[index].type_midia
          // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
        };
        this.galeria.push(tmp);
        let titulo = "";
        if (
          menu[index].type_midia == "jpg" ||
          menu[index].type_midia == "jpeg" ||
          menu[index].type_midia == "png"
        ) {
          titulo = "🖼 " + menu[index].titulo;
        } else if (menu[index].type_midia == "mp4") {
          titulo = "📹 " + menu[index].titulo;
        } else if (menu[index].type_midia == "ogg") {
          titulo = "🔊 " + menu[index].titulo;
        } else {
          titulo = "📰 " + menu[index].titulo;
        }
        let descricao = menu[index].descricao.substring(0, 60) + "...";
        let data_hora = menu[index].data_hora;

        mensagem +=
          this.ctrl +
          "*" +
          (index + 1) +
          "* - *" +
          titulo +
          "*" +
          this.ctrl +
          descricao +
          this.ctrl +
          data_hora +
          this.ctrl;
        if (index + 1 == menu.length) {
          mensagem += this.ctrl + "*Total na Galeria: " + (index + 1) + "*";
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuPublicidade(dados) {
    let menu = dados;
    let mensagem = "";
    this.publicidade = [];
    // console.log (dados)
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        let tmp = {
          numero: index + 1,
          nome: menu[index].nome,
          midia: menu[index].midia,
          texto: menu[index].texto,
          telefone: menu[index].telefone || " ",
          data_hora: menu[index].data_hora,
          type_midia: menu[index].type_midia,
          localizacao: menu[index].localizacao,
          complemento: menu[index].complemento,
          mostra_localizacao: menu[index].mostra_localizacao,
          desconto: menu[index].des_max,
          latitude: menu[index].latitude,
          longitude: menu[index].longitude

          // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
        };
        if (menu[index].des_max) {
          menu[index].localizacao +=
            this.ctrl + "*Desconto de até " + menu[index].des_max + "%*";
          menu[index].complemento +=
            this.ctrl + "*Desconto de até " + menu[index].des_max + "%*";
        }
        this.publicidade.push(tmp);
        if (menu[index].mostra_localizacao) {
          mensagem +=
            this.ctrl +
            "*" +
            (index + 1) +
            "* ] *" +
            menu[index].nome +
            "*" +
            this.ctrl +
            menu[index].localizacao +
            this.ctrl;
        } else {
          mensagem +=
            this.ctrl +
            "*" +
            (index + 1) +
            "* ] *" +
            menu[index].nome +
            "*" +
            this.ctrl +
            menu[index].complemento +
            this.ctrl;
        }
        if (index + 1 == menu.length) {
          mensagem += this.ctrl + "*Total da Lista: " + (index + 1) + "*";
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  onMontaMenuNoticia(dados) {
    let menu = dados;
    let mensagem = "";
    this.noticia = [];
    // console.log (dados)
    return new Promise(resolve => {
      for (let index = 0; index < menu.length; index++) {
        let tmp = {
          numero: index + 1,
          titulo: menu[index].titulo,
          midia: menu[index].midia,
          descricao: menu[index].descricao,
          data_hora: menu[index].data_hora,
          type_midia: menu[index].type_midia

          // localizacao : menu[index].rua+', '+menu[index].numero+' - '+menu[index].bairro +' - '+menu[index].cidade
        };
        this.noticia.push(tmp);
        mensagem +=
          this.ctrl +
          "*" +
          (index + 1) +
          "* ] *" +
          menu[index].titulo +
          "*" +
          this.ctrl +
          menu[index].data_hora +
          this.ctrl;
        if (index + 1 == menu.length) {
          mensagem += this.ctrl + "*Total de Notícias: " + (index + 1) + "*";
          resolve(mensagem + this.ctrl);
        }
      }
    });
  }
  //fim

  //Pesquisas
  pesquisaPerguntachatbot(chave, file, nivel?: any) {
    //  var RegExp = /\b[^A-Za-zÀ-ú][^A-Za-zÀ-ú]+,?\s[^A-Za-zÀ-ú][^A-Za-zÀ-ú]{2,19}\b/ig;
    var RegExp = /[^A-Za-zÀ-ú]/gi;
    let pesquisa = chave.replace(RegExp, " ");
    var array_pergunta = pesquisa.split(/\s* \s*/);
    /*
    let chatbot_pergunta = file.filter(obj => {
      return obj.pergunta;
    });
    let chatbot = chatbot_pergunta.filter(obj => {
      return obj.nivel >= nivel;
    });
    */
    let chatbot = file.filter(obj => {
      return obj.pergunta;
    });
    return new Promise(resolve => {
      for (let i = 0; i < array_pergunta.length; i++) {
        let pergunta = array_pergunta[i].trim();
        let res = [];
        if (pergunta.length >= 3) {
          // var array_chatbot = pesquisa.split(/\s* \s*/);
          res = chatbot.filter(obj => {
            if (
              obj.pergunta
                .toLocaleLowerCase()
                .indexOf(pergunta.toLowerCase()) >= 0
            ) {
              return true;
            }
            return false;
          });
        }
        if (res.length > 0) {
          i = array_pergunta.length + 1;
          resolve(res);
          //  return true;
        }
        if (i + 1 >= array_pergunta.length) {
          //   console.log (res)
          resolve(false);
          //    return false;
        }
      }
    });
  }
  pesquisaPergunta(menus, chave) {
    var RegExp = /[^A-Za-zÀ-ú]/gi;
    let pesquisa = chave.replace(RegExp, " ");
    var array_pergunta = pesquisa.split(/\s* \s*/);
    let menu = menus.filter(obj => {
      return obj.pergunta;
    });
    return new Promise(resolve => {
      for (let i = 0; i < array_pergunta.length; i++) {
        let pergunta = array_pergunta[i].trim();
        let res = [];
        if (pergunta.length >= 4) {
          res = menu.filter(obj => {
            if (
              obj.pergunta
                .toLocaleLowerCase()
                .indexOf(pergunta.toLowerCase()) >= 0
            ) {
              return true;
            }
            return false;
          });
        }
        if (res.length > 0) {
          i = array_pergunta.length + 1;
          resolve(res);
        }
        if (i + 1 >= array_pergunta.length) {
          resolve(false);
        }
      }
    });
  }
  pesquisaPerguntaNivel(menus, chave, nivel) {
    var RegExp = /[^A-Za-zÀ-ú]/gi;
    let pesquisa = chave.replace(RegExp, " ");
    var array_pergunta = pesquisa.split(/\s* \s*/);
    let menu_pergunta = menus.filter(obj => {
      return obj.pergunta;
    });
    let menu = menu_pergunta.filter(obj => {
      return obj.nivel == nivel;
    });
    return new Promise(resolve => {
      for (let i = 0; i < array_pergunta.length; i++) {
        let pergunta = array_pergunta[i].trim();
        let res = [];
        if (pergunta.length >= 4) {
          res = menu.filter(obj => {
            if (
              obj.pergunta
                .toLocaleLowerCase()
                .indexOf(pergunta.toLowerCase()) >= 0
            ) {
              return true;
            }
            return false;
          });
        }
        if (res.length > 0) {
          i = array_pergunta.length + 1;
          resolve(res);
        }
        if (i + 1 >= array_pergunta.length) {
          resolve(false);
        }
      }
    });
  }
  pesquisaDenuncia(protocolo) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/denuncia", "protocolo", protocolo).subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
  pesquisaDenuncia_body(protocolo) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetFilterOrder("dados/" + this.parametros.path + "/denuncia_body", "time", "protocolo", protocolo).subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
  pesquisaMensagens(protocolo) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/mensagem", "protocolo", protocolo).subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
  pesquisaMensagens_body(protocolo) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetAll("dados/" + this.parametros.path + "/mensagem/" + protocolo + "/mensagem_body", "time").subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
  pesquisaMensagens_old(protocolo) {
    return new Promise(resolve => {
      let res = this.mensagens.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  pesquisaMensagens_body_old(protocolo) {
    return new Promise(resolve => {
      let res = this.mensagens_body.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  pesquisaOuvidoria(protocolo) {
    return new Promise(resolve => {
      let res = this.ouvidoria.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  pesquisaOuvidoria_body(protocolo) {
    return new Promise(resolve => {
      let res = this.ouvidoria_body.filter(obj => {
        return obj.protocolo == protocolo;
      });
      resolve(res);
    });
  }
  pesquisaChat(protocolo) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/chat", "protocolo", protocolo).subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
  pesquisaTicket(protocolo) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetfilter("dados/" + this.parametros.path + "/ticket", "protocolo", protocolo).subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
  pesquisaChat_body(protocolo) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetAll("dados/" + this.parametros.path + "/chat/" + protocolo + "/chat_body", "time").subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
  pesquisaTicket_body(ticket) {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetAll("dados/" + this.parametros.path + "/ticket/" + ticket + "/ticket_body", "time").subscribe(data => {
        unSub.unsubscribe();
        let dados = JSON.parse(JSON.stringify(data));
        resolve(dados);
      });
    });
  }
  // fim
  //monitoramento
  onMsgInatividade(element: any, texto?: string) {
    let msg = this.atendimento_final.replace("{{2}}", element.nome);
    msg = msg.replace(
      "Atendimento Finalizado",
      "Seu atendimento foi finalizado por inatividade!"
    );
    if (texto) {
      msg = texto
    }

    this.filtroNivel(this.menus, 0, 0).then(menu => {
      if (this.informaProtocolo) {
        msg = msg + this.ctrl + "*Protocolo :" + element.protocolo + "*";
      } else {
        msg =
          msg +
          this.ctrl +
          this.ctrl +
          new DatePipe("pt-BR").transform(Date.now(), "HH:mm:ss");
      }
      let formulario = {
        origem: element.origem,
        contato: element.telefone,
        mensagem: msg,
        midia: this.pergunta.midia
      };
      this.enviarMsg(formulario);
    });
  }
  onFinalizaProcessos(contato) {
    let dados_msg = {
      key: contato.protocolo,
      status: "Cancelada"
    };
    this.pesquisaMensagens(contato.protocolo).then(
      data => {
        let dados = JSON.parse(JSON.stringify(data));
        if (dados.length > 0) {
          this.genProvider.onSaveObjeto(
            "dados",
            this.parametros.path,
            "mensagem",
            dados_msg
          );
          //   this.onWebHookMsg(dados[0].protocolo);
        }
      },
      err => console.log(err)
    );
    this.pesquisaChat(contato.protocolo).then(
      data => {
        let res = JSON.parse(JSON.stringify(data));
        if ((res.length > 0) && (res[0].status == "Enviando...")) {
          this.excluirMensagem(contato.protocolo);
        } else if ((res.length > 0) && (res[0].chat)) {
          this.pesquisaChat_body(contato.protocolo).then(res => {
            let dados_msg = {
              key: contato.protocolo,
              status: "Encerrado",
              time: Date.now(),
              data_criacao: Date.now(),
              value: "SEM COMUNICAÇÃO COM USUÁRIO"
            };
            let texto = "*Atendimento Encerrado*" + this.ctrl + "Por falta de comunicação, o atendimento será encerrado."
            this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
            let tmp_contato = contato[0]
            this.excluirContato(tmp_contato);
            this.onMsgInatividade(contato, texto);
          })
        }
      },
      err => console.log(err)
    );
    this.pesquisaOuvidoria(contato.protocolo).then(
      data => {
        let dados = JSON.parse(JSON.stringify(data));
        if (dados.length > 0) {
          this.genProvider.onSaveObjeto(
            "dados",
            this.parametros.path,
            "ouvidoria",
            dados_msg
          );
          this.onWebHookMsg(dados[0].protocolo);
        }
      },
      err => console.log(err)
    );
  }
  temporizador() {
    // console.log('aki')
    return (this.time = new Observable(observer => {
      setInterval(() => {
        //   console.log(new Date().toString())
        observer.next(new Date().toString());
      }, 60000);
    }));
  }
  onAtualizaEnvio(path, key) {
    this.genProvider
      .onUpdateMsgEnviada(path, key)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });
  }
  onAtualizaEntregue(path, key) {
    this.genProvider
      .onUpdateMsgEntregue(path, key)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });
  }
  onAtualizaFalha(path, key) {
    this.genProvider
      .onUpdateMsgFalha(path, key)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });
  }
  onLoadPendente() {
    this.unSubPendente = this.genProvider.onGetFilterOrderDesc('dados/' + this.parametros.path + '/chat', "time", "status", "Pendente").subscribe(data => {
      this.msgPendente = JSON.parse(JSON.stringify(data));
    });
  }
  /***/
  onCheckPendente() {
    this.temporizador().subscribe(res => {
      this.msgPendente.forEach(data => {
        if (data.status = "Pendente") {
          let time = new Date();
          let date = new Date(time.getTime() - this.time_inatividade * 60 * 1000);
          let tempo = Date.parse(date.toString());
          if (data.time <= tempo) {
            setTimeout(() => {
              let dados_msg = {
                key: data.protocolo,
                status: "Encerrado",
                time: Date.now(),
                data_criacao: Date.now(),
                value: "SEM COMUNICAÇÃO COM USUÁRIO",
                faz_enquete: false
              };
              this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
              data.status = "Encerrado"
              let texto = "*Atendimento Encerrado.*" + this.ctrl +
                "Por falta de comunicação, o atendimento será encerrado." + this.ctrl +
                "*Esta é uma mensagem automática, não responda* 😉"
              let formulario = {
                origem: data.origem,
                contato: data.telefone,
                mensagem: texto
              };
              this.enviarMsg(formulario);
            }, 1000);
            let tmp_contato = data
            this.excluirContato(tmp_contato);
          };
        }
      });
    });
  }
  /***/
  onFinalizaUsuario() {
    this.temporizador().subscribe(res => {
      let time = new Date();
      let date = new Date(time.getTime() - this.time_resposta * 60 * 1000);
      let tempo = Date.parse(date.toString());
      let dateInavtivos = new Date(time.getTime() - this.time_inatividade * 60 * 1000);
      let tempoInativos = Date.parse(dateInavtivos.toString());
      let contatos = this.contatos.filter(obj => {
        return obj.time <= tempo;
      });
      let contatosInativos = this.contatos.filter(obj => {
        return obj.time <= tempoInativos;
      });
      /*
      for (let i = 0; i < contatos.length; i++) {
        const e = contatos[i];
        if ((e.nivel > 0) && (e.nivel < 200)) {
          this.onFinalizaProcessos(e);
          setTimeout(() => {
            this.onMsgInatividade(e);
            this.excluirContato(e.id_canal);
          }, 1000);
        }
      }
      */
      for (let i = 0; i < contatosInativos.length; i++) {
        const e = contatosInativos[i];
        if (e.protocolo) {
          this.pesquisaChat(e.protocolo).then(res => {
            let dados = JSON.parse(JSON.stringify(res));
            if (dados.length == 0) {
              this.pesquisaMensagens(e.protocolo).then(res => {
                let dados = JSON.parse(JSON.stringify(res));
                if (dados.length == 0) {
                  this.onMsgInatividade(e);
                  let tmp_contato = e
                  this.excluirContato(tmp_contato);
                }
              })
              //              this.onMsgInatividade(e);
              //              this.excluirContato(e.id_canal);
            }
          })
        } else {
          this.onMsgInatividade(e);
          let tmp_contato = e
          this.excluirContato(tmp_contato);
        }
      }
    });
  }
  //fim

  //mensagem em massa
  onStartCampanha(msg) {
    this.onConfig();
    let data = msg;
    data.status = "Enviando";
    data.data_inicio = new DatePipe("pt-BR").transform(
      Date.now(),
      "d, MMMM yyyy - HH:mm:ss"
    );
    this.genProvider
      .onSaveObjeto("dados", this.parametros.path, "campanha", data)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });

    let path = "dados/" + this.parametros.path + "/campanha";
    var strTmp = this.parametros.saudacao;
    var array_saudacao = strTmp.split(/\s*;\s*/);
    let enviados = 0;
    let i = 0;
    let turno = "";
    this.continua = true;
    let startMsg = this.genProvider
      .onGetFilterOrder(
        "dados/" + this.parametros.path + "/campanha/" + msg.key + "/contatos",
        "nome",
        "status_envio",
        "Aguardando"
      )
      .subscribe(dt => {
        startMsg.unsubscribe();
        let dados = JSON.parse(JSON.stringify(dt));
        if (dados.length > 0) {
          this.myTimer = setInterval(() => {
            let now = new Date();
            let horario = true;
            if (now.getHours() >= 0 && now.getHours() < 12) turno = "Bom dia";
            else if (now.getHours() >= 12 && now.getHours() < 18)
              turno = "Boa tarde";
            else turno = "Boa noite";

            if (
              now.getHours() >= parseInt(this.parametros.hora_inicio) &&
              now.getHours() <= parseInt(this.parametros.hora_fim)
            ) {
              horario = true;
            } else {
              horario = false;
            }
            if (i < dados.length && this.continua && horario) {
              enviados++;
              console.log("Enviados ", enviados++, " de ", dados.length);
              let count = array_saudacao.length - 1;
              let sugestao = Math.floor(Math.random() * count); // Escolher um numero ao acaso
              let saudacao = array_saudacao[sugestao];
              let mensagem = msg.mensagem;
              let contato = dados[i].telefone;
              let nome = dados[i].nome || "";
              if (nome) {
                saudacao = saudacao.replace("{{2}}", nome);
                mensagem = mensagem.replace("{{2}}", nome);
              } else {
                saudacao = saudacao.replace("{{2}}", "");
                mensagem = mensagem.replace("{{2}}", "");
              }
              mensagem = mensagem.replace("{{1}}", this.parametros.razao);
              saudacao = saudacao.replace("{{4}}", turno);
              mensagem = mensagem.replace("{{4}}", turno);
              let texto: any;
              if (msg.saudacao) {
                texto = saudacao + this.ctrl + mensagem;
              } else {
                texto = mensagem;
              }

              let caption = "";
              if (msg.caption) {
                caption = texto;
              }
              let telefone = contato;
              let formulario = {
                origem: "whatsapp",
                contato: telefone,
                mensagem: texto,
                midia: msg.midia,
                type_midia: msg.type_midia,
                caption: caption
              };
              this.enviarMsg(formulario, dados[i]);
              let pessoa: any;
              if (nome) {
                pessoa = {
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  acesso: 2,
                  time: 0,
                  nivel: 0,
                  tipo: "Marketing",
                  telefone: telefone,
                  nome: nome,
                  status: "Ativo"
                };
              } else {
                pessoa = {
                  data_hora: new DatePipe("pt-BR").transform(
                    Date.now(),
                    "d, MMMM yyyy - HH:mm"
                  ),
                  acesso: 0,
                  time: 0,
                  nivel: 0,
                  tipo: "Marketing",
                  telefone: "55" + telefone,
                  status: "Ativo"
                };
              }
              this.genProvider
                .onSaveDocKey(
                  "dados/" + this.parametros.path + "/contato",
                  pessoa.telefone,
                  pessoa
                )
                .then(t => { })
                .catch(e => {
                  console.log("Atenção, erro ao salvar dados.");
                });
              this.onAtualizaEnvio(path, msg.key);
              i++;
            }
            if (enviados >= this.parametros.apos) {
              enviados = 0;
              this.continua = false;
              this.onPause(this.parametros.pausar, msg);
            }

            // final envio
            if (i >= dados.length) {
              clearInterval(this.myTimer); // finaliza loop
              let data = {
                key: msg.key,
                status: "Finalizado",
                data_fim: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm:ss"
                )
              };
              this.genProvider
                .onSaveObjeto("dados", this.parametros.path, "campanha", data)
                .then(t => { })
                .catch(e => {
                  alert(
                    "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
                  );
                  console.log(e);
                });
              //    alert('Lista de Transmissão Finalizada.')
            }
          }, Math.floor(Math.random() * (this.parametros.intervalo_fim * 1000) + this.parametros.intervalo_inicio * 1000));
        } else {
          alert("Não existe lista pendente de envio.");
        }
      });
  }
  onPause(tempo, dados) {
    //  console.log('pausa em ', tempo)
    let data = {
      key: dados.key,
      status: "Pausado"
    };
    this.genProvider
      .onSaveObjeto("dados", this.parametros.path, "campanha", data)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });

    setTimeout(() => {
      this.continua = true;
      //    console.log('continua a excussao')
      let data = {
        key: dados.key,
        status: "Enviando"
      };
      this.genProvider
        .onSaveObjeto("dados", this.parametros.path, "campanha", data)
        .then(t => { })
        .catch(e => {
          alert(
            "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
          );
          console.log(e);
        });
    }, tempo * 60 * 1000);
  }
  onStop(data) {
    clearInterval(this.myTimer);
    data.status = "Parado";
    this.genProvider
      .onSaveObjeto("dados", this.parametros.path, "campanha", data)
      .then(t => { })
      .catch(e => {
        alert(
          "Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet."
        );
        console.log(e);
      });
  }
  onReset() { }
  onStatus(value: string) {
    /*
    this.parametros = this.genProvider.parametros;
    let url = "";
    if (value == "status") {
      url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/status?token=" +
        this.parametros.token;
    } else {
      url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/qr_code?token=" +
        this.parametros.token;
    }
    return new Promise(resolve => {
      this.http.get(url).subscribe(
        data => {
          resolve(data);
          //      console.log (data)
        },
        err => {
          if (!err.ok) {
            console.log("o erro ", err);
            resolve(err);
          }
        }
      );
    });
    */
  }
  //fim

  //API chat
  formataTelefone(valor) {
    /*
    if (valor.length <= 11) {
      let fone = "55" + valor;
      return fone;
    } else {
      return valor;
    }
    */
    return valor;
  }
  sendAll(msg, tipo) {
    console.log(msg)
    let contato = this.formataTelefone(msg.contato); // message

    if (tipo == "vcard") {
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/sendVCard?token=" +
        this.parametros.token;
      let data = {
        phone: contato,
        vcard: msg.vcard
      };
      this.http.post(url, data).subscribe(res => {
        console.log("vCard Enviada para ", contato, res);
      });
    }
    if (tipo == "localizacao") {
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/sendLocation?token=" +
        this.parametros.token;
      let data = {
        phone: contato,
        lat: msg.latitude,
        lng: msg.longitude,
        address: msg.localizacao
      };
      this.http.post(url, data).subscribe(res => {
        console.log("Localizacao Enviada para ", contato, res);
      });
    }
    if (tipo == "link") {
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/sendLink?token=" +
        this.parametros.token;
      let img =
        "data:image/jpeg;base64,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";
      let link = {
        phone: contato,
        body: msg.http,
        previewBase64: msg.imgem64,
        title: msg.titulo,
        description: msg.descricao
      };

      this.http.post(url, link).subscribe(res => {
        console.log("link Enviada para ", contato, res);
      });
    }
    if (tipo == "audio") {
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/sendPTT?token=" +
        this.parametros.token;
      let img =
        "data:image/jpeg;base64,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";
      let audio = {
        phone: contato,
        audio: msg.audio
      };

      this.http.post(url, audio).subscribe(res => {
        console.log("audio Enviada para ", contato, res);
      });
    }
  }
  postAPI(url, data) {
    return new Promise(resolve => {
      let result = this.http.post(url, data).subscribe(res => {
        return res;
      });
      resolve(result);
    });
  }
  onStartchat() {
    this.onParametro();
  }
  enviarMsg_old(mensagem, type?: any, dados?, phone?) {
    let msg = mensagem;
    let data: any;
    if (mensagem.origem == 'chatbot') {
      this.sendChatBot(mensagem, type)
    } else if (mensagem.origem == 'messenger') {
      this.sendFaceMessage(mensagem)
    } else if (mensagem.origem == 'whatsapp') {
      this.sendTyping(msg.contato);
      // this.onSendWaBi(msg)
      //  }
      // }

      if (msg.midia) {
        if (msg.caption) {
          this.sendZapMidia(msg);
          data = {
            id: 0,
            fromMe: true,
            telefone: msg.contato,
            type: msg.type_midia,
            midia: msg.midia,
            value: msg.caption,
            date: Date.now(),
            data_hora: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm.ss.SSS"
            ),
            nome: "chatBot",
            //  messageNumber: 0
          };
        } else {
          this.sendZapMidia(msg, dados, phone);
          setTimeout(() => {
            this.sendZapMsg(msg, dados, phone);
          }, 5000);
        }
      } else {
        this.sendZapMsg(msg, dados, phone);
        data = {
          id: 0,
          fromMe: true,
          telefone: msg.contato,
          type: "",
          midia: "",
          value: msg.mensagem,
          date: Date.now(),
          data_hora: new DatePipe("pt-BR").transform(
            Date.now(),
            "d, MMMM yyyy - HH:mm.ss.SSS"
          ),
          nome: "chatBot",
          //  messageNumber: 0
        };
      }

    }
  }
  enviarMsg(mensagem, type?: any, dados?, phone?) {
    let msg = mensagem;
    let data: any;
    if (mensagem.origem == 'chatbot') {
      this.sendChatBot(mensagem, type)
    } else if (mensagem.origem == 'messenger') {
      this.sendFaceMessage(mensagem)
    } else if (mensagem.origem == 'email') {
      this.onSendEmail(mensagem)
    } else if (mensagem.origem == 'whatsapp') {
      this.onSendWaBi(msg)
    }
  }
  sendTyping(phone) {
    let contato = this.formataTelefone(phone) + "@c.us";
    let data = {
      "phone": phone,
      "on": "1",
      "duration": "10"
    }
    let url =
      this.parametros.servidor +
      "/instance" +
      this.parametros.instancia +
      "/typing?token=" +
      this.parametros.token;
    this.http.post(url, data).subscribe(res => {

    });
  }
  sendFaceMessage(msg) {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    let options = new RequestOptions({
      headers: headers,
      method: "POST"
    });
    //    this.formataDados(msg.mensagem,"*", "_").then(res=>{
    //      if (res!="*"){
    //  console.log("nao")
    //     }else {
    //      msg.mensagem = null;
    //      msg.caption = null;
    //     }

    let url = 'https://graph.facebook.com/v8.0/me/messages?access_token=' + this.tokenFace;
    let type = "image";
    if (msg.type_midia) {
      if (msg.type_midia == "jpeg" || msg.type_midia == "jpg" || msg.type_midia == "png") {
        type = "image"
      } else if (msg.type_midia == "ogg" || msg.type_midia == "ppt") {
        type = "audio"
      } else if (msg.type_midia == "pdf" || msg.type_midia == "docx") {
        type = "file"
      } else if (msg.type_midia == "mp4") {
        if (msg.type_anexo == "video") {
          type = "video"
        } else {
          type = "audio"
        }
      }
    } else {
      type = "image"
    }
    if (msg.midia) {
      if (msg.caption) {
        let message = {
          recipient: {
            id: msg.contato
          },
          message: {
            attachment: {
              type: type,
              payload: {
                url: msg.midia
              }
            }
          }
        }
        this.http.post(url, message, options).subscribe(res => {
          let message = {
            recipient: {
              id: msg.contato
            },
            message: {
              text: msg.caption || msg.mensagem
            }
          }
          this.http.post(url, message, options).subscribe(res => {
            //  console.log (res)
          })

        })
      } else {
        let message = {
          recipient: {
            id: msg.contato
          },
          message: {
            attachment: {
              type: type,
              payload: {
                url: msg.midia
              }
            },
          }
        }
        this.http.post(url, message, options).subscribe(res => {
          //  console.log (res)
        })
        if (msg.mensagem) {
          setTimeout(() => {
            let message = {
              recipient: {
                id: msg.contato
              },
              message: {
                text: msg.mensagem
              }
            }
            this.http.post(url, message, options).subscribe(res => {
              //  console.log (res)
            })
          }, 0);
        }
      }
    } else {
      //incio
      if (msg.mensagem.length < 1999) {
        let message = {
          recipient: {
            id: msg.contato
          },
          message: {
            text: msg.mensagem
          }
        }
        this.http.post(url, message, options).subscribe(res => {
        })
      } else {
        // quebrar a mesnagem

        this.divideString(msg.mensagem, 1999).then(res => {
          let dados = JSON.parse(JSON.stringify(res))
          //  console.log(dados)
          dados.forEach(element => {
            let message = {
              recipient: {
                id: msg.contato
              },
              message: {
                text: element
              }
            }
            setTimeout(() => {
              this.http.post(url, message, options).subscribe(res => { })
            }, 1000);

          });

        })
      }

      // fim
    }

    //   });
  }
  sendChatBot(msg, type?) {
    let url = 'dados/' + this.parametros.path + '/dialogChat/' + msg.contato + '/dialogChat_body'
    if (msg.contato.trim() != '55') {
      if (msg.midia) {
        let dados = {
          status: 'Enviada',
          type: msg.type_midia,
          value: msg.midia,
          time: '',
          data_hora: new DatePipe('pt-BR').transform(
            Date.now(),
            'd, MMMM yyyy - HH:mm'
          )
        }
        let data = {
          comando: "saveChat",
          body: dados,
          url: url
        }
        this.onSaveChat(data)
        //    this.genProvider.onSaveObjeto('dados', this.parametros.path + '/dialogChat/' + msg.contato, 'dialogChat_body', dados);
        if (msg.caption) {
          let dados = {
            status: 'Enviada',
            type: 'chat',
            value: msg.caption,
            time: '',
            data_hora: new DatePipe('pt-BR').transform(
              Date.now(),
              'd, MMMM yyyy - HH:mm'
            )
          }
          let data = {
            comando: "saveChat",
            body: dados,
            url: url
          }
          this.onSaveChat(data)
          //   this.genProvider.onSaveObjeto('dados', this.parametros.path + '/dialogChat/' + msg.contato, 'dialogChat_body', dados);
        }
      } else {
        let tipo = 'chat'
        if (type) {
          tipo = type
        }
        let dados = {
          status: 'Enviada',
          type: tipo,
          value: msg.mensagem,
          time: '',
          data_hora: new DatePipe('pt-BR').transform(
            Date.now(),
            'd, MMMM yyyy - HH:mm'
          )
        }
        let data = {
          comando: "saveChat",
          body: dados,
          url: url
        }
        this.onSaveChat(data)

        //   this.genProvider.onSaveObjeto('dados', this.parametros.path + '/dialogChat/' + msg.contato, 'dialogChat_body', dados);
      }
    }
  }
  formataDados(dados, c, c2?) {
    return new Promise(resolve => {
      try {
        let res = dados.replaceAll(c, "");
        if (c2) {
          let res2 = res.replaceAll(c2, "");
          resolve(res2);
        } else {
          resolve(res);
        }
      } catch (e) {
        resolve(c);
      }
      resolve(dados);
    });
  }
  divideString(str, num) {
    return new Promise(resolve => {
      var pedacos = []
      var i = 0

      while (i < str.length) {
        (i % num == 0 ? pedacos.push(str.substring(i, i + num)) : i++)
        i++
      }
      resolve(pedacos)
      /*
      var t=str.split(''), col = [];
      for (let i = 0; i in t; i++) {
        col.push(t[i]);
        if((i+1) % num === 0) {
          col.push('-');
        }
     }

    resolve(col.join('').split('-').filter(e => e != ""));
    */
      //  let pedacos = []
      //  let i = 0
      //  while (i < str.length){
      //    (i % n == 0 ? pedacos.push(str.substring(i, i + n)) : i++)
      //    i++
      //  }
      // let a = str.match(/.{1,1999}/g);
      //  resolve(a)
    });

  }
  sendZapMidia(msg, dados?, phone?) {
    let hora = new DatePipe("pt-BR").transform(
      Date.now(),
      "d, MMMM yyyy - HH:mm:ss.SSS"
    );

    let contato = this.formataTelefone(msg.contato) + "@c.us";
    if (phone) {
      contato = this.formataTelefone(msg.contato);
    }
    let url =
      this.parametros.servidor +
      "/instance" +
      this.parametros.instancia +
      "/sendFile?token=" +
      this.parametros.token;
    let urlMsg =
      this.parametros.servidor +
      "/instance" +
      this.parametros.instancia +
      "/message?token=" +
      this.parametros.token;
    let filename = "";
    if (msg.type_midia) {
      filename = `file_${new DatePipe("pt-BR").transform(
        Date.now(),
        "yyyy-MM-dd-HH:mm:ss.SSS"
      )}.${msg.type_midia}`;
    } else {
      filename = `file_${new DatePipe("pt-BR").transform(
        Date.now(),
        "yyyy-MM-dd-HH:mm:ss.SSS"
      )}.jpg`;
    }
    let data = {};
    if (msg.caption && msg.type_midia == "ogg") {
      try {
        let data1 = {};
        let data2 = {};
        if (phone) {
          data1 = {
            phone: contato,
            body: msg.midia,
            filename: filename
          };
          data2 = {
            phone: contato,
            body: msg.caption
          };
        } else {
          data1 = {
            chatId: contato,
            body: msg.midia,
            filename: filename
          };
          data2 = {
            chatId: contato,
            body: msg.caption
          };
        }
        this.http.post(urlMsg, data2).subscribe(res => {
          console.log("texto Enviada para ", contato, hora, res);
          // enviar o texto
          this.http.post(url, data1).subscribe(res => {
            console.log("audio Enviada para ", contato, hora, res);
            if (dados) {
              let path =
                "/dados/" +
                this.parametros.path +
                "/campanha/" +
                dados.key_campanha +
                "/contatos";
              let status_msg: any;
              if (res) {
                status_msg = "Entregue";
              } else {
                status_msg = "Não Entregue";
              }
              let data = {
                key: dados.telefone,
                status_envio: "Enviado",
                status_msg: status_msg,
                data_envio: new DatePipe("pt-BR").transform(
                  Date.now(),
                  "d, MMMM yyyy - HH:mm"
                )
              };
              this.genProvider
                .onSaveDocKey(path, dados.telefone, data)
                .then(t => { })
                .catch(e => {
                  console.log("Atenção, erro ao salvar dados.");
                });
            }
          });
          // fim
          if (dados) {
            let path =
              "/dados/" +
              this.parametros.path +
              "/campanha/" +
              dados.key_campanha +
              "/contatos";
            let status_msg: any;
            if (res) {
              status_msg = "Entregue";
            } else {
              status_msg = "Não Entregue";
            }
            let data = {
              key: dados.telefone,
              status_envio: "Enviado",
              status_msg: status_msg,
              data_envio: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm:ss.SSS"
              )
            };
            this.genProvider
              .onSaveDocKey(path, dados.telefone, data)
              .then(t => { })
              .catch(e => {
                console.log("Atenção, erro ao salvar dados.");
              });
          }
        });
      } catch (error) {
        console.log(error);
      }
    } else if (msg.caption && msg.type_midia != "ogg") {
      let data = {};
      try {
        if (phone) {
          data = {
            phone: contato,
            body: msg.midia,
            filename: filename,
            caption: msg.caption
          };
        } else {
          data = {
            chatId: contato,
            body: msg.midia,
            filename: filename,
            caption: msg.caption
          };
        }
        this.http.post(url, data).subscribe(res => {
          console.log("Mensagem Enviada para ", contato, hora, res);
          if (dados) {
            let path =
              "/dados/" +
              this.parametros.path +
              "/campanha/" +
              dados.key_campanha +
              "/contatos";
            let status_msg: any;
            if (res) {
              status_msg = "Entregue";
            } else {
              status_msg = "Não Entregue";
            }
            let data = {
              key: dados.telefone,
              status_envio: "Enviado",
              status_msg: status_msg,
              data_envio: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              )
            };
            this.genProvider
              .onSaveDocKey(path, dados.telefone, data)
              .then(t => { })
              .catch(e => {
                console.log("Atenção, erro ao salvar dados.");
              });
          }
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        if (phone) {
          data = {
            phone: contato,
            body: msg.midia,
            filename: filename
          };
        } else {
          data = {
            chatId: contato,
            body: msg.midia,
            filename: filename
          };
        }
        this.http.post(url, data).subscribe(res => {
          console.log("Mensagam Enviada para ", contato, hora);
          if (dados) {
            let path =
              "/dados/" +
              this.parametros.path +
              "/campanha/" +
              dados.key_campanha +
              "/contatos";
            let status_msg: any;
            if (res) {
              status_msg = "Entregue";
            } else {
              status_msg = "Não Entregue";
            }
            let data = {
              key: dados.telefone,
              status_envio: "Enviado",
              status_msg: status_msg,
              data_envio: new DatePipe("pt-BR").transform(
                Date.now(),
                "d, MMMM yyyy - HH:mm"
              )
            };
            this.genProvider
              .onSaveDocKey(path, dados.telefone, data)
              .then(t => { })
              .catch(e => {
                console.log("Atenção, erro ao salvar dados.");
              });
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
  sendZapMsg(msg, dados?, phone?) {
    if (msg.mensagem) {
      let hora = new DatePipe("pt-BR").transform(
        Date.now(),
        "d, MMMM yyyy - HH:mm.ss.SSS"
      );
      let contato = this.formataTelefone(msg.contato) + "@c.us";
      if (phone) {
        contato = this.formataTelefone(msg.contato);
      }
      let url =
        this.parametros.servidor +
        "/instance" +
        this.parametros.instancia +
        "/message?token=" +
        this.parametros.token;
      let data = {};
      if (phone) {
        data = {
          phone: contato, // Receivers phone
          body: msg.mensagem // Message
        };
      } else {
        data = {
          chatId: contato, // Receivers chatId
          body: msg.mensagem // Message
        };
      }
      this.http.post(url, data).subscribe(res => {
        //**   console.log("Mensagam Enviada para ", contato, hora);
        if (dados) {
          let path =
            "/dados/" +
            this.parametros.path +
            "/campanha/" +
            dados.key_campanha +
            "/contatos";
          let status_msg: any;
          if (res) {
            status_msg = "Entregue";
          } else {
            status_msg = "Não Entregue";
          }

          let data = {
            key: dados.telefone,
            status_envio: "Enviado",
            status_msg: status_msg,
            data_envio: new DatePipe("pt-BR").transform(
              Date.now(),
              "d, MMMM yyyy - HH:mm"
            )
          };
          this.genProvider
            .onSaveDocKey(path, dados.telefone, data)
            .then(t => { })
            .catch(e => {
              console.log("Atenção, erro ao salvar dados.");
            });
        }
      });
    }
  }
  sendMsg(mensagem, dados?, phone?) {
    let msg = mensagem;
    this.onParametro();
    if (mensagem.contato.length >= 16) {
      this.sendFaceMessage(mensagem)
    } else {
      if (msg.midia) {
        if (msg.caption) {
          this.sendZapMidia(msg, dados, phone);
        } else {
          this.sendZapMidia(msg, dados, phone);
          setTimeout(() => {
            this.sendZapMsg(msg, dados, phone);
          }, 5000);
        }
      } else {
        this.sendZapMsg(msg, dados, phone);
      }
    }
  }

  //webhook
  onWebHookMsg(id) {
    // cabecalho da mensagemola ()
    if (this.parametros.webhookDenuncia) {
      this.pesquisaDenuncia(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaDenuncia_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                if (dados_body.length > 0) {
                  let conteudo = [];
                  let denuncia = '';
                  let idprotocolo = dados[0].protocolo
                  dados_body.forEach(res => {
                    if (res.type == "chat") {
                      denuncia = denuncia + res.value + this.ctrl
                    }
                    let temp = {
                      type: res.type,
                      value: res.value
                    };
                    conteudo.push(temp);
                  });
                  /*
                  let msg = {
                    key: dados[0].key,
                    //idDenuncia: dados[0].iddenuncia || null,
                    instanceId: this.parametros.instancia,
                    token: this.parametros.token,
                    protocolo: dados[0].protocolo,
                    data_hora: dados[0].data_hora,
                    time: dados[0].time,
                    status: "REGISTRADA",
                    content: conteudo,
                    origem: dados[0].origem,
                    natureza: ''
                  };*/

                  let msg = {
                    instanceId: this.parametros.instancia,
                    token: this.parametros.token,
                    status: "INSERIR",
                    situacao: "REGISTRADA",
                    data_registro: dados[0].time,
                    data_status: dados[0].time,
                    origem: dados[0].origem.toLowerCase(),
                    lat: 0,
                    lng: 0,
                    local: "",
                    tipo: "",
                    estabelecimento: "",
                    logradouro: "",
                    bairro: "",
                    cidade: "",
                    estado: "",
                    cep: "",
                    denuncia: denuncia,
                    files: conteudo
                  };
                  let telefone = dados[0].telefone;
                  this.http.post(this.parametros.webhookUrl, msg, this.options).subscribe(res => {
                    console.log(res)
                    let data = JSON.parse(JSON.stringify(res));
                    let protocolo: any
                    try {
                      protocolo = JSON.parse(data._body);
                    } catch (e) {
                      protocolo = null
                    }
                    console.log(protocolo)
                    let id = null;
                    let erro = null;
                    if (protocolo["iddenuncia"]) {
                      id = protocolo["iddenuncia"];
                    } else {
                      console.log("Erro ao retornar iddenuncia" + protocolo)
                      erro = protocolo["error"];
                    }
                    if (id) {
                      let formulario = {
                        origem: dados[0].origem,
                        contato: telefone,
                        mensagem:
                          "Protocolo da sua denúncia: " +
                          "*" + id + "*" +
                          this.ctrl +
                          this.msg_denuncia_acompanhar + this.ctrl + '*Esta é uma mensagem automática, não responda* 😉'

                      };
                      this.enviarMsg(formulario, null, true);
                      let temp = {
                        key: dados[0].key,
                        idDenuncia: id,
                        value: denuncia
                      }
                      // this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chat_fila', temp)
                      this.genProvider.onSaveObjeto('dados', this.parametros.path, 'denuncia', temp)
                    } else {
                      let formulario = {
                        origem: 'whatsapp',
                        contato: "559180333070",
                        mensagem:
                          "Protocolo :" +
                          id +
                          this.ctrl +
                          erro
                      };
                      this.enviarMsg(formulario, null, true);
                    }
                  }, err => {
                    console.log(err);
                    let formulario = {
                      origem: 'whatsapp',
                      contato: "559180333070",
                      mensagem:
                        "Protocolo :" +
                        id +
                        this.ctrl +
                        "erro no envio p/ DD: " +
                        err
                    };
                    this.enviarMsg(formulario, null, true);
                  }
                  );
                }
              },
              err => {
                console.log(err);
                let formulario = {
                  origem: 'whatsapp',
                  contato: "559180333070",
                  mensagem:
                    "Protocolo :" +
                    id +
                    this.ctrl +
                    "erro firebase p/ DD: " +
                    err
                };
                this.enviarMsg(formulario, null, true);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    if (this.parametros.webhookMensagem) {
      this.pesquisaMensagens(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaMensagens_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value
                  };
                  conteudo.push(temp);
                });
                let msg = {
                  instanceId: this.parametros.instancia,
                  token: this.parametros.token,
                  name: "mensagem",
                  protocolo: dados[0].protocolo,
                  telefone: dados[0].telefone,
                  opcao: dados[0].menu,
                  data_hora: dados[0].data_hora,
                  time: dados[0].time,
                  status: dados[0].status,
                  content: conteudo
                };
                this.http
                  .post(this.parametros.webhookUrl, msg, this.options)
                  .subscribe(res => {
                    //     console.log (res)
                    //      this.excluirMensagens(dados[0].protocolo);
                  });
              },
              err => {
                console.log(err);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    if (this.parametros.webhookOuvidoria) {
      this.pesquisaOuvidoria(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaOuvidoria_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value
                  };
                  conteudo.push(temp);
                });
                let msg = {
                  instanceId: this.parametros.instancia,
                  token: this.parametros.token,
                  name: "ouvidoria",
                  protocolo: dados[0].protocolo,
                  telefone: dados[0].telefone,
                  opcao: dados[0].menu,
                  data_hora: dados[0].data_hora,
                  time: dados[0].time,
                  status: dados[0].status,
                  content: conteudo
                };
                //    console.log (msg)
                this.http
                  .post(this.parametros.webhookUrl, msg, this.options)
                  .subscribe(res => {
                    //     console.log (res)
                    //                       this.excluirOuvidoria(id)
                  });
              },
              err => {
                console.log(err);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    if (this.parametros.webhookchat) {
      this.pesquisaChat(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaChat_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                if (dados_body.length > 0) {
                  let conteudo = [];
                  let denuncia = '';
                  let idprotocolo = dados[0].protocolo
                  dados_body.forEach(res => {
                    if (res.type == "chat") {
                      denuncia = denuncia + res.value + this.ctrl
                    }
                    /*
                    if (res.type == "location") {
                      let temp = {
                        type: "location",
                        value: resthis.formulario_dd.value.lat + ";" + this.formulario_dd.value.lng
                      };
                      conteudo.push(temp);
                    }
                    */
                    else {
                      let temp = {
                        type: res.type,
                        value: res.value
                      };
                      conteudo.push(temp);
                    }
                  });
                  let msg = {
                    instanceId: this.parametros.instancia,
                    token: this.parametros.token,
                    status: "INSERIR",
                    situacao: "REGISTRADA",
                    data_registro: dados[0].time,
                    data_status: dados[0].time,
                    origem: dados[0].origem.toLowerCase(),
                    lat: 0,
                    lng: 0,
                    local: "",
                    tipo: "",
                    estabelecimento: "",
                    logradouro: "",
                    bairro: "",
                    cidade: "",
                    estado: "",
                    cep: "",
                    denuncia: denuncia,
                    files: conteudo
                  };
                  let telefone = dados[0].telefone;
                  this.http.post(this.parametros.webhookUrl, msg, this.options).subscribe(res => {
                    console.log(res)
                    let data = JSON.parse(JSON.stringify(res));
                    let protocolo: any
                    try {
                      protocolo = JSON.parse(data._body);
                    } catch (e) {
                      protocolo = null
                    }
                    let id = null;
                    let erro = null;
                    if (protocolo["iddenuncia"]) {
                      id = protocolo["iddenuncia"];
                    } else {
                      console.log("Erro ao retornar iddenuncia" + protocolo)
                      erro = protocolo["error"];
                    }
                    if (id) {
                      let formulario = {
                        origem: dados[0].origem,
                        contato: telefone,
                        mensagem:
                          "Protocolo da sua denúncia: " +
                          "*" + id + "*" +
                          this.ctrl +
                          this.msg_denuncia_acompanhar + this.ctrl + '*Esta é uma mensagem automática, não responda* 😉'

                      };
                      this.enviarMsg(formulario, null, true);
                      let temp = {
                        key: dados[0].key,
                        iddenuncia: id,
                        value: denuncia
                      }
                      this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chat', temp)
                    } else {
                      let formulario = {
                        origem: 'whatsapp',
                        contato: "559180333070",
                        mensagem:
                          "Protocolo :" +
                          id +
                          this.ctrl +
                          "erro protocolo: " +
                          idprotocolo +
                          this.ctrl +
                          erro
                      };
                      this.enviarMsg(formulario, null, true);
                    }
                  }, err => {
                    console.log(err);
                    let formulario = {
                      origem: 'whatsapp',
                      contato: "559180333070",
                      mensagem:
                        "Protocolo :" +
                        id +
                        this.ctrl +
                        "erro no envio p/ DD: " +
                        err
                    };
                    this.enviarMsg(formulario, null, true);
                  }
                  );
                }
              },
              err => {
                console.log(err);
                let formulario = {
                  origem: 'whatsapp',
                  contato: "559180333070",
                  mensagem:
                    "Protocolo :" +
                    id +
                    this.ctrl +
                    "erro firebase p/ DD: " +
                    err
                };
                this.enviarMsg(formulario, null, true);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }

  }
  onWebHookMsg_update(id) {
    if (this.parametros.webhookDenuncia) {
      this.pesquisaDenuncia(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaDenuncia_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                if (dados_body.length > 0) {
                  let conteudo = [];
                  let denuncia = '';
                  dados_body.forEach(res => {
                    if (res.type == "chat") {
                      denuncia = denuncia + res.value + this.ctrl
                    }
                    let temp = {
                      type: res.type,
                      value: res.value
                    };
                    conteudo.push(temp);
                  });
                  ;
                  let origem: any
                  if (dados[0].telefone.length >= 16) {
                    origem = "Messenger"
                  } else if (dados[0].telefone.length < 11) {
                    origem = "Phone"
                  } else {
                    origem = "whatsapp"
                  }
                  let msg = {
                    key: dados[0].key,
                    //idDenuncia: dados[0].iddenuncia || null,
                    instanceId: this.parametros.instancia,
                    token: this.parametros.token,
                    protocolo: dados[0].protocolo,
                    data_hora: dados[0].data_hora,
                    time: dados[0].time,
                    status: dados[0].status,
                    content: conteudo,
                    origem: origem,
                    natureza: ''
                  };
                  let telefone = dados[0].telefone;
                  this.http.post(this.parametros.webhookUrl, msg, this.options).subscribe(res => {
                    console.log(res)
                    let data = JSON.parse(JSON.stringify(res));
                    let protocolo: any
                    try {
                      protocolo = JSON.parse(data._body);
                    } catch (e) {
                      protocolo = null
                    }
                    console.log(protocolo)
                    let id = null;
                    let erro = null;
                    if (protocolo["iddenuncia"]) {
                      id = protocolo["iddenuncia"];
                    } else {
                      console.log("Erro ao retornar iddenuncia" + protocolo)
                      erro = protocolo["error"];
                    }
                    if (id) {
                      let formulario = {
                        origem: dados[0].origem,
                        contato: telefone,
                        mensagem:
                          "Protocolo da sua denúncia: " +
                          "*" + id + "*" +
                          this.ctrl +
                          this.msg_denuncia_acompanhar + this.ctrl + '*Esta é uma mensagem automática, não responda* 😉'

                      };
                      this.enviarMsg(formulario, null, true);
                      let temp = {
                        key: dados[0].protocolo,
                        idDenuncia: id,
                        value: denuncia
                      }
                      // this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chat_fila', temp)
                      this.genProvider.onSaveObjeto('dados', this.parametros.path, 'denuncia', temp)
                    } else {
                      let formulario = {
                        origem: 'whatsapp',
                        contato: "559180333070",
                        mensagem:
                          "Protocolo :" +
                          id +
                          this.ctrl +
                          "erro protocolo: " +
                          msg.protocolo +
                          this.ctrl +
                          erro
                      };
                      this.enviarMsg(formulario, null, true);
                    }
                  }, err => {
                    console.log(err);
                    let formulario = {
                      origem: 'whatsapp',
                      contato: "559180333070",
                      mensagem:
                        "Protocolo :" +
                        id +
                        this.ctrl +
                        "erro no envio p/ DD: " +
                        err
                    };
                    this.enviarMsg(formulario, null, true);
                  }
                  );
                }
              },
              err => {
                console.log(err);
                let formulario = {
                  origem: 'whatsapp',
                  contato: "559180333070",
                  mensagem:
                    "Protocolo :" +
                    id +
                    this.ctrl +
                    "erro firebase p/ DD: " +
                    err
                };
                this.enviarMsg(formulario, null, true);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    if (this.parametros.webhookMensagem) {
      this.pesquisaMensagens(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaMensagens_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value
                  };
                  conteudo.push(temp);
                });
                let msg = {
                  instanceId: this.parametros.instancia,
                  token: this.parametros.token,
                  name: "mensagem",
                  protocolo: dados[0].protocolo,
                  telefone: dados[0].telefone,
                  opcao: dados[0].menu,
                  data_hora: dados[0].data_hora,
                  time: dados[0].time,
                  status: dados[0].status,
                  content: conteudo
                };
                this.http
                  .post(this.parametros.webhookUrl, msg, this.options)
                  .subscribe(res => {
                    //     console.log (res)
                    //      this.excluirMensagens(dados[0].protocolo);
                  });
              },
              err => {
                console.log(err);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    if (this.parametros.webhookOuvidoria) {
      this.pesquisaOuvidoria(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaOuvidoria_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value
                  };
                  conteudo.push(temp);
                });
                let msg = {
                  instanceId: this.parametros.instancia,
                  token: this.parametros.token,
                  name: "ouvidoria",
                  protocolo: dados[0].protocolo,
                  telefone: dados[0].telefone,
                  opcao: dados[0].menu,
                  data_hora: dados[0].data_hora,
                  time: dados[0].time,
                  status: dados[0].status,
                  content: conteudo
                };
                //    console.log (msg)
                this.http
                  .post(this.parametros.webhookUrl, msg, this.options)
                  .subscribe(res => {
                    //     console.log (res)
                    //                       this.excluirOuvidoria(id)
                  });
              },
              err => {
                console.log(err);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    if (this.parametros.webhookchat) {
      this.pesquisaChat(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaChat_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                if (dados_body.length > 0) {
                  let conteudo = [];
                  let denuncia = '';
                  let idprotocolo = dados[0].protocolo
                  dados_body.forEach(res => {
                    if (res.type == "chat") {
                      denuncia = denuncia + res.value + this.ctrl
                    }
                    let temp = {
                      type: res.type,
                      value: res.value
                    };
                    conteudo.push(temp);
                  });
                  let origem: any
                  if (dados[0].telefone.length >= 16) {
                    origem = "Messenger"
                  } else if (dados[0].telefone.length < 11) {
                    origem = "Voz"
                  } else {
                    origem = "whatsapp"
                  }
                  let msg = {
                    instanceId: this.parametros.instancia,
                    token: this.parametros.token,
                    status: "Novo",
                    situacao: "REGISTRADA",
                    data_registro: dados[0].data_hora,
                    data_status: dados[0].time,
                    origem: origem,
                    lat: 0,
                    lng: 0,
                    local: "",
                    tipo: "",
                    estabelecimento: "",
                    logradouro: "",
                    bairro: "",
                    cidade: "",
                    estado: "",
                    cep: "",
                    denuncia: denuncia,
                    files: conteudo
                  };
                  let telefone = dados[0].telefone;
                  console.log(msg)
                  this.http.post(this.parametros.webhookUrl, msg, this.options).subscribe(res => {
                    console.log(res)
                    let data = JSON.parse(JSON.stringify(res));
                    console.log(JSON.parse(data))
                    let protocolo: any
                    try {
                      protocolo = JSON.parse(data._body);
                    } catch (e) {
                      protocolo = null
                    }
                    console.log(protocolo)
                    let id = null;
                    let erro = null;
                    if (protocolo["iddenuncia"]) {
                      id = protocolo["iddenuncia"];
                    } else {
                      console.log("Erro ao retornar iddenuncia" + protocolo)
                      erro = protocolo["error"];
                    }
                    if (id) {
                      let formulario = {
                        origem: dados[0].origem,
                        contato: telefone,
                        mensagem:
                          "Protocolo da sua denúncia: " +
                          "*" + id + "*" +
                          this.ctrl +
                          this.msg_denuncia_acompanhar + this.ctrl + '*Esta é uma mensagem automática, não responda* 😉'

                      };
                      this.enviarMsg(formulario, null, true);
                      let temp = {
                        key: dados[0].protocolo,
                        idDenuncia: id,
                        value: denuncia

                      }
                      this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chat', temp)
                    } else {
                      let formulario = {
                        origem: 'whatsapp',
                        contato: "559180333070",
                        mensagem:
                          "Protocolo :" +
                          id +
                          this.ctrl +
                          "erro protocolo: " +
                          idprotocolo +
                          this.ctrl +
                          erro
                      };
                      this.enviarMsg(formulario, null, true);
                    }
                  }, err => {
                    console.log(err);
                    let formulario = {
                      origem: 'whatsapp',
                      contato: "559180333070",
                      mensagem:
                        "Protocolo :" +
                        id +
                        this.ctrl +
                        "erro no envio p/ DD: " +
                        err
                    };
                    this.enviarMsg(formulario, null, true);
                  }
                  );
                }
              },
              err => {
                console.log(err);
                let formulario = {
                  origem: 'whatsapp',
                  contato: "559180333070",
                  mensagem:
                    "Protocolo :" +
                    id +
                    this.ctrl +
                    "erro firebase p/ DD: " +
                    err
                };
                this.enviarMsg(formulario, null, true);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
    // notidicacao agenda denuncias
    if (this.parametros.whatsDenuncia) {
      this.pesquisaDenuncia(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaDenuncia_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let operador = false;
                  if (res.nome) {
                    operador = res.nome;
                  }
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value,
                    nome: dados[0].nome,
                    operador: operador,
                    protocolo: dados[0].protocolo,
                    telefone: dados[0].telefone
                  };
                  conteudo.push(temp);
                });
                var unSubs = this.genProvider
                  .onGetfilter(
                    "dados/" + this.parametros.path + "/agenda",
                    "whatsDenuncia",
                    true
                  )
                  .subscribe(data => {
                    unSubs.unsubscribe();
                    let agenda = JSON.parse(JSON.stringify(data));
                    if (agenda.length > 0) {
                      agenda.forEach(res => {
                        if (res.status == "Ativo") {
                          let nome = new CamelcasePipe()
                            .transform(conteudo[0].nome)
                            .trim();
                          let telefone_usuario = this.validaCampoProvider.validaTelefoneZap(
                            conteudo[0].telefone.substring(2, 12)
                          );
                          let telefone = res.telefone.replace(/\D/g, "");
                          let cabecalho =
                            "*NOTIFICAÇÃO DE DENÚNCIA DA PLATAFORMA _" +
                            this.parametros.path.toUpperCase() +
                            "_*" +
                            this.ctrl +
                            this.ctrl;
                          cabecalho +=
                            "*Nome do Usuário: " + nome + "*" + this.ctrl;
                          cabecalho +=
                            "Telefone: " + telefone_usuario + this.ctrl;
                          cabecalho +=
                            "Data/Hora :" +
                            conteudo[0].data_hora +
                            this.ctrl;
                          cabecalho +=
                            "Protocolo :" + conteudo[0].protocolo;
                          let formulario = {
                            origem: dados[0].origem,
                            contato: telefone,
                            mensagem: cabecalho,
                            type_midia: "chat"
                          };
                          this.enviarMsg(formulario, null, true);
                          conteudo.forEach(content => {
                            if (content.type == "location") {
                              let coodenada = content.value.split(
                                /\s*;\s*/
                              );
                              let localizacao = {
                                origem: dados[0].origem,
                                contato: telefone,
                                localizacao: "",
                                latitude: coodenada[0],
                                longitude: coodenada[1]
                              };
                              setTimeout(() => {
                                this.sendAll(localizacao, "localizacao");
                              }, 2000);
                            } else if (content.type == "chat") {
                              let mensagem = content.value;
                              if (content.operador) {
                                mensagem =
                                  "[Operador *" +
                                  content.operador +
                                  "* diz]:" +
                                  this.ctrl +
                                  content.value;
                              }
                              let formulario = {
                                contato: telefone,
                                mensagem: mensagem,
                                type_midia: content.type
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "image") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                midia: content.value,
                                caption: "Protocolo: " + id,
                                type_midia: "jpeg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "ptt") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "ogg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "video") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "mp4"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            }
                          });
                        }
                      });
                    }
                  });
              },
              err => {
                console.log(err);
              }
            );
          }
        },
        err => console.log(err)
      );
    }
    // notificacoes agenda mensagens
    if (this.parametros.whatsMensagem) {
      this.pesquisaMensagens(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaMensagens_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let operador = false;
                  if (res.nome) {
                    operador = res.nome;
                  }
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value,
                    nome: dados[0].nome,
                    operador: operador,
                    protocolo: dados[0].protocolo,
                    telefone: dados[0].telefone
                  };
                  conteudo.push(temp);
                });
                var unSubs = this.genProvider
                  .onGetfilter(
                    "dados/" + this.parametros.path + "/agenda",
                    "whatsMensagem",
                    true
                  )
                  .subscribe(data => {
                    unSubs.unsubscribe();
                    let agenda = JSON.parse(JSON.stringify(data));
                    if (agenda.length > 0) {
                      agenda.forEach(res => {
                        if (res.status == "Ativo") {
                          let nome = new CamelcasePipe()
                            .transform(conteudo[0].nome)
                            .trim();
                          let telefone_usuario = this.validaCampoProvider.validaTelefoneZap(
                            conteudo[0].telefone.substring(2, 12)
                          );
                          let telefone = res.telefone.replace(/\D/g, "");
                          let cabecalho =
                            "*NOTIFICAÇÃO DE MENSAGEM DA PLATAFORMA _" +
                            this.parametros.path.toUpperCase() +
                            "_*" +
                            this.ctrl +
                            this.ctrl;
                          cabecalho +=
                            "*Nome do Usuário: " + nome + "*" + this.ctrl;
                          cabecalho +=
                            "Telefone: " + telefone_usuario + this.ctrl;
                          cabecalho +=
                            "Data/Hora :" +
                            conteudo[0].data_hora +
                            this.ctrl;
                          cabecalho +=
                            "Protocolo :" + conteudo[0].protocolo;
                          let formulario = {
                            origem: dados[0].origem,
                            contato: telefone,
                            mensagem: cabecalho,
                            type_midia: "chat"
                          };
                          this.enviarMsg(formulario, null, true);
                          conteudo.forEach(content => {
                            if (content.type == "location") {
                              let coodenada = content.value.split(
                                /\s*;\s*/
                              );
                              let localizacao = {
                                origem: dados[0].origem,
                                contato: telefone,
                                localizacao: "",
                                latitude: coodenada[0],
                                longitude: coodenada[1]
                              };
                              setTimeout(() => {
                                this.sendAll(localizacao, "localizacao");
                              }, 2000);
                            } else if (content.type == "chat") {
                              let mensagem = content.value;
                              if (content.operador) {
                                mensagem =
                                  "[Operador *" +
                                  content.operador +
                                  "* diz]:" +
                                  this.ctrl +
                                  content.value;
                              }
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                mensagem: mensagem,
                                type_midia: content.type
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "image") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                midia: content.value,
                                caption: "Protocolo: " + id,
                                type_midia: "jpeg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "ptt") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "ogg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "video") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "mp4"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            }
                          });
                        }
                      });
                    }
                  });
              },
              err => {
                console.log(err);
              }
            );
          }
        },
        err => console.log(err)
      );
    }
    // notificacoes agenda mensagens
    if (this.parametros.whatsOuvidoria) {
      this.pesquisaOuvidoria(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaOuvidoria_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let operador = false;
                  if (res.nome) {
                    operador = res.nome;
                  }
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value,
                    nome: dados[0].nome,
                    operador: operador,
                    protocolo: dados[0].protocolo,
                    telefone: dados[0].telefone
                  };
                  conteudo.push(temp);
                });
                // enviar mensagens
                var unSubs = this.genProvider
                  .onGetfilter(
                    "dados/" + this.parametros.path + "/agenda",
                    "whatsOuvidoria",
                    true
                  )
                  .subscribe(data => {
                    unSubs.unsubscribe();
                    let agenda = JSON.parse(JSON.stringify(data));
                    if (agenda.length > 0) {
                      agenda.forEach(res => {
                        if (res.status == "Ativo") {
                          let nome = new CamelcasePipe()
                            .transform(conteudo[0].nome)
                            .trim();
                          let telefone_usuario = this.validaCampoProvider.validaTelefoneZap(
                            conteudo[0].telefone.substring(2, 12)
                          );
                          let telefone = res.telefone.replace(/\D/g, "");
                          let cabecalho =
                            "*NOTIFICAÇÃO PARA OUVIDORIA DA PLATAFORMA _" +
                            this.parametros.path.toUpperCase() +
                            "_*" +
                            this.ctrl +
                            this.ctrl;
                          cabecalho +=
                            "*Nome do Usuário: " + nome + "*" + this.ctrl;
                          cabecalho +=
                            "Telefone: " + telefone_usuario + this.ctrl;
                          cabecalho +=
                            "Data/Hora :" +
                            conteudo[0].data_hora +
                            this.ctrl;
                          cabecalho +=
                            "Protocolo :" + conteudo[0].protocolo;
                          let formulario = {
                            contato: telefone,
                            mensagem: cabecalho,
                            type_midia: "chat"
                          };
                          this.enviarMsg(formulario, null, true);
                          conteudo.forEach(content => {
                            if (content.type == "location") {
                              let coodenada = content.value.split(
                                /\s*;\s*/
                              );
                              let localizacao = {
                                origem: dados[0].origem,
                                contato: telefone,
                                localizacao: "",
                                latitude: coodenada[0],
                                longitude: coodenada[1]
                              };
                              setTimeout(() => {
                                this.sendAll(localizacao, "localizacao");
                              }, 1000);
                            } else if (content.type == "chat") {
                              let mensagem = content.value;
                              if (content.operador) {
                                mensagem =
                                  "[Operador *" +
                                  content.operador +
                                  "* diz]:" +
                                  this.ctrl +
                                  content.value;
                              }
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                mensagem: mensagem,
                                type_midia: content.type
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "image") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                midia: content.value,
                                caption: "Protocolo: " + id,
                                type_midia: "jpeg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "ptt") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "ogg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "video") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                caption: "Protocolo: " + id,
                                midia: content.value,
                                type_midia: "mp4"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            }
                          });
                        }
                      });
                    }
                  });
              },
              err => {
                console.log(err);
              }
            );
          }
        },
        err => console.log(err)
      );
    }
    // notificacoes agenda mensagens
    if (this.parametros.whatschat) {
      this.pesquisaChat(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaChat_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                let conteudo = [];
                dados_body.forEach(res => {
                  let operador = false;
                  if (res.nome) {
                    operador = res.nome;
                  }
                  let temp = {
                    data_hora: res.data_hora,
                    time: res.time,
                    type: res.type,
                    value: res.value,
                    nome: dados[0].nome,
                    operador: operador,
                    protocolo: dados[0].protocolo,
                    telefone: dados[0].telefone
                  };
                  conteudo.push(temp);
                });
                // enviar mensagens
                var unSubs = this.genProvider
                  .onGetfilter(
                    "dados/" + this.parametros.path + "/agenda",
                    "whatsOuvidoria",
                    true
                  )
                  .subscribe(data => {
                    unSubs.unsubscribe();
                    let agenda = JSON.parse(JSON.stringify(data));
                    if (agenda.length > 0) {
                      agenda.forEach(res => {
                        if (res.status == "Ativo") {
                          let nome = new CamelcasePipe()
                            .transform(conteudo[0].nome)
                            .trim();
                          let telefone_usuario = this.validaCampoProvider.validaTelefoneZap(
                            conteudo[0].telefone.substring(2, 12)
                          );
                          let telefone = res.telefone.replace(/\D/g, "");
                          let cabecalho =
                            "*NOTIFICAÇÃO DE chat DA PLATAFORMA _" +
                            this.parametros.path.toUpperCase() +
                            "_*" +
                            this.ctrl +
                            this.ctrl;
                          cabecalho +=
                            "*Nome do Usuário: " + nome + "*" + this.ctrl;
                          cabecalho +=
                            "Telefone: " + telefone_usuario + this.ctrl;
                          cabecalho +=
                            "Data/Hora :" +
                            conteudo[0].data_hora +
                            this.ctrl;
                          cabecalho +=
                            "Protocolo :" + conteudo[0].protocolo;
                          let formulario = {
                            origem: dados[0].origem,
                            contato: telefone,
                            mensagem: cabecalho,
                            type_midia: "chat"
                          };
                          this.enviarMsg(formulario, null, true);
                          conteudo.forEach(content => {
                            if (content.type == "location") {
                              let coodenada = content.value.split(
                                /\s*;\s*/
                              );
                              let localizacao = {
                                origem: dados[0].origem,
                                contato: telefone,
                                localizacao: "",
                                latitude: coodenada[0],
                                longitude: coodenada[1]
                              };
                              setTimeout(() => {
                                this.sendAll(localizacao, "localizacao");
                              }, 1000);
                            } else if (content.type == "chat") {
                              let mensagem = content.value;
                              if (content.operador) {
                                mensagem =
                                  "[Operador *" +
                                  content.operador +
                                  "* diz]:" +
                                  this.ctrl +
                                  content.value;
                              }
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                mensagem: mensagem,
                                type_midia: content.type
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "image") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                midia: content.value,
                                caption: "Protocolo: " + id,
                                type_midia: "jpeg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "ptt") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                caption: " ",
                                midia: content.value,
                                type_midia: "ogg"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            } else if (content.type == "video") {
                              let formulario = {
                                origem: dados[0].origem,
                                contato: telefone,
                                caption: "Protocolo: " + id,
                                midia: content.value,
                                type_midia: "mp4"
                              };
                              setTimeout(() => {
                                this.enviarMsg(formulario, null, true);
                              }, 2000);
                            }
                          });
                        }
                      });
                    }
                  });
              },
              err => {
                console.log(err);
              }
            );
          }
        },
        err => console.log(err)
      );
    }
  }
  //fim

  //funcoes auxiliares
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  Encrypt(value) {
    var result = "";
    for (let i = 0; i < value.length; i++) {
      if (i < value.length - 1) {
        result += value.charCodeAt(i) + 10;
        result += "-";
      } else {
        result += value.charCodeAt(i) + 10;
      }
    }
    return result;
  }
  Decrypt(value) {
    var result = "";
    var array = value.split("-");

    for (let i = 0; i < array.length; i++) {
      result += String.fromCharCode(array[i] - 10);
    }
    return result;
  }
  cipher(salt) {
    const textToChars = text => text.split("").map(c => c.charCodeAt(0));
    const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = code =>
      textToChars(salt).reduce((a, b) => a ^ b, code);

    return text =>
      text
        .split("")
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join("");
  }
  decipher(salt) {
    const textToChars = text => text.split("").map(c => c.charCodeAt(0));
    const applySaltToChar = code =>
      textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded =>
      encoded
        .match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join("");
  }
  onEnviaMenu(texto, menu, contato, filtro) {
    let formulario = {};
    if (menu.texto == null) {
      texto = "";//this.ctrl;
    }
    if (menu.midia) {
      if (menu.type_midia == "pdf") {
        formulario = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          midia: menu.midia,
          type_midia: menu.type_midia,
          mensagem: texto
        };
        this.enviarMsg(formulario);
        /*
        formulario = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          mensagem: texto
        };
        this.enviarMsg(formulario);
        */
      } else {
        formulario = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          mensagem: texto,
          caption: texto,
          midia: menu.midia,
          type_midia: menu.type_midia
        };
        this.enviarMsg(formulario);
      }

    } else {
      formulario = {
        origem: contato[0].origem,
        contato: contato[0].id_canal,
        mensagem: texto
      };
      this.enviarMsg(formulario);
    }
    //  console.log(formulario)

  }
  onValidaMsg(res) {
    let msg = JSON.stringify(res);
    let temp =
      "[" +
      msg.substring(0, msg.length - 1) +
      ', "token":"' +
      this.parametros.token +
      '","razao":"' +
      this.parametros.razao +
      '", "status":"' +
      status +
      '"}]';
    let dados = JSON.parse(temp);
    this.onContato(dados[0]);
  }
  onLocalizacao(e) {
    return new Promise(resolve => {
      let coodenada = e.split(/\s*;\s*/);
      let geocoder = new google.maps.Geocoder();
      let latLng = new google.maps.LatLng(coodenada[0], coodenada[1]);
      geocoder.geocode({ location: latLng }, (results, status) => {
        let result = {
          localizacao: results[0].formatted_address,
          numero: results[0].address_components[0].long_name || " ",
          bairro: results[0].address_components[2].long_name || " ",
          cidade: results[0].address_components[3].long_name || " ",
          estado: results[0].address_components[4].long_name || " "
        };
        resolve(results[0].formatted_address);
      });
    });
  }

  //fim

  // tratamento de mensagens
  excluirMensagem(protocolo) {
    this.genProvider.remove('dados/' + this.parametros.path + '/chat', protocolo);
  }
  excluirMensagemTicket(protocolo, ticket, atendimento, contato) {
    if (!contato.chatLive) {
      if (protocolo) {
        this.genProvider.remove('dados/' + this.parametros.path + '/chat', protocolo);
      }
      if (ticket) {
        this.genProvider.remove('dados/' + this.parametros.path + '/ticket', ticket);
      }
      if (atendimento) {
        this.genProvider.remove('dados/' + this.parametros.path + '/atendimento', atendimento);
      }
    }

  }
  excluirMensagens(protocolo) {
    let res = this.mensagens.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res.length > 0) {
      const index = this.mensagens.indexOf(res[0]);
      this.mensagens.splice(index, 1);
    }
    let res_body = this.mensagens_body.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res_body.length > 0) {
      res_body.forEach(element => {
        const index = this.mensagens_body.indexOf(element);
        this.mensagens_body.splice(index, 1);
      });
    }
  }
  excluirOuvidoria(protocolo) {
    let res = this.ouvidoria.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res.length > 0) {
      const index = this.ouvidoria.indexOf(res[0]);
      this.ouvidoria.splice(index, 1);
    }
    let res_body = this.ouvidoria_body.filter(obj => {
      return obj.protocolo == protocolo;
    });
    if (res_body.length > 0) {
      res_body.forEach(element => {
        const index = this.ouvidoria_body.indexOf(element);
        this.ouvidoria_body.splice(index, 1);
      });
    }
  }
  onCancelaMsg(key, file, file_body) {
    this.genProvider.remove("dados/" + this.parametros.path + "/" + file, key);
    let unsSub = this.genProvider.onGetFilterOrder(
      "dados/" + this.parametros.path + "/" + file_body,
      "time",
      "protocolo",
      key
    )
      .subscribe(
        data => {
          unsSub.unsubscribe();
          let msg = JSON.parse(JSON.stringify(data));
          msg.forEach(element => {
            setTimeout(() => {
              this.genProvider.remove(
                "dados/" + this.parametros.path + "/" + file_body,
                element.key
              );
            }, 1000);
          });
        },
        err => {
          console.log(err);
        }
      );
  }
  msgCount() {
    return (Observable.interval(2000).map(valor => this.mensagemCount));
  }
  usuarioCount() {
    return (Observable.interval(2000).map(valor => this.contatos.length));
  }
  onStatusBot() {
    return (Observable.interval(3600000).map(valor => {
      return {
        usuariosOnLine: this.contatos.length,
        denuncias: this.mensagemCount,
        denunciasAndamento: this.denuncia.length
      }
    }
    ));
  }
  onCountUsuario_old() {
    return new Promise(resolve => {
      let unSub = this.genProvider.onGetAll("dados/" + this.parametros.path + "/contato", "nome")
        .subscribe(data => {
          let usuarios = JSON.parse(JSON.stringify(data));
          unSub.unsubscribe();
          resolve(usuarios.length);
        });
    })
  }

  onGravarPergunta() {
    this.isGravarPergunta = !this.isGravarPergunta;
  }
  onSavePergunta(contato, data) {
    if (this.isGravarPergunta && data.type == "chat") {
      let dados = {
        telefone: contato.telefone,
        protocolo: contato.protocolo,
        nome: contato.nome,
        data_hora: new DatePipe("pt-BR").transform(
          Date.now(),
          "d, MMMM yyyy - HH:mm"
        ),
        invalida: contato.invalida,
        time: Date.now(),
        data_criacao: Date.now(),
        value: data.body
      }
      //      console.log (dados)
      this.genProvider.onSaveIncrement('dados/' + this.parametros.path + '/logPergunta', dados, 'logPergunta');
    }
  }
  //fim
  // implementacao dia 25-06-2021
  getDialogs() {
    this.parametros = this.genProvider.parametros;
    let url =
      this.parametros.servidor +
      "/instance" +
      this.parametros.instancia +
      "/dialogs?token=" +
      this.parametros.token;
    return new Promise(resolve => {
      this.http.get(url).subscribe(res => {
        resolve(res);
      });
    });
  }
  onchatUpdate() {
    this.getchatUpdate = this.genProvider.onGetfilter("whatschatUpdate/", "instanceId", this.parametros.instancia).subscribe(data => {
      this.chatUpdate = JSON.parse(JSON.stringify(data));
    });
  }
  onUpdateStatus(data, denuncia) {
    let dados = {};
    //    console.log (data)
    //    console.log (denuncia)
    /*
       let temp = this.status.filter(obj => {
         return obj.key == this.formulario.value.status_key;
       });
       */
    dados = {
      key: data.protocolo,
      status_key: data.key_status,
      status_denuncia: data.status,
      status: "Aguardando...",
      data_status: new DatePipe('pt-BR').transform(
        Date.now(),
        'd, MMMM yyyy - HH:mm'
      )
    }

    if (data.notificaUsuario) {
      let msg = '*Status da sua denúncia*' + this.ctrl
      msg += 'Protocolo: ' + data.protocoloDD + this.ctrl
      msg += 'Última Atualização: ' + data.data_hora + this.ctrl
      msg += 'Situação: ' + data.status + this.ctrl + this.ctrl
      msg += '*Esta é uma mensagem automática, não responda* 😉'
      let formulario = {
        contato: denuncia.telefone,
        mensagem: msg
      };
      this.sendMsg(formulario);
    }
    if (data.abreDenuncia) {
      dados = {
        key: data.protocolo,
        status_key: data.key_status,
        status_denuncia: data.status,
        status: "Aguardando...",
        data_status: new DatePipe('pt-BR').transform(
          Date.now(),
          'd, MMMM yyyy - HH:mm'
        )
      }

      let msg = '*Status da sua denúncia*' + this.ctrl
      msg += 'Protocolo: ' + data.protocolo + this.ctrl
      msg += 'Última Atualização: ' + data.data_hora + this.ctrl
      msg += 'Situação: ' + data.status + this.ctrl + this.ctrl
      msg += '*Por favor, complemente a sua denúncia com as informações que estão faltando* 😉' + this.ctrl
      //      msg += 'Avaliação: '+this.formulario.value.avaliacao ||' '
      let formulario = {
        contato: denuncia.telefone,
        mensagem: msg
      };
      this.sendMsg(formulario);
      this.abriDenuncia(data, denuncia);
    }
    this.genProvider.onSaveObjeto('dados', this.parametros.path, 'denuncia', dados)
    console.log("Status Atualizado.")
  }
  abriDenuncia(data, denuncia) {
    //  let susContato = this.genProvider.onGetfilter('dados/' + this.parametros.path + '/contato', 'telefone', denuncia.telefone).subscribe(res => {
    //    let contato = JSON.parse(JSON.stringify(data));
    //    if (contato.length > 0 ){
    //  console.log (data)
    //  console.log (denuncia)
    let atuContato = {
      acesso: 2,
      bloqueado: denuncia.bloqueado,
      coordenadas: denuncia.coordenadas,
      data_hora: new DatePipe('pt-BR').transform(
        Date.now(),
        'd, MMMM yyyy - HH:mm'
      ),
      data_nascimento: denuncia.data_nascimento,
      invalida: denuncia.invalida,
      localizacao: denuncia.localizacao,
      nivel: denuncia.nivel,
      nome: denuncia.nome,
      status: "Ativo",
      telefone: denuncia.telefone,
      status_denuncia: denuncia.status_denuncia,
      time: Date.now(),
      data_criacao: Date.now(),
      data: Date(),
      tipo: denuncia.tipo,
      key_pergunta: denuncia.key_pergunta,
      protocolo: denuncia.protocolo,
      key_master: denuncia.key_master,
      key_child: denuncia.key_child,
      menu: denuncia.menu,
      countNatureza: 0,
      natureza: ''
    }
    this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/abrirdenuncia", this.parametros.instancia, atuContato);
    let dados = {
      status: "Enviada",
      protocolo: denuncia.protocolo,
      nome: denuncia.nome,
      telefone: denuncia.telefone,
      type: "chat",
      value: data.status,
      time: Date.now(),
      data_criacao: Date.now(),
      data_hora: new DatePipe('pt-BR').transform(
        Date.now(),
        'd, MMMM yyyy - HH:mm'
      )
    }
    this.genProvider.onSaveObjeto('dados', this.parametros.path, 'denuncia_body', dados);
    //  }
    //   susContato.unsubscribe();
    // });
  }
  registraAtendimento(contato) {
    console.log(contato)
    var dtInicio = new DatePipe("pt-BR").transform(contato[0].time, "dd/MM/yyyy - HH:mm:ss"); //"20/06/2017 16:40:00";
    var dtAtual = new DatePipe("pt-BR").transform(Date.now(), "dd/MM/yyyy - HH:mm:ss"); //"20/06/2017 11:20:00";
    var ms = moment(dtAtual, "DD/MM/YYYY HH:mm:ss").diff(moment(dtInicio, "DD/MM/YYYY HH:mm:ss"));
    var d = moment.duration(ms);
    var tempo = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");
    //   totalHoraDisplay.innerHTML = s;
    let atendimento = {
      status: "Finalizado",
      tipo: contato[0].tipo,
      protocolo: contato[0].protocolo + '-' + new DatePipe("pt-BR").transform(Date.now(), "mmss"),
      ticket: null,
      key_puc: this.parametros.key_puc,
      key_lotacao: this.parametros.key_lotacao,
      key_usuario: '000000',
      key_solicitante: contato[0].telefone,
      nome_solicitante: contato[0].nome,
      origem: contato[0].origem,
      id_canal: contato[0].id_canal,
      telefone: contato[0].telefone,
      data_criacao: Date.now(),
      time: Date.now(),
      tempo: tempo,
      menu: contato[0].menu
    };
    this.genProvider.onSaveDocKey("dados/" + this.parametros.path + "/atendimento", atendimento.protocolo, atendimento).then(key => {
      //   this.genProvider.onSaveIncrement("dados/" + this.parametros.path + "/atendimento", atendimento, "atendimento").then(key => {
      contato[0].time = Date.now();
      contato[0].geraTicket = false;
      this.atualizaContato(contato[0]);
    })

  }
  onSaveChat(data) {
    data.body.time = Date.now()
    let a = new DatePipe("pt-BR").transform(data.body.time, "dd/MM/yyyy - HH:mm:ss");
    this.genProvider.onSave(data.url, data.body)
  }
  //filtros
  filtroMenuPublicidade(numero) {
    return new Promise(resolve => {
      let res = this.publicidade.filter(obj => {
        return obj.numero == numero;
      });
      resolve(res);
    });
  }
  filtroChild(data, key_child) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.key_child == key_child;
      });
      resolve(res);
    });
  }
  filtroClassificado(data, menu) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.menu == menu;
      });
      let res_final = res.filter(obj => {
        return obj.status == "Publicado";
      });
      resolve(res_final);
    });
  }
  filtroPublicidade(data, hoje) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.publicar_ate >= hoje;
      });
      let res_final = res.filter(obj => {
        return obj.status == "Ativo";
      });
      resolve(res_final);
    });
  }
  filtroNoticia(data, hoje) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.publicar_ate >= hoje;
      });
      let res_final = res.filter(obj => {
        return obj.status == "Ativo";
      });
      resolve(res_final);
    });
  }
  filtroPesquisa(data, pesquisa) {
    let filtro = pesquisa.toLowerCase();
    return new Promise(resolve => {
      let res = data.filter(obj => {
        if (obj.busca.toLocaleLowerCase().indexOf(filtro) >= 0) {
          return true;
        }
        return false;
      });
      resolve(res);
    });
  }
  filtroMaster(data, key_master) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.key_master == key_master;
      });
      resolve(res);
    });
  }
  filtroUid(data, key_child) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.uid == key_child;
      });
      resolve(res);
    });
  }
  filtroOpcao(data, filtro) {
    return new Promise(resolve => {
      let res = data.filter(obj => {
        return obj.numero == filtro
      });
      resolve(res);
    });
  }
  filtroMenu(data, filtro) {
    let res: any;
    return new Promise(resolve => {
      res = data.filter(obj => {
        return obj.menu == filtro;
      });
      resolve(res);
    });
  }
  filtroMenuNoticia(numero) {
    return new Promise(resolve => {
      let res = this.noticia.filter(obj => {
        return obj.numero == numero;
      });
      resolve(res);
    });
  }
  filtroMenuGaleria(numero) {
    return new Promise(resolve => {
      let res = this.galeria.filter(obj => {
        return obj.numero == numero;
      });
      resolve(res);
    });
  }
  filtroNivel(data, nivel, key_dad) {
    let res: any;
    return new Promise(resolve => {
      if (nivel == 0) {
        res = data.filter(obj => {
          return obj.nivel == nivel;
        });
      } else {
        res = data.filter(obj => {
          return obj.nivel == nivel && obj.key_child == key_dad;
        });
      }
      resolve(res);
    });
  }
  filtroMenuEnquete(opc) {
    return new Promise(resolve => {
      let tmp = this.menu_enquete.filter(obj => {
        return obj.numero == opc;
      });
      resolve(tmp);
    });
  }
  filtroMenuEnqueteKey(key) {
    return new Promise(resolve => {
      let tmp = this.menu_enquete.filter(obj => {
        return obj.key_enquete == key;
      });
      resolve(tmp);
    });
  }
  filtroMenuEnqueteEncerrada(opc) {
    return new Promise(resolve => {
      let tmp = this.menu_enquete_encerrada.filter(obj => {
        return obj.numero == opc;
      });
      resolve(tmp);
    });
  }
  filtroMenuEnqueteOpcao(opc) {
    return new Promise(resolve => {
      let tmp = this.menuEnqueteOpcao.filter(obj => {
        return obj.numero == opc;
      });
      resolve(tmp);
    });
  }
  onSendWaBi(msg: any) {
    console.log("aqui", msg)
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    let options = new RequestOptions({
      headers: headers,
      method: "POST"
    });
    let body = null
    if (msg.midia) {
      if ((msg.type_midia == 'document') || (msg.type_midia == 'pdf') || (msg.type_midia == 'doc') || (msg.type_midia == 'docx') || (msg.type_midia == 'xls') || (msg.type_midia == 'xlsx')) {
        // this.sendTextWaBa("Aguarde, já estamos enviando o documento.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "document",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            document: {
              link: msg.midia,
              caption: msg.mensagem
            }
          }
        }
      } else if ((msg.type_midia == 'imagem') || (msg.type_midia == 'image') || (msg.type_midia == 'jpg') || (msg.type_midia == 'jpeg') || (msg.type_midia == 'png')) {
        //  this.sendTextWaBa("Aguarde, já estamos enviando a imagem.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "image",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            image: {
              link: msg.midia,
              caption: msg.caption || msg.message
            }
          }
        }
      } else if ((msg.type_midia == 'audio') || (msg.type_midia == 'ogg') || (msg.type_midia == 'ptt') || (msg.type_midia == 'mp3')) {
        //  this.sendTextWaBa("Aguarde, já estamos enviando o áudio.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "audio",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            audio: {
              link: msg.midia
            }
          }
        }
      } else if ((msg.type_midia == 'video') || (msg.type_midia == 'mp3') || (msg.type_midia == 'mp4')) {
        //  this.sendTextWaBa("Aguarde, já estamos enviando o vídeo.",msg.contato)
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "video",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            video: {
              link: msg.midia,
              caption: msg.caption || msg.message
            }
          }
        }
      } else if ((msg.type_midia == 'location')) {
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            type: "location",
            recipient_type: "individual",
            messaging_product: "whatsapp",
            location: {
              link: msg.midia,
              caption: msg.caption || msg.message
            }
          }
        }

      }
    } else if (msg.list) {
      body = {
        type: "chat",
        api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          to: msg.contato,
          recipient_type: "individual",
          messaging_product: "whatsapp",
          type: "interactive",
          interactive: {
            type: "list",
            header: {
              "type": "text",
              "text": msg.header
            },
            body: {
              "text": msg.body
            },
            footer: {
              "text": msg.footer
            },
            action: {
              button: msg.button,
              sections: [
                {
                  title: msg.title,
                  rows: msg.rows,
                }
              ]
            }
          }
        }
      }
    } else if (msg.header) {
      body = {
        type: "chat",
        api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          to: msg.contato,
          recipient_type: "individual",
          messaging_product: "whatsapp",
          type: "interactive",
          interactive: {
            type: "button",
            header: {
              "type": "text",
              "text": msg.header
            },
            body: {
              "text": msg.body
            },
            footer: {
              "text": msg.footer
            },
            action: {
              buttons: msg.rows
            }
          }
        }
      }
    } else if (msg.preview_url) {
      let url = msg.preview_url || false;
      body = {
        type: "chat",
        api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          "to": msg.contato,
          "type": "text",
          "recipient_type": "individual",
          "messaging_product": "whatsapp",
          "text": {
            "body": msg.mensagem,
          },
          "preview_url": true
        }
      }
    } else {
      console.log('texto')
      body = {
        type: "chat",
        api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
        app_id: this.parametros.instancia + "/messages",
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token,
        messages: {
          to: msg.contato,
          recipient_type: "individual",
          messaging_product: "whatsapp",
          text: {
            body: msg.mensagem
          }
        }
      }
    }

    console.log(body)
    let url = this.parametros.url_send

    this.http.post(url, body, options).subscribe((res: any) => {
      let data = JSON.parse((res._body));
      console.log(data)
      if (data.errors) {
        console.log("aqui")
        let texto = 'Erro Code:' + data.errors[0].code + this.ctrl;
        texto += data.errors[0].title + this.ctrl;
        texto += data.errors[0].details + this.ctrl;
        body = {
          type: "chat",
          api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
          app_id: this.parametros.instancia,
          app_phone: this.parametros.telefone,
          token: "Bearer " + this.parametros.token,
          messages: {
            to: msg.contato,
            recipient_type: "individual",
            messaging_product: "whatsapp",
            text: {
              body: texto,
            }
          }
        }
        this.http.post(url, body, options).subscribe((res: any) => {
          console.log(res)

        });
      }
    });
  }
  sendTextWaBa(value: string, contato: string) {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    let options = new RequestOptions({
      headers: headers,
      method: "POST"
    });
    let body = {
      type: "chat",
      api_url: this.parametros.servidor + '/' + this.parametros.token_user + "/messages",
      app_id: this.parametros.instancia,
      app_phone: this.parametros.telefone,
      token: "Bearer " + this.parametros.token,
      messages: {
        to: contato,
        recipient_type: "individual",
        messaging_product: "whatsapp",
        text: {
          body: value
        }
      }
    }
    console.log(body)
    let url = this.parametros.url_send
    this.http.post(url, body, options).subscribe((res: any) => {
      console.log(JSON.stringify(res._body))
    });
  }
  sendTextSms(msg, phone) {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    let options = new RequestOptions({
      headers: headers,
      method: "POST"
    });
    let body = {
      type: "sms",
      api_url: this.parametros.url_sms,
      id: '9',
      app_phone: phone,
      token: this.parametros.token_sms,
      message: "msg"
    }
    let url = this.parametros.url_send

    this.http.post(url, body, options).subscribe(res => {
      console.log(res)
    });
  }
  onGetUrlMedia(id) {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    let options = new RequestOptions({
      headers: headers,
      method: "POST"
    });
    return new Promise(resolve => {
      let body = {
        type: "media_url",
        api_url: this.parametros.servidor + '/' + id,
        token: "Bearer " + this.parametros.token
      }
      let url = this.parametros.url_send
      this.http.post(url, body, options).subscribe(res => {
        resolve(res)
      });
    });
  }
  onDownLoadMidia(file) {
    return new Promise(async (resolve) => {
      this.onGetUrlMedia(file.id).then((res: any) => {
        let dados = JSON.parse(res._body);
        console.log (dados)
        let body = {
          type: "download",
          api_url: dados.url,
          token: "Bearer " + this.parametros.token
        }
        let xhr = new XMLHttpRequest();
        xhr.responseType = "json"
        xhr.open("POST", 'https://hyperchannelbrasil.com.br/webhook/sendwaba.php', true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        let self = this;
        xhr.responseType = "arraybuffer";
        xhr.onreadystatechange = function (t) {
          if (xhr.readyState == 4) {
            xhr.onload = function (s) {
              const TYPED_ARRAY = new Uint8Array(this.response);
              var base64 = btoa(new Uint8Array(TYPED_ARRAY).reduce((data, byte) => data + String.fromCharCode(byte), ''));
              console.log(base64);
              resolve(base64)
            };
          }
        }
        xhr.send(JSON.stringify(body))

      });

    })
  }
  onLoginUser() {
    /*
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    let options = new RequestOptions({
      headers: headers,
      method: "POST"
    });
    let body = {
      type: "login",
      api_url: this.parametros.servidor + '/' + this.parametros.token_user +  "/users/login",
      app_id: this.parametros.instancia,
      app_phone: this.parametros.telefone,
      token: "Basic " + this.parametros.token_user
    }
    let url = this.parametros.url_send
    console.log(url, body)

    this.http.post(url, body, options).subscribe((res: any) => {
      let data = JSON.parse((res._body));
      let token = data.users[0].token
      let dados = {
        key: this.parametros.key,
        token: token
      }
      this.parametros.token = token;
      //   this.genProvider.onSaveObjeto('dados', this.parametros.path, 'parametros', dados);
    })
*/
  }
  onGetLogin() {
    this.onLoginUser();
    setInterval(() => {
      this.onLoginUser();
    }, (3600000 * 24));
  }
  onBot() {
    /*
    this.onCountUsuario().then(res => {
      let msg1 = "*Plataforma Disque Denúncia.*" + this.ctrl + "Status whatsapp." + this.ctrl
      msg1 += "Total de Acessos: " + res + this.ctrl;
      msg1 += "Usuários on line: " + this.contatos.length + this.ctrl;
      msg1 += "Total de Denúncias: " + this.mensagemCount + this.ctrl;
      msg1 += "Denúncias em Andamento: " + this.denuncia.length
      let formulario = {
        contato: "559180333070",
        mensagem: msg1
      };
      this.enviarMsg(formulario);
    })
    */
    /*
     if (!this.statusBot) {
       this.statusBot = true;
       this.unSubstatus = this.onStatusBot().subscribe(data => {
         //      this.onCountUsuario().then(res => {
         let msg1 = "*Plataforma Hyper Channel (" + this.parametros.path + ")*" + this.ctrl + "Status: online" + this.ctrl
         //        msg1 += "Total de Acessos: " + res + this.ctrl;
         msg1 += "Usuários logados: " + this.contatos.length + this.ctrl;
         //    msg1 += "Total de Denúncias: " + this.mensagemCount + this.ctrl;
         //     msg1 += "Denúncias em Andamento: " + this.denuncia.length
         let formulario = {
           origem: 'whatsapp',
           contato: "559180333070",
           mensagem: msg1
         };
         this.enviarMsg(formulario);
         //       })
       })
     } else {
       this.unSubstatus.unsubscribe();
       this.statusBot = false;
     }
     */
  }
  onIntegracao(id) {
    if (this.parametros.webhookDenuncia) {
      this.pesquisaChat(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaChat_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                if (dados_body.length > 0) {
                  let conteudo = [];
                  let denuncia = ' ';
                  let idprotocolo = dados[0].protocolo
                  dados_body.forEach(e => {
                    if (e.type == 'chat' || e.type == 'interactive') {
                      if (e.value) {
                        denuncia = denuncia + e.value + this.ctrl;
                      }
                    } else {
                      let temp = {
                        type: e.type,
                        value: e.value
                      };
                      conteudo.push(temp);
                    }
                  });

                  let msg = {
                    instanceId: this.parametros.instancia,
                    token: this.parametros.token_user,
                    status: "INSERIR",
                    situacao: "REGISTRADA",
                    data_registro: dados[0].time,
                    data_status: dados[0].time,
                    origem: dados[0].origem.toLowerCase(),
                    lat: 0,
                    lng: 0,
                    local: "",
                    tipo: "",
                    estabelecimento: "",
                    logradouro: "",
                    bairro: "",
                    cidade: "",
                    estado: "",
                    cep: "",
                    denuncia: denuncia,
                    files: conteudo
                  };
                  let telefone = dados[0].telefone;
                  console.log(msg)
                  this.http.post(this.parametros.webhookUrl, msg, this.options).subscribe(res => {
                    console.log(res)
                    let data = JSON.parse(JSON.stringify(res));
                    let protocolo: any
                    try {
                      protocolo = JSON.parse(data._body);
                    } catch (e) {
                      protocolo = null
                    }
                    //      console.log(protocolo)
                    let id = null;
                    let erro = null;
                    if (protocolo["iddenuncia"]) {
                      id = protocolo["iddenuncia"];
                    } else {
                      console.log("Erro ao retornar iddenuncia" + protocolo)
                      erro = protocolo["error"];
                      let formulario = {
                        origem: 'email',
                        assunto: "Erro ao retornar iddenuncia",
                        contato: "paulospcoelho@gmail.com",
                        mensagem: erro
                      };
                      this.enviarMsg(formulario);
                    }
                    if (id) {
                      let formulario = {
                        origem: dados[0].origem,
                        contato: telefone,
                        mensagem:
                          "Protocolo da sua denúncia: " +
                          "*" + id + "*" +
                          this.ctrl +
                          this.msg_denuncia_acompanhar + this.ctrl + '*Esta é uma mensagem automática, não responda* 😉'

                      };
                      this.enviarMsg(formulario, null, true);
                      let temp = {
                        key: dados[0].key,
                        ticket: id,
                        value: denuncia
                      }
                      // this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chat_fila', temp)
                      this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chat', temp)
                    } else {
                      let formulario = {
                        origem: 'email',
                        assunto: "Erro servico DD",
                        contato: "paulospcoelho@gmail.com",
                        mensagem:
                          "Protocolo :" +
                          id +
                          this.ctrl +
                          erro
                      };
                      this.enviarMsg(formulario);
                    }
                  }, err => {
                    console.log(err);
                    let formulario = {
                      origem: 'email',
                      contato: "paulospcoelho@gmail.com",
                      assunto: "Erro servico DD",
                      mensagem:
                        "Protocolo :" +
                        id +
                        this.ctrl +
                        "erro no envio p/ DD: " +
                        err
                    };
                    this.enviarMsg(formulario);
                  }
                  );

                }
              },
              err => {
                console.log(err);
                let formulario = {
                  origem: 'email',
                  assunto: "Erro servico DD",
                  contato: "paulospcoelho@gmail.com",
                  mensagem:
                    "Protocolo :" +
                    id +
                    this.ctrl +
                    "erro firebase p/ DD: " +
                    err
                };
                this.enviarMsg(formulario);
              }
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }
  }
  onStartIntegracao() {
    console.log("start")
    this.onParametro();
    setTimeout(() => {
      this.onLoadLogin();
      this.onLoadTipo();
      this.onPessoas();
      this.onLoadCatalogo();
    }, 10000);

  }
  onLoadLogin() {
    let unSub = this.genProvider.onGetAll('login', 'nome').subscribe(data => {
      unSub.unsubscribe();
      this.usuarios = JSON.parse(JSON.stringify(data));
    })
  }
  onPessoas() {
    let unSub = this.genProvider.onGetAll('dados/' + this.parametros.path + '/pessoa', 'nome').subscribe(data => {
      unSub.unsubscribe()
      this.pessoa = JSON.parse(JSON.stringify(data));
    })
  }
  onLoadCatalogo() {
    this.genProvider.onGetAll('dados/' + this.parametros.path + '/catalogo', 'nome').pipe(take(1)).subscribe(data => {
      this.catalogo = JSON.parse(JSON.stringify(data));
      let c = 0;
      this.catalogo.forEach(e => {
        c++
        this.genProvider.onGetAll('dados/' + this.parametros.path + '/catalogo/' + e.key + '/item', "nome").pipe(take(1)).subscribe(data => {
          let itemCatalogo = JSON.parse(JSON.stringify(data));
          itemCatalogo.forEach(i => {
            this.itemCatalogo.push(i)
            this.genProvider.onGetAll('dados/' + this.parametros.path + '/catalogo/' + e.key + '/item/' + i.key + '/subitem', 'nome').pipe(take(1)).subscribe(data => {
              let subItem = JSON.parse(JSON.stringify(data));
              subItem.forEach(s => {
                this.subItem.push(s)
              })
            });
          });
        },
          err => console.log(err)
        );
        if (c >= this.catalogo.length) {
          setTimeout(() => {
            this.onPegaTickets();
          }, 5000);
        }
      });
    },
      err => console.log(err)
    );
  }
  onLoadTipo() {
    let unSub = this.genProvider.onGetAll('dados/' + this.parametros.path + '/tipo', 'nome').subscribe(data => {
      unSub.unsubscribe();
      this.tipo = JSON.parse(JSON.stringify(data));
      this.onLoadLotacao();
    })
  }
  onLoadLotacao() {
    let unSub = this.genProvider.onGetAll('dados/' + this.parametros.path + '/lotacao', 'nome').subscribe(data => {
      unSub.unsubscribe()
      let lotacoes = JSON.parse(JSON.stringify(data));
      this.lotacao = lotacoes.map(res => {
        let tipo_lotacao = this.genProvider.onGetTableKey(this.tipo, res.key_tipo);
        if (tipo_lotacao) {
          res.tipo_lotacao = tipo_lotacao.nome;
        } else {
          res.tipo_lotacao = '';
        }
        return res
      });
      console.log(this.lotacao)
    })
  }
  onPegaTickets(qtd_dias?: any) {
    let dias = 7;
    let time = new Date();
    let inicio = new Date();
    inicio.setDate(time.getDate() - dias);
    let dia = Date.parse(inicio.toString());
    let unMsg = this.genProvider.onGetPeriodo('dados/' + this.parametros.path + '/ticket', 'data_criacao', dia).subscribe(data => {
      unMsg.unsubscribe();
      let temp = JSON.parse(JSON.stringify(data));
      if (temp.length > 0) {
        this.temp = temp.map(res => {
          if (!res.nome_responsavel) {
            res.nome_responsavel = 'Sem responsável'
          }
          res.dia = new DatePipe("pt-BR").transform(res.time, "dd-MM");
          //       res.data_criacaoM = new DatePipe("pt-BR").transform(res.data_criacao, "d/MM - HH:mm");
          //     res.prazo_resolucaoM = new DatePipe("pt-BR").transform(res.prazo_resolucao, "d/MM/yyyy - HH:mm");
          if (res.qtd_interacao) {
            res.ultima_interacaoM = new DatePipe("pt-BR").transform(res.time, "d/MM - HH:mm") + " / " + res.qtd_interacao || '';
          } else {
            res.qtd_interacao = null
          }
          if (res.key_usuario) {
            let nome$ = this.genProvider.onGetTableKey(this.usuarios, res.key_usuario)
            if (nome$) {
              res.nome_agente = nome$.nome
            }
          } else {
            res.key_usuario = null
            res.nome_agente = null
          }

          if (res.key_lotacao) {
            let nome$ = this.genProvider.onGetTableKey(this.lotacao, res.key_lotacao)
            if (nome$) {
              res.nome_lotacao = nome$.nome;
              res.tipo_lotacao = nome$.tipo_lotacao;
              res.codigo_sigean = nome$.codigo || null;
              res.lat = nome$.lat || null;
              res.lng = nome$.lng || null;
            }
          } else {
            res.key_lotacao = null;
            res.nome_lotacao = null;
            res.tipo_lotacao = null;
            res.lat = null;
            res.lng = null;
            res.codigo_sigean = null;

          }
          if (res.key_item) {
            let nome$ = this.genProvider.onGetTableKey(this.itemCatalogo, res.key_item)
            if (nome$) {
              res.nome_item = nome$.nome
            }
          } else {
            res.nome_item =
              res.key_item = null
          }
          if (res.key_responsavel) {
            let nome$ = this.genProvider.onGetTableKey(this.pessoa, res.key_responsavel)
            if (nome$) {
              res.nome_responsavel = nome$.nome
            }
          } else {
            res.key_responsavel = null;
            res.nome_responsavel = null;
          }
          if (res.key_subitem) {
            let nome$ = this.genProvider.onGetTableKey(this.subItem, res.key_subitem)
            if (nome$) {
              res.nome_subitem = nome$.nome
            }
          } else {
            res.key_subitem = null;
            res.nome_subitem = null;
          }
          if (res.conteudo == '') {
            res.conteudo = null;
          }
          res.canal = res.canal.toUpperCase()
          res.id_pesquisa = null;
          res.text_pesquisa = null;

          return res;
        });
        this.onIntegrarTicket(this.temp)
      }
    });

  }

  onIntegrarTicket(tickets) {
    let temp = this.temp.filter(obj => {
      return obj.status != "Cancelado" && obj.canal != "EMAIL"
    })
    console.log(temp);
    let url = this.parametros.webhookUrl;
    url = "http://13.58.56.37:5000/webhook.php";
    let i = 0;
    let startIntervalo = setInterval(() => {
      let data = temp[i]
      console.log(data)
      this.http.post(url, data, this.options).subscribe(
        res => {
          console.log(res)
        })
      i++
      if (i >= temp.length)
        clearInterval(startIntervalo);
    }, 1000);
  }
  onTemplateShow(contato) {
    if (contato[0].n_pergunta >= contato[0].template.length) {
      this.onFinalizaTemplate(contato)
    } else {
      let i = contato[0].n_pergunta
      while (contato[0].template[i].status == 'oculto') {
        i++
      }
      let template = contato[0].template[i]
      let msg_template: any = [];
      if (template.type == 'text') {
        msg_template = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          mensagem: template.texto
        }
        contato[0].validacao = template.validacao || null
        contato[0].type = template.type || null
        contato[0].acao = null
        contato[0].value = null
        contato[0].titulo_pergunta = template.texto
        contato[0].field = template.field
      } else if (template.type == 'reply') {
        let btn_item = []
        template.rows.forEach(b => {
          let bt = {
            type: "reply",
            reply: {
              id: b.id,
              title: b.title
            }
          }
          btn_item.push(bt)
        })
        msg_template = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          header: template.header,
          body: template.body,
          footer: template.footer,
          rows: btn_item
        };
        contato[0].titulo_pergunta = template.header
        contato[0].field = template.field
        contato[0].acao = template.rows || null
        contato[0].type = template.type || null
        contato[0].value = template.value || null
        contato[0].validacao = null
        console.log(template)
      } else if (template.type == 'list') {
        msg_template = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          header: template.header,
          body: template.body,
          footer: template.footer,
          title: template.title,
          button: template.button,
          list: true,
          rows: template.rows
        };
        contato[0].titulo_pergunta = template.title
        contato[0].field = template.field
        contato[0].acao = null
        contato[0].value = null
        contato[0].validacao = null
        contato[0].type = template.type || null
      }
      contato[0].n_pergunta = i + 1;
      this.atualizaContato(contato[0]);
      this.enviarMsg(msg_template);
    }


  }
  onTemplateShowAll(contato) {
    console.log("showall")
    if (contato[0].n_pergunta >= contato[0].template.length) {
      this.onFinalizaTemplate(contato)
    } else {
      let i = contato[0].n_pergunta
      let template = contato[0].template[i]
      let msg_template: any = [];
      if (template.type == 'text') {
        msg_template = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          mensagem: template.texto
        }
        contato[0].validacao = template.validacao || null
        contato[0].type = template.type || null
        contato[0].acao = null
        contato[0].value = null
        contato[0].titulo_pergunta = template.texto
        contato[0].field = template.field
      } else if (template.type == 'reply') {
        let btn_item = []
        template.rows.forEach(b => {
          let bt = {
            type: "reply",
            reply: {
              id: b.id,
              title: b.title
            }
          }
          btn_item.push(bt)
        })
        msg_template = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          header: template.header,
          body: template.body,
          footer: template.footer,
          rows: btn_item
        };
        contato[0].titulo_pergunta = template.header
        contato[0].field = template.field
        contato[0].acao = template.rows || null
        contato[0].value = template.value || null
        contato[0].validacao = null
        contato[0].type = template.type || null
        console.log(template)
      } else if (template.type == 'list') {
        msg_template = {
          origem: contato[0].origem,
          contato: contato[0].id_canal,
          header: template.header,
          body: template.body,
          footer: template.footer,
          title: template.title,
          button: template.button,
          list: true,
          rows: template.rows
        };
        contato[0].titulo_pergunta = template.title
        contato[0].field = template.field
        contato[0].acao = null
        contato[0].value = null
        contato[0].validacao = null
        contato[0].type = null
      }
      contato[0].n_pergunta = i + 1;
      this.atualizaContato(contato[0]);
      this.enviarMsg(msg_template);
    }


  }
  onFinalizaTemplate(contato) {
    let dados_msg = {
      key: contato[0].protocolo,
      origem: contato[0].origem,
      key_template: contato[0].key_template,
      image: "assets/icon/" + contato[0].origem.trim() + ".png",
      status: "Novo",
      novo: '1',
      time: Date.now(),
      data_criacao: Date.now(),
      nome: contato[0].nome,
      value: contato[0].conteudo
    };
    this.genProvider.onSaveObjeto("dados", this.parametros.path, "chat", dados_msg);
    this.onSavePerguntaTemplate(contato[0].protocolo);
    if (this.parametros.webhookDenuncia) {
      let msg2 = {
        origem: contato[0].origem,
        contato: contato[0].id_canal,
        mensagem: "📮Sua mensagem foi finalizada com sucesso!" + this.ctrl + "Anote seu protocolo 👉 " + contato[0].protocolo + " 👈"
      };
      this.enviarMsg(msg2);
    }
    setTimeout(() => {
      this.onFinalizaAtendimento(contato);
    }, 1000);
    contato[0].finaliza = true;
    this.atualizaContato(contato[0]);
  }
  onSavePerguntaTemplate(id) {
    setTimeout(() => {
      this.pesquisaChat(id).then(
        data => {
          let dados = JSON.parse(JSON.stringify(data));
          if (dados.length > 0) {
            this.pesquisaChat_body(id).then(
              data_body => {
                let dados_body = JSON.parse(JSON.stringify(data_body));
                if (dados_body.length > 0) {
                  let conteudo = '';
                  let tmp1 = dados_body.filter(res => {
                    return res.pergunta == false && res.field != 'relato'
                  })
                  let tmp2 = dados_body.filter(res => {
                    return res.pergunta == false && res.field == 'relato'
                  })
                  tmp2.forEach(e => {
                    if (e.value.length > 0) {
                      conteudo = conteudo + e.value + this.ctrl;
                    }
                  });
                  let colsDados = tmp1.map(col => ({
                    [col.field]: col.value
                  }
                  ));
                  let a = JSON.stringify(colsDados)
                  let b = a.replace(/\{/g, '');
                  let c = b.replace(/\}/g, '');
                  let d = c.replace(/\[/g, '{');
                  let e = d.replace(/\]/g, '}');
                  var obj = JSON.parse(e);
                  let msg = {
                    protocolo: id,
                    status: "NOVO",
                    situacao: "REGISTRADA",
                    data_hora: dados[0].data_hora,
                    time: dados[0].time,
                    key_template: dados[0].key_template,
                    origem: dados[0].origem.toLowerCase(),
                    relato: conteudo,
                    ...obj
                  };
                  this.genProvider.onSaveObjeto('dados', this.parametros.path, 'chat_dinamico', msg)
                }
              },
            );
            // fim
          }
        },
        err => console.log(err)
      );
    }, 5000);


  }
  // tratamento p/ api de email

  onStartEmail(value) {
    if (value) {
      this.onTimeEmail();
    } else {
      clearInterval(this.timeMail);
    }
  }
  onTimeEmail() {
    console.log("AutoMail ativo")
    console.log(this.parametros)
    console.log(this.parametros.intervalo_email)
    //  let n = Math.floor(Math.random() * ((1000 * 60) * this.parametros.intervalo_email))
    this.timeMail = setInterval(() => {
      //     this.loadListEmail();
    }, (this.parametros.intervalo_email * 1000));
  }
  onSendEmail(msg) {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    let options = new RequestOptions({
      headers: headers,
      method: "POST"
    });
    let body = {
      type: 'send',
      Host: this.parametros.host_email,
      Username: this.parametros.conta_email,
      Password: this.parametros.senha_email,
      origem: this.parametros.origem_email,
      destino: msg.contato,
      assunto: msg.assunto,
      mensagem: msg.mensagem
    }
    console.log(body)
    let url = this.parametros.url_email
    this.http.post(url, body, options).subscribe(res => {
      console.log(res)
    });
  }
  loadEmail(data) {
    this.onParametro();
    console.log(this.parametros)
    console.log("aqui load email")
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    let options = new RequestOptions({
      headers: headers,
      method: "POST"
    });
    let body = {
      type: 'loadList',
      Host: this.parametros.host_email,
      Username: this.parametros.conta_email,
      Password: this.parametros.senha_email,
      origem: this.parametros.origem_email,
      destino: data.id_canal,
      assunto: "assunto",
      mensagem: data.msg,
      path: this.genProvider.parametros.path,
      instancia: this.genProvider.parametros.telefone
    }
    let url = this.parametros.url_email
    this.http.post(url, body, options).subscribe((res: any) => {
      let num_email = JSON.parse(res._body);
      console.log(num_email)
      num_email.forEach(e => {
        let body = {
          type: 'load',
          Host: this.parametros.host_email,
          Username: this.parametros.conta_email,
          Password: this.parametros.senha_email,
          origem: this.parametros.origem_email,
          destino: data.id_canal,
          assunto: "assunto",
          mensagem: data.msg,
          path: this.genProvider.parametros.path,
          instancia: this.genProvider.parametros.telefone,
          uid: e
        }
        this.http.post(url, body, options).subscribe((res: any) => {
          console.log(res)
        });
      });
    });
  }
  loadListEmail() {
    console.log("load lista de email")
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    let options = new RequestOptions({
      headers: headers,
      method: "POST"
    });
    let body = {
      type: 'loadList',
      Host: this.parametros.host_email,
      Username: this.parametros.conta_email,
      Password: this.parametros.senha_email,
      origem: this.parametros.origem_email,
      path: this.genProvider.parametros.path,
      instancia: this.genProvider.parametros.telefone
    }
    let url = this.parametros.url_email
    this.http.post(url, body, options).subscribe((res: any) => {
      let num_email = JSON.parse(res._body);
      //  num_email =[24]
      console.log(num_email)
      let t = 0
      if (num_email) {
        if (num_email.length > 0) {
          num_email.forEach(e => {
            setTimeout(() => {
              let body = {
                type: 'load',
                Host: this.parametros.host_email,
                Username: this.parametros.conta_email,
                Password: this.parametros.senha_email,
                origem: this.parametros.origem_email,
                path: this.genProvider.parametros.path,
                instancia: this.genProvider.parametros.telefone,
                uid: e
              }
              this.http.post(url, body, options).subscribe((res: any) => {
                console.log(res)
              });
            }, t);
            t = t + 15000
          });
        }
      }
    });
  }
  loadMidiaEmail(dados) {
    console.log("Load Anexo email")
    let url = 'https://srv.email.hyperchannel.com.br' + dados.url.substring(1)
    let type_file = dados.file.split('.').pop();
    console.log(type_file)
    console.log(url)
    return new Promise(async (resolve) => {
      let body = {
        type: "download",
        url: url,
      }
      console.log(this.parametros.url_email)
      let xhr = new XMLHttpRequest();
      xhr.responseType = "json"
      xhr.open("POST", this.parametros.url_email, true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      let self = this;
      xhr.responseType = "arraybuffer";
      xhr.onreadystatechange = function (t) {
        if (xhr.readyState == 4) {
          xhr.onload = function (s) {
            const TYPED_ARRAY = new Uint8Array(this.response);
            var base64 = btoa(
              new Uint8Array(TYPED_ARRAY)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            let file = ''
            if ((type_file == 'jpeg') || (type_file == 'jpg') || (type_file == 'png')) {
              file = 'data:image/' + type_file + ';base64, ' + base64
            }
            let result = {
              type: type_file,
              value: file
            }
            resolve(result)
          };
        }
      }
      xhr.send(JSON.stringify(body))
    })

  }
  onDownLoadImage(data) {
    return new Promise(async (resolve) => {
      let body = {
        type: "download",
        id: data.id,
        api_url: this.parametros.servidor + '/v1/media/' + data.id,
        app_id: this.parametros.instancia,
        app_phone: this.parametros.telefone,
        token: "Bearer " + this.parametros.token
      }
      let xhr = new XMLHttpRequest();
      xhr.responseType = "json"
      xhr.open("POST", 'https://hyperchannelbrasil.com.br/webhook/sendwaba.php', true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      let self = this;
      xhr.responseType = "arraybuffer";
      xhr.onreadystatechange = function (t) {
        if (xhr.readyState == 4) {
          xhr.onload = function (s) {
            const TYPED_ARRAY = new Uint8Array(this.response);
            var base64 = btoa(
              new Uint8Array(TYPED_ARRAY)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            resolve('data:image/jpg;base64, ' + base64)
          };
        }
      }
      xhr.send(JSON.stringify(body))
    })
  }

}
/*
https://developers.facebook.com/docs/graph-api

Atende AI
User Token
EAAIljDiKXJABABfHndZCaD4xDt8C0sJlvSBBZA1bJA7Pn4GbhiNrqBKLRua7nO4ZBNOBZCB9OOEnVO7tOQa6SmzymkZCZAmfhIc4Va60jVrRT0adzmIZBtsDaUUQAgFP4ZA5ZCVZCL3L16RHIA602oXRV92wqYSqh6C0IH96bu0GmJpsmniZCoQyXW6lsqhu0VssOMZD
Depuração
App Token
604234127662224|JpiArSkrXgSzMclib1wgfujLg0A

{
  "to": "5591980333070",
  "recipient_type": "individual",
  "messaging_product": "whatsapp",
  "to": "5591980333070",
  "type": "template",
  "template": {
     "name": "fale_conosco",
     "language": {"code": "pt_BR"},
       "components": [
    {
        "type": "body",
        "parameters": [
            {
                "type": "text",
                "text": "135345345"
            }
        ]
    }
  ]
 }
}
novo token :
EAAIljDiKXJABAMmcW1ifM3FJ3qZAqnVDmYxo31rMMzNUU3LaEYnPsjxgIL6rR4RHzJKDVDcQHDsAdn93cb0kANZBm3HogwYMBh0feT0ibls37hfErCQT6ddtHPYkJroQZCnjXIG0GH7hqdokeqEWzskmxIQPrKtEFVju8276Mo9SUqDiR1tShZBbWozXUyhGbvrZA4Y7ufAZDZD

Serviços de conect center e service desk através de uma plataforma omni channel.

Esse número está registrado em uma conta do WhatsApp. Para usá-lo, desconecte-o da conta, volte a esta página e insira o número novamente. Nota: o número pode levar até 3 minutos para ficar disponível


*/



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/providers/service/service.ts